import { OPEN_STATUS } from "@/enums/open-status-type";
import {
  FACILITY_STATUS,
  MAPS_INTEGRATION_STATUS
} from "@/enums/facility-status-type";
import { WEEK_DAYS } from "@/enums/week-days";
import {
  POST_TYPE,
  POSTS_FORM_TYPE,
  POSTS_CALL_TO_ACTION_TYPE,
  POST_BY_FACILITY_STATUS
} from "@/enums/posts.enum";
import { FACILITY_CREATE_ACTION } from "@/enums/gmb-search-type";
import { FACILITIES_SORTING_OPTION } from "@/enums/facilities-sorting-option";
import {
  PERIODIC_REPORT_TYPE,
  TOP_CHART_SERIE
} from "@/enums/charts-type.enum";
import { AccountType } from "@/enums/account-type";

import {
  EXTERNAL_CHANGES_SOURCE,
  EXTERNAL_CHANGES_TYPE,
  EXTERNAL_CHANGES_STATUS,
  EXTERNAL_CHANGES_FIELD
} from "@/enums/external-changes";
import { KEYWORDS_SCOPE } from "@/enums/keywords";
import { DIALOG_MANAGE_MODE } from "@/enums/reply-templates";
import { REVIEWS_TAGS_SEARCH_TYPE } from "@/enums/reviews.enum";
import { Module } from "@/enums/modules";
import { GMB_MEDIA_STATUS } from "@/enums/gmb-media-status";
import { GMB_MEDIA_TYPE } from "@/enums/gmb-media-type";

export default {
  subscriptionDetails: {
    yourPlan: "Tu plan",
    noPlan: "Sin plan",
    detailsLoadError: "No se pudieron cargar los datos de la suscripción. Actualiza la página o inténtalo de nuevo en unos momentos.",
    remainingSlots: "Plazas disponibles: {count}",
    editBilling: "Editar datos",
    usageLabel: "Número de ubicaciones utilizadas",
    projectedUsage: "Número de ubicaciones utilizadas después de importar",
    limitExceeded: "Se ha superado el límite de ubicaciones. Desconecta las ubicaciones sobrantes o contrata más.",
    importLimitExceeded: "Se ha superado el límite de ubicaciones. Selecciona menos ubicaciones para importar o contrata más en {settings}.",
    subscriptionSettings: "los ajustes de suscripción",
    openSubscriptionSettings: "Abrir ajustes de suscripción",
    goToSubscription: "Ir a Suscripción",
    increasePaid: "Amplía tu plan en los ajustes de suscripción",
    increaseTrial: "Elige un plan mayor",
    contactAdmin: "Contacta con el administrador de tu empresa para cambiar el plan.",
    morePaid: "¿Necesitas más ubicaciones? Abre el portal de Stripe desde Suscripción y aumenta el número de ubicaciones contratadas.",
    moreTrial: "Estás usando un plan de prueba. Para contratar más ubicaciones, accede a la selección de planes en Suscripción.",
    disconnectPaidHeading: "Desconectar ubicaciones no reduce la cuota de suscripción.",
    disconnectPaid: "Para cambiar la cuota, reduce el número de ubicaciones contratadas en Stripe.",
    disconnectConfirmTitle: "¿Desconectar {locations} de LocalZen?",
    disconnectConfirmFee: "La cuota de suscripción no cambiará.",
    disconnectConfirmSettings: "Para reducirla, cambia el número de ubicaciones contratadas en {settings}.",
    disconnectConfirmButton: "Desconectar {locations}",
    disconnectTrial: "Desconectar ubicaciones libera plazas en el plan de prueba sin cambiar su límite. Puedes elegir un plan de pago y el número de ubicaciones en Suscripción.",
    loadError: "No se pudo actualizar el uso del plan. Cierra este diálogo y vuelve a abrirlo.",
    importRejected: "Las ubicaciones seleccionadas superan el límite de tu plan. Actualiza la lista, selecciona menos ubicaciones o amplía tu plan en Suscripción.",
    manage: "Gestionar suscripción",
    paymentLoadError: "No se pudieron abrir los pagos de facturas. Inténtalo de nuevo en un momento.",
    active: "Activa",
    accessActive: "Acceso activo",
    accessExpired: "Acceso caducado",
    accessValidityLabel: "Acceso válido hasta",
    expired: "Caducada",
    trialUntil: "Fin del período de prueba: {date}",
    trialEndedOn: "El período de prueba terminó: {date}",
    expiredOn: "La suscripción caducó: {date}",
    renewsOn: "Próxima renovación: {date}",
    accessValidUntil: "Acceso a LocalZen válido hasta: {date}",
    accessExpiredOn: "El acceso a LocalZen caducó: {date}",
    nextRenewal: "Próxima renovación",
    nextPaymentOn: "Próximo pago: {date}",
    billingCycle: "Período de facturación",
    estimatedAmount: "Importe estimado",
    gross: "bruto",
    net: "neto",
    amountDue: "Importe a pagar después de aplicar el saldo",
    noUpcomingInvoice: "No hay ninguna renovación programada en Stripe.",
    billingPreviewUnavailable: "No se pudieron cargar los datos de la próxima facturación.",
    changeQuantity: "¿Cómo cambiar el número de ubicaciones contratadas?",
    manageDescription: "En el portal de Stripe puedes cambiar el número de ubicaciones contratadas y gestionar los pagos.",
    stepOpen: "Haz clic en «Gestionar suscripción» e inicia sesión en el portal de Stripe.",
    stepQuantity: "Selecciona tu suscripción de LocalZen, abre las opciones de actualización y establece el número de ubicaciones.",
    stepConfirm: "Revisa los cargos y confirma el cambio en Stripe.",
    refreshHint: "Después de guardar, vuelve a LocalZen y actualiza la página. El plan puede tardar un momento en actualizarse."
  },
  common: {
    millionAbbr: "M",
    thousandAbbr: "mil",
    saveChanges: "Guardar cambios",
    showMore: "Mostrar más",
    showLess: "Mostrar menos",
    setPasswordAndFinishRegistration:
      "Establecer contraseña y finalizar registro",
    page: "Página {0}",
    expand: "Expandir",
    readMore: "Leer más",
    areas: "Áreas",
    copyAddress: "Copiar dirección",
    areaFacility: "Area location",
    areaFacilityTooltip:
      "No puedes seleccionar esta ubicación porque es un negocio con área de servicio (SAB). Los resultados de búsqueda no se monitorean para este tipo de ubicaciones.",
    collapse: "Contraer",
    locations: "Ubicaciones",
    members: "Usuarios",
    keywords: "Palabras clave",
    tags: "Revisar categorías",
    competitors: "Ubicación del competidor",
    yourFacility: "Tu ubicación",
    competitorsFacility: "Ubicación del competidor",
    deleteSelected: "Eliminar seleccionado",
    learnMore: "Más información",
    name: "Nombre",
    stats: "Estadísticas",
    videoTutorialsTooltip: "Mira el video que explica esta funcionalidad.",
    faq: "Ayuda",
    selectImportColumns: "Seleccione las columnas que desea importar.",
    upload: "Subir",
    addFile: "Agregar archivo",
    desktop: "escritorio",
    exportToCSV: "Exportar a CSV",
    exportToXLSX: "Exportar a XLSX",
    exportCSV: "Exportar CSV",
    exportToFile: "Exportar a archivo",
    exportToCSVTooltip:
      "Los resultados de la exportación están limitados a 10 000 filas",
    mobile: "móvil",
    select: "Seleccionar",
    edited: "Editado",
    downloadStarted: "Descarga iniciada",
    groups: "Grupos",
    range: "Rango",
    selectAddress: "Seleccionar dirección",
    dontShowItAgain: "No mostrar de nuevo",
    changeName: "Cambiar nombre",
    show: "Mostrar {0}",
    bestPractices: "Mejores prácticas",
    dataProcessing: "Procesamiento de datos en curso",
    points: "pts",
    above: "Arriba",
    allReviews: "Todas las reseñas",
    reviewsWithoutCategory: "Reseñas sin categorías",
    accept: "Aceptar",
    accessibility: "Accesibilidad",
    accountData: "Datos de la cuenta",
    accountSettings: "Configuración de la cuenta",
    accountAdded: "Cuenta añadida",
    accountDeleted: "Cuenta eliminada",
    accountType: "Tipo de cuenta",
    actions: "Acciones",
    addDomain: "Agregar dominio",
    add: "Agregar",
    addAccount: "Agregar cuenta",
    addBusinessAddress: "Agregar ubicación",
    addFacility: "Agregar ubicación",
    addFbId: "Agregar ID de página",
    addManually: "Agregar manualmente",
    addMonitoredKeywords: "Agregar palabras clave para el monitoreo",
    addNew: "Agregar nuevo",
    addNewTerm: "Agregar palabra clave",
    addOwnBusinessAddress: "Agregar ubicación del negocio",
    addProfile: "Agregar perfil",
    addProfileName: "Agregar nombre de perfil",
    additionalCategories: "Categorías comerciales adicionales",
    administrativeArea: "Área administrativa",
    address: "Dirección",
    addUrlAddress: "Agregar URL",
    urlAddress: "Dirección URL",
    after: "Después",
    analytics: "Analítica",
    comparator: "Comparar fichas de Google Maps",
    appliance: "Dispositivo",
    apply: "Aplicar",
    all: "Todo",
    allFacilities: "Todas las ubicaciones del negocio",
    more: "Más",
    less: "Menos",
    added: "Añadido",
    assignAccount: "Asignar cuenta",
    avg_rate_on_main_page:
      "Calificación promedio en las reseñas más relevantes",
    accurate_number_of_photos: "Fotos",
    ascending: "Ascendente",
    automatically: "Automáticamente",
    back: "Atrás",
    backToList: "Volver a la lista",
    backToSignIn: "Volver a iniciar sesión",
    before: "Antes de",
    businessAddress: "Dirección de la empresa",
    businessAddresses: "Ubicaciones",
    businessAddressesGroups: "Grupos de ubicaciones",
    businessAddressesList: "Lista de ubicaciones",
    businessAddressesManage: "Gestión de ubicaciones",
    businessAddressOrWww: "Ubicación o sitio web",
    billingData: "Datos de facturación",
    by: "por",
    cancel: "Cancelar",
    cancelPost: "Anular publicación",
    categories: "Categorías",
    category: "Categoría",
    change: "Cambiar",
    changeAccountType: "Cambiar tipo de cuenta",
    changeSinceLastWeek: "Cambios desde la semana pasada",
    choose: "Elegir",
    chooseDate: "Elige franja horaria",
    chooseGmbAccount: "Elige una cuenta de Google",
    choosePeriod: "Elige el periodo",
    chooseProfile: "Elegir perfil",
    chosenBusinessAddress: "Ubicación elegida",
    city: "Ciudad",
    clear: "Claro",
    clients_activity_score: "Hoja de actividad del cliente",
    close: "Cerrar",
    closed: "Cerrado",
    collectData: "Recopilación de datos",
    companyName: "Nombre del negocio en el panel de LocalZen",
    legalCompanyName: "Nombre de la empresa",
    taxNumber: "Número de identificación fiscal (NIF)",
    companyProfile: "Configuración",
    compareWith: "Comparar con",
    competition: "Competidores",
    competitionVisibility: "Comparación con la competencia",
    competitiveBusinessAddresses: "Ubicaciones de competidores",
    competitiveWebsites: "Sitios web de la competencia",
    confirm: "Confirmar",
    confirmDelete: "Sí, eliminar",
    confirmCancel: "Sí, cancelar",
    confirmPassword: "Confirmar contraseña",
    consentsAndRegulations: "Consentimientos y Términos de Uso",
    dateAndTime: "Fecha y hora",
    contact: "Detalles de contacto",
    contactPhone: "Teléfono móvil",
    contactWithUs: "Contáctanos",
    content: "Contenido",
    continue: "Continuar",
    country: "País",
    popularCountries: "Países populares",
    cover_photo: "Foto de portada",
    createAccount: "Crear una cuenta",
    createBusinessAddress: "Crear ubicación",
    currentData: "Datos actuales",
    dashboard: "Panel de control",
    day: "Día",
    dateFrom: "Fecha de inicio",
    dateTo: "Fecha de finalización",
    dateRange: "Rango de fechas",
    delete: "Eliminar",
    deletePicked: "Eliminar seleccionado",
    descending: "Descendiendo",
    description: "Descripción",
    details: "Detalles",
    seeDetails: "Ver detalles",
    direction: "Dirección",
    doYouWantToSaveChanges: "¿Te gustaría guardar los cambios?",
    monday: "Lunes",
    tuesday: "Martes",
    wednesday: "Miércoles",
    thursday: "Jueves",
    friday: "Viernes",
    saturday: "Sábado",
    sunday: "Domingo",
    edit: "Editar",
    editFromFile: "Editar desde archivo",
    editData: "Editar datos",
    email: "Correo electrónico",
    emailAddress: "Dirección de correo electrónico",
    exportTo: "Exportar a:",
    exportTo2: "Exportar a",
    exportData: "Exportar datos",
    exportGroupedByDates: "agrupados por fechas",
    exportGroupedByLocations: "agrupados por ubicaciones",
    facility: "Ubicación",
    facilityData: "Datos de ubicación",
    facilityName: "nombre de la ubicación",
    fillYourCompanyData: "Complete los datos de su empresa",
    filter: "Filtrar",
    filters: "Filtros",
    find: "Buscar en",
    findCity: "Buscar ciudad",
    findPhrase: "Buscar frase",
    findFacility: "Buscar ubicación",
    finish: "Finalizar",
    followers: "Seguido por",
    following: "Siguiendo",
    forgotPassword: "Olvidé mi contraseña",
    from: "Desde",
    further: "Siguiente",
    importedBusinessAddresses: "Ubicaciones importadas",
    importFacilities: "Importar ubicaciones",
    import: "Importar",
    facilitiesCountIsOwnerTooltip:
      "Ubicaciones importadas desde el Administrador de Perfiles de Empresa de Google. Puedes editar estas ubicaciones.",
    facilitiesCountIsNotOwnerTooltip:
      "Ubicaciones añadidas desde fuera del Administrador de Perfiles de Empresa de Google. No puedes editar estas ubicaciones.",
    facilityOpenStatus: "Estado de apertura",
    importStatus: "Estado de importación",
    openStatusLabel: {
      all: "Todo",
      open: "Abrir",
      closedPermanently: "Cerrado permanentemente",
      closedTemporarily: "Cerrado temporalmente"
    },
    importStatusLabel: {
      any: "Cualquiera",
      imported: "Importado",
      notImported: "No importado"
    },
    facilitiesStatus: "Estado de ubicaciones",
    facilitiesStatusInGoogleMaps: "Estado de ubicaciones en Google Maps",
    facilitiesStatusInBingMaps: "Estado de ubicaciones en Bing Maps",
    facilitiesStatusInAppleMaps: "Estado de ubicaciones en Apple Maps",
    facilityIsOwnerTooltip:
      "Ubicación importada desde el Administrador de Perfiles de Empresa de Google. Puedes editar esta ubicación.",
    facilityIsNotOwnerTooltip:
      "Ubicación añadida desde fuera del Administrador de Perfiles de Empresa de Google. No puedes editar esta ubicación.",
    freeTrialInfo:
      "Prueba LocalZen gratis durante {0} días, sin necesidad de tarjeta de crédito. No se te cobrará nada a menos que elijas un plan al finalizar la prueba.",
    freeTrialTitle: "¡Vamos a configurarlo!",
    general: "Principal",
    generalData: "Datos generales",
    gmb_analytics: "Analítica",
    googleMaps: "Google Maps",
    facebook: "Facebook",
    googleMyBusiness: "Administrador de Perfiles de Empresa de Google",
    govTaxNumber: "Número de IVA",
    history: "Historia",
    importPicked: "Importar seleccionado",
    institution: "Ubicación",
    lack: "Nada",
    lastAudit: "Última auditoría",
    likes: "Likes",
    list: "Lista",
    loadingTime: "Tiempo de carga",
    location: "Localidad",
    login: "Iniciar sesión",
    logOut: "Cerrar sesión",
    manage: "Gestionar",
    maps: "Mapas",
    marketingConsents: "Permisos de marketing",
    mobileAdaptation: "Adaptación móvil",
    month: "Mes",
    moreInformations: "Más",
    moreThan: "Arriba",
    newLocality: "Nueva localidad",
    newLocation: "Nueva localidad",
    newPassword: "Nueva contraseña",
    newTerm: "Nueva palabra clave",
    newWebsite: "Nuevo sitio web",
    next: "Siguiente",
    loadingError: "No se pudieron cargar los datos",
    noData: "Sin datos",
    noDataDescription:
      "Estamos procesando datos en este momento. La información estará disponible aquí en unas horas.",
    noChanges: "Sin cambios",
    none: "Ninguno",
    noRatings: "Sin calificaciones",
    number_of_photos: "Número de fotos",
    number_of_posts: "Número de publicaciones",
    ofPages: "fuera de",
    ok: "OK",
    oldPassword: "Contraseña anterior",
    open: "Abrir",
    open_hours: "Horario de apertura",
    openCloseFacilities: "Apertura y cierre de ubicaciones",
    openCloseFacility: "Apertura y cierre de ubicaciones",
    openStreetMap: "Open Street Map",
    optional: "Opcional",
    or: "o",
    other: "Otro",
    overview: "Descripción general",
    password: "Contraseña",
    performance: "Rendimiento",
    perPage: "Elementos por página",
    phone_number: "Número de teléfono",
    photos: "Fotos",
    pickFacilities: "Elige ubicaciones",
    pickWebsite: "Elige sitio web",
    pointer: "Elemento",
    pointers: "Consejos",
    poland: "Polonia",
    position: "posición",
    positionsCount: "Posiciones: {0}",
    positionAbove: "Fuera del top {0}",
    postalCode: "Código postal",
    postcode: "Código postal",
    posts: "Publicaciones",
    postsAdd: "Agregar publicación",
    postsEdit: "Editar publicación",
    postsList: "Publicaciones",
    previewPhoto: "Vista previa de la foto",
    previous: "Anterior",
    primaryCategory: "Categoría principal de negocio",
    profile_photo: "Foto de perfil",
    profileDeleted: "Perfil eliminado",
    provideCode: "Ingrese el código",
    quarter: "Trimestre",
    rate: "Clasificación",
    rateCenter: "Calificación de LocalZen",
    refresh: "Actualizar",
    reject: "Rechazar",
    rememberMe: "Recuérdame",
    removeAccount: "Eliminar de LocalZen",
    removeFacility: "Eliminar ubicación",
    removeFacilities: "Eliminar ubicaciones",
    removeFilters: "Eliminar filtros",
    removeProfile: "Eliminar de LocalZen",
    repeatNewPassword: "Repite la nueva contraseña",
    report: "Informe",
    reportProblem: "Informar de un problema",
    resend: "Reenviar",
    resetPassword: "Restablecer la contraseña",
    reviewers: "Total de reseñas",
    reviews_rating: "Calificación promedio",
    reviews: "Calificación en Google Maps",
    save: "Guardar",
    saveData: "Guardar datos",
    savedDoneChanges: "Guardar cambios en",
    facilities: "ubicaciones",
    search: "Buscar",
    searchCompany: "Buscar empresa",
    searchEngines: "Motores de búsqueda",
    searchTerm: "Buscar palabra clave",
    searchTerms: "Palabras clave monitorizadas",
    security: "Seguridad",
    selectAll: "Seleccionar todo",
    selectAllFromPage: "Seleccionar todo en la página",
    selectedCount: "Seleccionado: {0}",
    sendEmail: "Enviar correo electrónico",
    seo: "Seo",
    settings: "Configuración",
    showHistory: "Mostrar historial",
    showFacility: "Mostrar detalles",
    signUp: "Registrarse",
    signUpTrial: "Pruébalo gratis",
    signUpTitle:
      "Impulsa tu visibilidad local y reputación empresarial. Gana clientes leales y haz crecer tu negocio.",
    signUpTrialTitle:
      "Regístrate hoy y disfruta de {0} días del plan Estándar – <b>sin necesidad de tarjeta de crédito</b>. ¡Descubre cómo LocalZen puede ayudarte a atraer más clientes locales!",
    skip: "Saltar",
    social: "Comunidad",
    socialMedia: "Redes sociales",
    sort: "Ordenar",
    sortBy: "Ordenar por",
    speed: "Velocidad",
    status: "Estado",
    date: "Fecha",
    hour: "Hora",
    statusOnGoogleMaps: "Estado de Google Maps",
    statusOnGMB: "Estado del Administrador de Perfiles de Empresa de Google",
    storeCode: "Código del local",
    street: "Calle",
    subscription: "Suscripción",
    suggested: "Sugerido",
    summary: "Resumen",
    tasksToDo: "Lista de tareas",
    termsOfService: "Política de Privacidad",
    trade: "Categoría del negocio",
    tryAgain: "Inténtalo de nuevo.",
    to: "a",
    urlAttribute: "atributo de URL",
    user_activity_score: "Tu actividad",
    userAccount: "Cuenta de usuario",
    userName: "Nombre de usuario",
    userProfile: "Perfil de usuario",
    voivodeship: "Región",
    website: "Sitio web",
    websites: "Sitios web",
    week: "Semana",
    www_analytics: "Analítica de sitios web",
    year: "Año",
    yourBusinessAddress: "Dirección de ubicación",
    yourBusinessAddresses: "Tus ubicaciones",
    yourCompany: "Tu empresa",
    yourPosition: "Tu posición",
    yourPositionOnGoogleMaps:
      "Tu posición en los resultados de búsqueda de Google Maps",
    yourSite: "Tu sitio",
    yourVisibility: "Tu visibilidad",
    yourWebsite: "Tu sitio web",
    yourWebsites: "Tus sitios web",
    csv: "CSV",
    xls: "XLS",
    xlsx: "XLSX",
    yes: "Sí",
    no: "No",
    see: "Ver más",
    copiedToClipboard: "Copiado al portapapeles",
    filterByDateOf: "Filtrar por fecha de",
    reviewLastEdit: "Última edición",
    reviewCreation: "Creación",
    reviewLastEditOrCreation: "Última edición o creación",
    validation: {
      urlWithProtocol: "La URL debe comenzar con http:// o https://",
      requiredField: "Este campo es obligatorio",
      maxLength: "La longitud máxima es de {0} caracteres",
      minLength: "La longitud mínima es de {0} caracteres",
      minWords: "El número mínimo de palabras es {0}",
      latitudeRange: "La latitud debe estar entre -90 y 90",
      longitudeRange: "La longitud debe estar entre -180 y 180",
      bothCoordinatesRequired:
        "Ambas coordenadas (latitud y longitud) deben estar completadas",
      incompleteNumber: "Número inválido - completa el valor decimal"
    },
    timezone: "Zona horaria"
  },
  pluralForms: {
    facility: ["ubicación", "ubicaciones", "ubicaciones"],
    facilityAccusative: ["ubicación", "ubicaciones", "ubicaciones"],
    facilityGenitive: ["ubicación", "ubicaciones", "ubicaciones"],
    facilityLocative: ["ubicación", "ubicaciones", "ubicaciones"],
    city: ["ciudad", "ciudades", "ciudades"],
    group: ["grupo", "grupos", "grupos"],
    groupGenitive: ["grupo", "grupos", "grupos"],
    review: ["reseña", "reseñas", "reseñas"],
    position: ["posición", "posiciones", "posiciones"],
    click: ["clic", "clics", "clics"],
    view: ["ver", "vistas", "vistas"],
    changeAccusative: ["cambio", "cambios", "cambios"],
    listing: ["ficha", "fichas", "fichas"]
  },
  serviceUnavailable: {
    title: "Mantenimiento del sistema",
    description:
      "Lo sentimos, el panel web y la API de LocalZen no están actualmente disponibles debido a trabajos de mantenimiento programados. El sistema volverá a estar disponible pronto.",
    footer: "Gracias por tu comprensión,",
    signature: "Equipo de <span style='color: #01496E'>LocalZen</span>",
    backToMainPage: "Volver a la página principal"
  },
  service: {
    accountSuspended: `Lamentamos informarte de que tu cuenta de <a href="https://localzen.com/" target="_blank">LocalZen</a> ha sido suspendida temporalmente debido a un pago pendiente. Para restablecer la funcionalidad completa de tu cuenta y continuar utilizando nuestro servicio, te pedimos que regularices el saldo adeudado. Si tienes alguna pregunta o consulta, por favor comunícate con nuestro Equipo de Atención al Cliente a través de <a href="mailto:support@localzen.com">support@localzen.com</a>.`,
    subscriptionPlanExpired:
      "Tu plan de suscripción ha expirado. Para renovar tu suscripción, por favor, dirígete al panel de configuración.",
    wrongSubscriptionPlan:
      "Tu plan de suscripción no permite realizar esta acción.",
    subscriptionLimit:
      "Has superado el número de ubicaciones permitidas. Tu plan de suscripción solo permite X ubicaciones. Contáctanos si deseas aumentar tu cuota de ubicaciones."
  },
  dashboard: {
    clientScoreHistory: "Tu cronología de reseñas de Google Maps",
    lastMonth: "desde el mes pasado",
    googleMaps: "Visibilidad en Google Maps",
    googleMyBusiness: "Calidad de ubicaciones en Google Maps",
    fromLastWeek: "desde la semana pasada",
    fromLastMonth: "desde el mes pasado",
    fromLast30Days: "en los últimos 30 días",
    selectAll: "Seleccionar todo",
    noDataFromLastMonth: "No hay datos del mes pasado",
    competitionBusiness: "Competidores",
    visibility: "Visibilidad",
    quality: "Calidad",
    checkbox: {
      overallRate: "Calificación general",
      googleOrganic: "Visibilidad en los resultados de búsqueda de Google",
      googleMaps: "Visibilidad en Google Maps",
      googleMyBusiness: "Calidad de las ubicaciones de Google Maps",
      websites: "Calidad del sitio web",
      socialMedia: "Calidad de los perfiles de redes sociales",
      otherMaps: "Visibilidad de otros mapas"
    },
    title: "¡Bienvenido de nuevo!",
    daysRange: "Últimos {0} días",
    widgetTitle: {
      averageRating: "Calificación promedio",
      ratingCount: "Número de reseñas",
      repliesPercentage: "% de reseñas respondidas",
      ratingDistribution: "Distribución de calificaciones",
      bestGmbAddresses: "Ubicaciones mejor valoradas",
      worstGmbAddresses: "Ubicaciones peor valoradas",
      lowestQualityGmbAddresses: "Ubicaciones con peor calidad en Google Maps",
      postsCount: "Publicaciones añadidas",
      viewsCount: "Vistas de ubicaciones",
      queriesCount: "Búsquedas de ubicaciones",
      queries: "Tipos de consultas de búsqueda",
      actionsDrivingDirections: `Acciones de "Solicitar direcciones"`,
      actionsWebsite: `Acciones de "Visitar sitio web"`,
      actionsPhone: `Acciones de "Llamada telefónica"`
    },
    widgetTooltip: {
      comparedToLast30Days: "En comparación con los 30 días anteriores",
      averageRating: "Calificación promedio",
      ratingCount: "Número de valoraciones",
      repliesPercentage: "% opiniones respondidas",
      ratingDistribution: "Distribución de calificaciones",
      bestGmbAddresses: "Ubicaciones mejor valoradas",
      worstGmbAddresses: "Ubicaciones peor valoradas",
      lowestQualityGmbAddresses: "Ubicaciones con peor calidad en Google Maps",
      postsCount: "Publicaciones añadidas",
      viewsCount: "Vistas de ubicaciones",
      queriesCount: "Búsquedas de ubicaciones",
      queries: "Tipos de consultas",
      actionsDrivingDirections: `Acciones de "Solicitar direcciones"`,
      actionsWebsite: `Acciones de "Visitar sitio web"`,
      actionsPhone: `Acciones de "Llamadas telefónicas"`
    },
    ratingDistributionSerie: `Calificación "{0}"`,
    addressScore: "Calidad {0}/100",
    queriesSerie: {
      direct: "Búsquedas directas",
      indirect: "Búsquedas de descubrimiento",
      chain: "Búsquedas de marcas"
    }
  },
  tooltip: { indicator: "Haz clic para más detalles" },
  session: {
    accountTypeSelection: {
      employee: "Empleado",
      company: "Empresa",
      ifHaveAnAccount: "o si tienes una cuenta",
      signUpAs: "Regístrate como",
      companyOwnerText: `Soy administrador o propietario de una empresa. Quiero crear una cuenta para mi organización.`,
      employeeText: `Ya usamos LocalZen en la empresa. Quiero acceder a la aplicación.`
    },
    employeePage: {
      title: "Registro de empleados",
      description1: `Si tu empresa ya utiliza LocalZen, deberías recibir una invitación en tu dirección de correo electrónico.`,
      description2: `Si no has recibido una invitación, pídele a tu administrador que te envíe la invitación.`,
      ifHaveAnAccount: "... o si ya tienes una cuenta"
    },
    dontHaveAccount: "¿Todavía no tienes una cuenta?",
    haveAccount: "¿Ya tienes una cuenta en LocalZen?",
    loginWithFacebook: "Iniciar sesión con Facebook",
    loginWithGoogle: "Iniciar sesión con Google",
    signUpWithFacebook: "Regístrate con Facebook",
    signUpWithGoogle: "Regístrate con Google",
    continueWithSSO: "Continuar con SSO",
    teamName: "Nombre del equipo",
    ssoLogin: {
      description: "Introduce el nombre del equipo para continuar con SSO",
      wantToUseEmailAndPassword:
        "¿Quieres usar correo electrónico y contraseña?",
      clickHere: "Haz clic aquí",
      ssoLoginErrorTitle: "Error de login",
      backToLogin: "Volver al inicio de sesión",
      alertText:
        'No encontramos el equipo <b>"{0}"</b>. Verifica el nombre, usa el inicio de sesión con correo/contraseña o contacta a tu administrador.',
      errors: {
        saml_auth_failed: "Falló la autenticación SAML",
        saml_replay_attack: "Ataque de repetición detectado",
        saml_no_email: "No se encontró correo electrónico en la respuesta SAML",
        saml_user_not_found:
          "El usuario con el correo electrónico dado no existe y la creación automática está deshabilitada",
        saml_processing_error: "Error al procesar la respuesta SAML",
        saml_group_sync_error: "Error al sincronizar permisos de grupo",
        saml_multiple_groups:
          "El IdP devolvió múltiples grupos, pero solo se permite uno",
        default: "Ocurrió un error desconocido durante la autenticación"
      }
    },

    errorSsoLogin: {
      title: "Error de autenticación",
      message:
        "Hubo un problema al intentar iniciar sesión. Inténtalo de nuevo o contacta a tu administrador si el problema persiste.",
      backToLogin: "Volver al inicio de sesión"
    },

    login: {
      description:
        "Introduce tu correo electrónico y contraseña para iniciar sesión en el panel.",
      captchaError: "No se pudo iniciar la verificación de reCAPTCHA. Actualiza la página e inténtalo de nuevo."
    },
    forgot: {
      description:
        "Por favor, introduce tu correo electrónico para recibir un enlace para restablecer la contraseña."
    },
    reset: { description: "Confirmar contraseña" },
    register: {
      privacyPolicy: "Política de Privacidad",
      regulations: "Términos de Uso",
      bySigningUpYouAgreeTo:
        "Al registrarte, confirmas que has leído y aceptado la {privacyPolicy} y los {regulations}.",
      consent_3:
        "Quiero recibir boletines informativos y correos electrónicos de marketing (puedes cambiar esto en cualquier momento)."
    },
    agreement: {
      newsletterAndMarketing:
        "Me gustaría suscribirme al boletín y al marketing por correo electrónico (puede revocar tu consentimiento en cualquier momento)."
    }
  },
  notification: {
    timezoneUpdatedSuccessfully:
      "La zona horaria se ha actualizado correctamente",
    timezoneUpdateFailed: "La zona horaria no se ha actualizado",
    userLoggedInSuccess: "¡Inicio de sesión del usuario exitoso!",
    activationCodeWasAdded: "El código de activación ha sido añadido.",
    changesSaved: "Cambios guardados con éxito",
    activationCodeWasNotAdded:
      "Este código de activación no se puede usar. Ya no es válido o pertenece a un plan de suscripción más limitado.",
    noCompetitionAdded:
      "No se añadieron ni seleccionaron competidores para la comparación"
  },
  visibility: {
    summary: {
      businessAddressesTitle: "Visibilidad en Google Maps",
      websitesTitle: "Visibilidad en los resultados de búsqueda de Google",
      noBusinessAddressesInfo:
        "Al agregar la dirección comercial de una ubicación concreta, puedes ver el mapa que muestra la clasificación de tu empresa en las búsquedas de Google.",
      noKeywordsInfo:
        "Para cada palabra clave que añadas, LocalZen supervisará la posición de tus fichas en las búsquedas de Google Maps. Para añadir palabras clave, primero debes incorporar tus fichas a LocalZen.",
      noWebsiteAddress: "No hay dirección de sitio web",
      noWebsiteAddressInfo:
        "Al agregar la dirección de tu sitio web, podrás conocer tu clasificación actual.",
      dataCollectionPendingForKeyword:
        "Estamos preparando los datos para esta palabra clave.",
      dataCollectionForKeywordTryAgainLater:
        "¡Los radares de LocalZen ya están activos! Estamos recopilando datos en este momento.",
      addKeywords: "Agregar palabras clave de búsqueda.",
      map: {
        info:
          "Este mapa muestra la posición de tu <b>ubicación</b> en Google Maps basada en la palabra clave específica y la ubicación del usuario. Los colores representan la fuerza de tu ficha en una zona determinada. Por ejemplo, el color verde indica la mejor posición (la más cercana al no. 1), el rojo representa la peor posición dentro del top 20 (la más cercana al no. 20), y el gris indica que está fuera del top 20.",
        subtitle: "La posición de tu ubicación en Google Maps",
        legend: {
          high: "Alto",
          medium: "Medio",
          low: "Bajo",
          info:
            "La posición de tu ubicación en los resultados de búsqueda de Google Maps según la palabra clave elegida:",
          nodata: "Sin datos disponibles"
        }
      },
      chart: {
        title: "Posición promedio de la ubicación en su zona.",
        description:
          "El gráfico a continuación muestra la posición promedio de tu ubicación en un área determinada."
      },
      websites: {
        label: {
          yourWebsiteAddress: "Tu sitio web",
          localization: "Ubicación",
          competitionWebsiteAddress: "Sitio web de la competencia"
        },
        chart: {
          yAxisLabel: "Posición en los resultados de búsqueda de Google"
        },
        subtitle:
          "La posición de tu sitio web en los motores de búsqueda de Google en respuesta a una palabra clave determinada"
      }
    },
    GMBSummary: {
      history: {
        select: {
          centerRate: "Calificación de LocalZen",
          googleMapsRate: "Calificación de Google Maps",
          googleMapsRatingQty: "Número de calificaciones en Google Maps",
          profileCompletness: "Grado de completitud del perfil"
        }
      },
      rate:
        "Calificación de LocalZen (0-100) - Evaluación general del perfil de Google Maps de tu ubicación. Esta calificación se basa en el nivel de completitud del perfil, las valoraciones de los clientes y la actividad de los clientes (nuevas valoraciones y reseñas).",
      avgRateInfo:
        "Las reseñas más relevantes son aquellas que Google destaca y muestra en la página principal de tu ficha en Google Maps. Estas son las reseñas que tus clientes ven primero."
    },
    mapsVisibility: {
      title: "Tus ubicaciones en otros mapas",
      tooltip: {
        bing:
          "Microsoft Bing Maps. Uno de los servicios de mapas en línea más populares.",
        openStreetMap:
          "Estos mapas son parte de un proyecto comunitario, por lo que se pueden usar gratuitamente y las ubicaciones se pueden editar libremente. Esto los hace extremadamente populares y ampliamente utilizados con fines comerciales. Por ejemplo, Yanosik y JakDojadę se encuentran entre sus usuarios en Polonia.",
        targeo:
          "Estos mapas polacos están entre los más precisos del mercado. Automapa, un popular servicio de GPS, los utiliza.",
        yanosik:
          "Este es un servicio comunitario de alertas de tráfico gestionado por y para conductores. Ayuda a más de 1,5 millones de personas al volante cada mes en Polonia.",
        jakDojade:
          "Este es el planificador de viajes de transporte público favorito en Polonia, utilizado por 3,5 millones de pasajeros cada mes. Opera en más de 45 ciudades polacas. En particular, los estudiantes y los jóvenes adultos parecen ser quienes más lo prefieren.",
        automapa:
          "Es uno de los servicios de GPS más populares de Polonia. Utilizado y valorado por muchos conductores."
      }
    }
  },
  competition: {
    header: "Sitios web de la competencia",
    businessAddresses: {
      title: "Las fichas de la competencia",
      noSuggested: "No hay sugerencias de ubicaciones de la competencia",
      suggestedTooltip:
        "Ubicaciones que aparecen en los resultados de búsqueda para tus palabras clave",
      label: {
        yourBusinessAddress: "Dirección de ubicación",
        addCompetitionBusinessAddress: "Agregar la ubicación del competidor"
      },
      noCompetitorWithinRadius:
        "No se encontró ningún competidor dentro del radio seleccionado.",
      noData:
        "Para agregar una empresa competidora, escribe su nombre o ciudad, o elige entre las fichas de competidores sugeridas a continuación."
    },
    visibility: {
      businessAddresses: {
        chartTitle:
          "Posición promedio de tu ubicación y la de los competidores en los alrededores",
        chartDescription:
          "El gráfico a continuación muestra la posición promedio de tu ubicación en comparación con la de los competidores seleccionados.",
        cardTitle:
          "Descubre quién aparece en los primeros resultados de búsqueda en tu zona.",
        cardDescription:
          "Elige tu ubicación y selecciona hasta 5 ubicaciones de tus competidores.",
        cardInfo:
          "Los colores en el mapa representan las ubicaciones de los negocios e indican cuál ocupa el primer lugar en los resultados de búsqueda de Google Maps (entre las ubicaciones seleccionadas) para la palabra clave elegida, según la localización del cliente. Por ejemplo, el color naranja muestra las zonas donde alguien que busca un producto o servicio específico ve tu ubicación en el primer puesto.",
        inputLegend: "La ubicación de tu negocio en el mapa",
        listTitle: "Ubicaciones de los competidores",
        listNoData: "No hay ubicaciones de competidores registradas",
        searchingData:
          "Estamos procesando tu consulta para la palabra clave seleccionada.",
        addNewTerm:
          "Añadir palabras clave. Las palabras clave más populares aparecerán aquí."
      },
      title: "Visibilidad de la competencia en Google y Google Maps",
      keywordsTitle: "Palabras clave rastreadas",
      nodata: {
        title: "No se ha proporcionado la dirección del sitio web",
        content:
          "Al añadir la dirección de tu sitio web, podrás conocer la posición actual de tus competidores."
      }
    }
  },
  analytics: {
    wellDone: "Bien hecho",
    needFix: "Necesita mejoras",
    scale: {
      great: "Excelente",
      good: "Bueno",
      medium: "Aceptable",
      weak: "Deficiente"
    },
    businessAddresses: {
      dataCollectInfoText:
        "A partir de enero de 2024, el número de solicitudes de direcciones podría disminuir. Esto se debe a un cambio en la forma en que Google cuenta estos datos.",
      incompleteMonthlyPeriodInfo:
        "El rango de fechas seleccionado no cubre por completo los períodos en los que se agrupan los datos. Para el último, que está incompleto, se muestra el valor final previsto junto con los datos reales.",
      here: "aquí",
      archiveAlert1: "Para ver la versión anterior de esta página, haz clic",
      archiveAlert2: `La versión anterior muestra información sobre el número de búsquedas para tus ubicaciones. Sin embargo, debido a cambios en Google, todos los datos disponibles en esa versión se actualizarán únicamente hasta el <span class="text-primary">28 de febrero de 2023</span>.`,
      postStatAlert2: `Las estadísticas de las publicaciones estarán disponibles únicamente hasta el <span class="text-primary">28 de febrero de 2023</span> (debido a los cambios introducidos por Google).`,
      noData:
        "Aquí puedes ver con qué frecuencia los usuarios vieron tus ubicaciones en Google Maps y Google Search y qué acciones tomaron. Esta función te permitirá obtener información valiosa sobre el comportamiento de los usuarios.",
      title: "Acciones de los usuarios en Google Maps",
      titleTooltip:
        "Aquí puedes ver con qué frecuencia los usuarios vieron tus ubicaciones en Google Maps y Google Search y qué acciones tomaron. Esta función te permitirá obtener información valiosa sobre el comportamiento de los usuarios.",
      subtitle: {
        search: "Búsquedas del perfil",
        actions: "Acciones del cliente después de ver tus ubicaciones",
        displays: "Visualizaciones de ubicaciones"
      },
      noCompare: "No compares",
      compareWithPreviousPeriod: "Periodo anterior",
      compareWithPreviousYear: "Año anterior",
      showConversionRate: "Mostrar tasa de conversión",
      chart: {
        estimated: "estimación",
        estimatedLegend: "Pronóstico (basado en datos históricos)",
        estimatedData: "Datos pronosticados",
        total: "Total",
        incompletePeriod: "período incompleto",
        legend: {
          actual: "Número de acciones",
          incomplete: "Número de acciones (período incompleto)",
          forecast: "Pronóstico de acciones para el final del período",
          conversionActual: "Tasa de conversión",
          conversionIncomplete: "Tasa de conversión (período incompleto)",
          conversionForecast: "Pronóstico de la tasa para el final del período"
        },
        directDiscoveryBranded: {
          title: {
            text: "Tipo de búsqueda",
            tooltip:
              "Existen múltiples formas en que los clientes pueden llegar a tu perfil comercial. Por ejemplo, pueden buscar directamente tu marca o escribir una categoría más general en la barra de búsqueda."
          },
          label: {
            text: {
              direct: "Búsquedas directas",
              indirect: "Búsquedas de descubrimiento",
              branded: "Búsquedas de marcas"
            },
            tooltip: {
              direct:
                "Clientes que encontraron tu ficha buscando el nombre de tu marca.",
              indirect:
                "Clientes que encontraron tu ficha al buscar una categoría, producto o servicio.",
              branded:
                "Clientes que encontraron tu ficha buscando marcas asociadas a tu negocio."
            }
          }
        },
        searches: {
          title: {
            text: "Total de búsquedas",
            tooltip:
              "Número total de todos los tipos de búsqueda durante el período seleccionado."
          }
        },
        searchMaps: {
          title: {
            text: "Google Search vs Google Maps",
            tooltip:
              "Tu ubicación es visible en la Búsqueda de Google y en Google Maps. Aquí puedes dónde se visualiza con mayor frecuencia."
          },
          label: {
            search: "Visualizaciones en búsquedas de Google",
            maps: "Visualizaciones en Google Maps"
          }
        },
        maps: {
          title: {
            text: "Visualizaciones",
            tooltip:
              "Número total de visualizaciones de las ubicaciones seleccionadas en búsquedas de Google y Google Maps."
          }
        },
        clicks: {
          title: {
            text: "Visitas al sitio web",
            tooltip:
              "Número total de visitas a tu sitio web provenientes de tus ubicaciones en Google Maps."
          }
        },
        directions: {
          title: {
            text: "Solicitudes de cómo llegar",
            tooltip:
              "Número total de solicitudes de cómo llegar a tus ubicaciones de Google Maps."
          }
        },
        calls: {
          title: {
            text: "Llamadas telefónicas realizadas a tu negocio",
            tooltip:
              "Número total de llamadas telefónicas realizadas a través de tus ubicaciones de Google Maps."
          }
        },
        clicksConversion: {
          title: {
            text: "Visitas al sitio web",
            tooltip:
              "Número total de visitas a tu sitio web desde tus ubicaciones en Google Maps."
          }
        },
        directionsConversion: {
          title: {
            text: "Solicitudes de cómo llegar",
            tooltip:
              "Número total de solicitudes de cómo llegar a tus ubicaciones en Google Maps."
          }
        },
        callsConversion: {
          title: {
            text: "Llamadas telefónicas realizadas a su negocio",
            tooltip:
              "Número total de llamadas telefónicas realizadas a través de tus ubicaciones de Google Maps."
          }
        },
        common: {
          totalViews: "Visualizaciones",
          conversion: "Tasa de conversión"
        }
      }
    },
    websites: {
      noWebsitesAdded: "No se ingresó ningún sitio web.",
      addWebsite: "Agregar sitio web",
      noAuditYetTryAgainLater:
        "La auditoría de este sitio web aún no está lista. Por favor, inténtalo de nuevo más tarde."
    },
    periodic: {
      title: "Posición en los resultados de búsqueda de Google Maps",
      tooltip: {
        [PERIODIC_REPORT_TYPE.TOP]:
          "Aquí puedes ver con qué frecuencia tus ubicaciones son visibles en las posiciones 1-3, 4-10 y 11-20 de los resultados de búsqueda para las palabras clave seleccionadas.",
        [PERIODIC_REPORT_TYPE.AVERAGE]:
          "Aquí puedes ver la posición promedio de tu ubicación en los resultados de búsqueda para las palabras clave seleccionadas durante un período de tiempo específico."
      },
      allSelected: "(todo)",
      keywords: {
        label: "Palabras clave",
        noKeywords: "No se han elegido palabras clave",
        dialog: {
          [PERIODIC_REPORT_TYPE.TOP]: { title: "Elige palabras clave" },
          [PERIODIC_REPORT_TYPE.AVERAGE]: {
            title: "Elige una palabra clave",
            infoBox:
              "Solo puedes elegir una palabra clave para el gráfico de <b>Posición promedio</b>"
          },
          filterInputPlaceholder: "¿Qué palabra clave estás buscando?"
        }
      },
      types: {
        [PERIODIC_REPORT_TYPE.TOP]: "Mejores posiciones",
        [PERIODIC_REPORT_TYPE.AVERAGE]: "Posición promedio"
      },
      chart: {
        tabTitle: "Gráfico",
        yAxisLabel: {
          [PERIODIC_REPORT_TYPE.TOP]: "Número de ubicaciones",
          [PERIODIC_REPORT_TYPE.AVERAGE]:
            "Posición promedio en los resultados de búsqueda de Google Maps"
        },
        noKeywordsDescription:
          "Elige palabras clave y te mostraremos los gráficos correspondientes."
      },
      table: {
        tabTitle: "Mesa",
        noKeywordsDescription:
          "Elige palabras clave y te mostraremos los datos en una tabla.",
        groupFacilities: "Agrupar ubicaciones",
        gmbAddress: "Ubicación",
        group: "Grupo",
        summary: "Resumen",
        summarySecondaryText: "de todos los lugares elegidos"
      }
    },
    comparator: {
      title: "Comparar fichas de Google Maps",
      showDifference: "Mostrar diferencias",
      addDescription:
        "Aquí puedes comparar dos conjuntos de fichas de Google Maps. Para ver la comparación, selecciona las fichas que deseas comparar en los conjuntos (en los conjuntos A y B).",
      groupA: "Fichas de Google Maps (conjunto A)",
      groupB: "Fichas de Google Maps (conjunto B)",
      addFacilities: "Seleccionar fichas",
      reviewsOverall: "Reseñas - todas",
      reviewsLastMonth: "Reseñas - últimos 30 días",
      averageRating: "Calificación promedio de reseñas",
      mostAccurateAverageRating:
        "Calificación promedio para las reseñas más relevantes",
      reviewsCount: "Calificaciones en total",
      reviewsRatings: "Distribución de calificaciones",
      reviewsAswersPercentage: "% de reseñas respondidas",
      postsOverall: "Publicaciones - todas",
      postsLastMonth: "Publicaciones - últimos 30 días",
      posts: "Publicaciones en total",
      postsDistribution: "Distribución de tipos de publicaciones",
      postType: {
        [POST_TYPE.STANDARD]: "Estándar",
        [POST_TYPE.EVENT]: "Evento",
        [POST_TYPE.OFFER]: "Oferta",
        [POST_TYPE.ALERT]: "Alerta"
      }
    }
  },
  companyProfile: {
    tab: { termsInBrowsers: "Palabras clave rastreadas" },
    settings: {
      subscriptionInfo:
        "Para cambiar tu plan de suscripción, ingresa el código de activación.",
      subscriptionType: `Estás usando el plan de suscripción "{variable}", válido hasta {variable2}.`,
      subscriptionName: "Plan: {name}",
      subscriptionExpiration: "Próxima fecha de renovación: {date}",
      subscriptionExpired: "Su plan de suscripción ha caducado",
      manageSubscription: "Gestionar plan",
      pay: "Pagar facturas pendientes",
      legacyPay: "Liquidar Facturas",
      expired:
        "Tu plan de suscripción ha caducado. Para renovar tu suscripción, por favor contáctanos por chat o a través del correo electrónico en support@localzen.com."
    },
    noData: {
      title:
        "No tienes Perfiles de Negocio (Administrador de Perfiles de Empresa de Google) asociados con LocalZen.",
      description:
        "Añade un Perfil de Empresa para aprovechar al máximo las funcionalidades que ofrece LocalZen. Al vincular tu cuenta de Google con LocalZen, podrás editar tus fichas de forma masiva, publicar tus contenidos en bloque y monitorear la posición de tus fichas en los resultados de búsqueda de Google Maps según las frases de búsqueda utilizadas."
    },
    listings: {
      title: "Cuentas de Google",
      subtitle: {
        mainSection: "Cuentas conectadas",
        asideSection: "Aplicar cambios a"
      },
      aside: {
        title: "Aplicar cambios a",
        description:
          "Por favor, selecciona los mapas que deseas actualizar en relación con las ubicaciones de tu negocio. Solo se actualizarán aquellas en las que figures como propietario, es decir, las que hayas importado desde tu cuenta de Google."
      },
      description: {
        mainSection:
          "Para aprovechar todas las funciones de LocalZen, asegúrate de vincular tu cuenta de Google a nuestro conjunto de herramientas e importar tus ubicaciones. Todas las cuentas que ya hayas vinculado con LocalZen aparecerán aquí.",
        asideSection:
          "Por favor, selecciona los mapas que deseas actualizar en relación con las ubicaciones de tu negocio. Solo se actualizarán aquellas en las que figures como propietario, es decir, las que hayas importado desde tu cuenta de Google."
      },
      refreshInfo:
        "¿No puedes ver tu ubicación en la lista? Los datos se actualizan cada 10 minutos. Por favor, inténtalo de nuevo en unos instantes.",
      importSummary: {
        locationsImport: "Importar ubicaciones",
        lastImport: "Última importación:",
        importedLocations: "Ubicaciones importadas:",
        importedStatistics: "Importado {current_count} de {total_count}",
        importInProgress: "Importación de datos en curso.",
        lastCheckedAt: "Última verificación a las {time}",
        downloadReport: "Descargar informe XLSX",
        dialogMessages: {
          importing:
            "Ubicaciones seleccionadas para importar: {importing_count}",
          successfullyImported: "Ubicaciones importadas: {success_count}",
          error:
            "Algunas ubicaciones seleccionadas ({error_count}) no se pudieron importar. Los motivos detallados están disponibles en el informe XLSX.",
          alreadyImported:
            "Algunas de las ubicaciones ({already_imported_count}) ya han sido importadas a LocalZen desde otra cuenta de Google, por lo que no es necesario importarlas de nuevo.",
          unverified: "Ubicaciones no verificadas que se omitieron:"
        }
      },
      actionsDisabledDuringImport:
        "Durante la importación de datos, esta pantalla permanecerá inactiva. El resto de las funcionalidades seguirá funcionando con normalidad.",
      deleteBusinessAddressesListDialog: {
        title: "Seleccione las ubicaciones que te gustaría eliminar de LocalZen"
      },
      businessAddressesListDialog: {
        noData: "No hay ubicaciones asociadas a esta cuenta",
        title: "Selecciona las ubicaciones que te gustaría importar",
        statuses: {
          is_disabled: "Deshabilitado",
          is_disconnected: "Desconectado",
          is_duplicate: "Duplicar",
          is_pending_review: "Revisión en progreso",
          is_permanently_closed: "Cerrado",
          is_published: "Publicado",
          is_suspended: "Suspendido",
          is_verified: "Verificado",
          needs_reverification: "Se requiere una nueva verificación"
        }
      },
      confirmationDialog: {
        textImport:
          "Las ubicaciones se importaron correctamente y deberían aparecer en la lista de ubicaciones.",
        textImportPending: "Importando listados ahora.",
        textImportPendingDescription:
          "Mientras tanto, te sugerimos que eches un vistazo a <a href='https://localzen.com/blog/' target='_blank'>nuestro blog</a>. Los artículos de nuestro blog te ayudarán a comprender mejor el valor comercial que ofrece LocalZen y te ofrecerán recomendaciones para sacarle el máximo provecho.",
        importInProgressTitle: "Importación de datos en curso ⏳",
        importInProgressText:
          "Estamos añadiendo tus listados y obteniendo automáticamente datos: reseñas, visualizaciones y actividad de los usuarios en Google Maps. Normalmente, los datos están disponibles en unos minutos.",
        importedStatistics: "Importado {current_count} de {total_count}",
        textDelete: "La ubicación seleccionada ha sido eliminada de LocalZen.",
        textProfileDelete:
          "El perfil seleccionado y todas las ubicaciones asociadas han sido eliminadas de LocalZen.",
        textAccountDelete:
          "Tu cuenta y todos los perfiles asociados han sido eliminados de LocalZen.",
        importErrorTitle: "Se produjo un error al agregar una nueva cuenta.",
        deleteErrorTitle:
          "Se produjo un error al eliminar la cuenta de LocalZen.",
        deleteProfileErrorTitle:
          "Se produjo un error al eliminar el perfil de LocalZen.",
        deleteAccountErrorTitle:
          "Se produjo un error al eliminar la cuenta de Google de LocalZen",
        deleteAccountConfirm:
          "¿Estás seguro/a de que quieres eliminar la cuenta de Google de LocalZen?",
        deleteProfileConfirm:
          "¿Está seguro/a de que quieres eliminar el perfil de LocalZen?",
        deleteFacilityConfirm:
          "¿Está seguro/a de que quieres eliminar la ubicación de LocalZen?",
        importErrorText:
          "Vaya, algo salió mal... No se pudieron importar tus ubicaciones. Por favor, inténtalo de nuevo.",
        deleteErrorText:
          "Vaya, algo salió mal... No se pudieron eliminar las ubicaciones seleccionadas. Por favor, inténtalo de nuevo.",
        deleteProfileErrorText:
          "Vaya, algo salió mal... No se pudo eliminar el perfil. Por favor, inténtalo de nuevo.",
        deleteAccountErrorText:
          "Vaya, algo salió mal... No se pudo eliminar la cuenta de Google. Por favor, inténtalo de nuevo.",
        tooManyRequestsErrorText:
          "Tu plan de suscripción no permite tantas ubicaciones. Para aumentar la cuota, por favor envíanos un correo electrónico a support@localzen.com o utiliza el chat en la esquina inferior derecha de la pantalla.",
        preAddAccount: {
          title: "Permisos para LocalZen",
          description:
            "LocalZen requiere permisos de acceso a las ubicaciones de tu negocio en Google Maps. Esto es necesario para ayudarte en la gestión de ubicaciones.",
          descriptionSecondary:
            "Para conceder estos permisos, marca la casilla cuando se te solicite, como se muestra a continuación:",
          imgAlt: "Cómo marcar la casilla correcta."
        },
        postAddAccount: {
          error: {
            title: "Permisos para LocalZen",
            description:
              "No se pudo añadir la cuenta de Google porque no has concedido los permisos necesarios.",
            descriptionSecondary:
              "LocalZen requiere permisos de acceso a las ubicaciones de tu negocio en Google Maps. Esto es necesario para ayudarte en la gestión de ubicaciones."
          }
        }
      },
      noProfilesAdded: "Aún no se han agregado perfiles."
    },
    monitoredKeywords: {
      title: "Palabras clave rastreadas",
      subtitle: "¿Qué buscan tus clientes?",
      subtitleTooltip:
        "Escribe palabras clave para las que deseas rastrear tu posición.",
      keywordsScope: "Alcance de palabras clave",
      scope: {
        [KEYWORDS_SCOPE.COMPANY]: "Todas las ubicaciones",
        [KEYWORDS_SCOPE.GROUP]: "Grupo",
        [KEYWORDS_SCOPE.FACILITY]: "Ubicación elegida"
      },
      keywordsSection: {
        title: "Palabras clave rastreadas",
        keywordInputPlaceholder: "Agregar palabra clave",
        infoBoxContent:
          "Para agregar una palabra clave, escríbela arriba y presiona Enter en tu teclado o haz clic en el botón Agregar.",
        noKeywords: "Actualmente no estás rastreando ninguna palabra clave.",
        noKeywordsAlt: "Sin palabras clave"
      },
      deleteDialogLabel: "¿Te gustaría eliminar la palabra clave seleccionada?",
      chosenKeywordDeleted: "La palabra clave elegida ha sido eliminada"
    }
  },
  facilityDetails: {
    title: "Detalles de ubicación",
    backToFacilitiesList: "Volver a la lista de ubicaciones",
    appleMapButton: "Apple Maps",
    showIn: "Mostrar en",
    mapButton: "Google Maps",
    bingMapButton: "Bing Maps",
    startDate: "Fecha de apertura",
    openingHours: "Horario de atención",
    openingHoursInfoText:
      "El siguiente horario de apertura se aplicará a toda la semana. Por ejemplo, si configuras el horario de 9 a.m. a 5 p.m. solo para los lunes, y los demás días están marcados como cerrados, entonces, al aplicar los cambios, se modificarán los horarios de apertura tanto para los lunes como para el resto de los días (según lo indicado en el formulario anterior).",
    customOpeningHours: "Horario especial de apertura",
    customOpeningHoursInfoText:
      "El horario de apertura se establecerá solo para los días seleccionados anteriormente. No se modificará ningún otro día.",
    allDayOpeningHours: "Abierto 24h",
    statusOnMaps: "Estado en los mapas",
    typeOfMap: "Mapa",
    status: "Estado",
    details: "Detalles",
    lastUpdateDate: "Última actualización",
    reviewFormLink: "Enlace al formulario de envío de reseñas en Google Maps",
    technicalDetailsDialog: {
      title: "Detalles técnicos",
      locationName: "gmb_location_name"
    },
    statuses: {
      pending: "Esperando actualización",
      inProgress: "Actualización en progreso",
      ok: "Actualizado",
      failed: "Actualización fallida",
      externalChange: "Cambios externos en la información comercial",
      noData: "Sin datos sobre el estado",
      lastUpdateNoData: "Fecha de la última actualización desconocida"
    },
    statusDescription:
      "Puedes ver el estado de tus actualizaciones a continuación. LocalZen actualiza tus ubicaciones en Google Maps en pocos minutos. Sin embargo, el proceso puede demorar más debido a la verificación de datos por parte de Google.",
    forms: {
      streetAndHomeNumber: "Número de casa/piso.",
      websiteAddress: "Dirección del sitio web",
      phoneOne: "Número de teléfono 1",
      phoneTwo: "Número de teléfono 2",
      latitude: "Latitud",
      longitude: "Longitud"
    },
    addWorkingHours: "Agregar horario de apertura",
    addAnotherDay: "Agrega otro día",
    validation: { date: "Se requiere el año y el mes" },
    footer: {
      openingHours:
        "Una vez guardados, los cambios pasarán por un proceso de verificación que puede tardar hasta 3 días. Normalmente, este proceso toma solo unos minutos."
    },
    noChangesInForm:
      "No hay cambios en el formulario. Por favor, selecciona el campo que te gustaría actualizar.",
    facilityDescription: "Descripción de la ubicación del negocio",
    urlAttributes: {
      title: "atributos de la URL",
      facilityAttributes: "Atributos de URL de la ubicación",
      facilitiesAttributes: "Atributos de URL de la ubicación",
      noAttributesSelected: "No se ha seleccionado ningún atributo de URL.",
      editMessage:
        "Agrega o elimina atributos de URL (enlaces). Por ejemplo, un enlace al menú de tu restaurante, para proporcionar más información sobre tus ubicaciones.",
      addAttributes: "Agregar atributos de URL",
      addAttributesInfo:
        "Agrega atributos de URL para proporcionar más información sobre tus ubicaciones y facilitar la conexión con fuentes externas valiosas.",
      addingAttributes: "Agregando atributos de URL",
      addAttributesQuestion:
        "¿Te gustaría agregar atributos de URL adicionales?",
      addAttributesDescription:
        "Proporciona atributos de URL para agregarlos a las ubicaciones seleccionadas. Los nuevos atributos se añadirán junto a los ya existentes, sin modificarlos.",
      deleteAttributes: "Eliminar atributos de URL",
      deletingAttributes: "Eliminando atributos de URL",
      deleteAttributesQuestion:
        "¿Te gustaría eliminar los atributos de URL seleccionados?",
      deleteAttributesDescription:
        "Elige los atributos de URL que deseas eliminar en las ubicaciones seleccionadas. Solo se eliminarán los atributos seleccionados. Los demás permanecerán sin cambios.",
      changeType: "¿Tienes algo más en mente? Seleccionar:",
      changeTypeConfirm: `Si decides cambiar el modo de edición de atributos, se borrarán todos los datos bajo "atributos de URL de ubicación" en tu formulario. Esto solo afectará al formulario; los atributos de URL de cada ubicación no se modificarán. ¿Deseas continuar?`,
      dialog: {
        title: "Atributos de URL",
        description:
          "A continuación, puedes agregar, editar y eliminar atributos de URL.",
        noAttributes: "Sin atributos de URL",
        noAttributesAvailable:
          "Esta ubicación no puede tener atributos URL adicionales. Los atributos URL adicionales solo están permitidos para ciertas categorías de negocios (por ejemplo, restaurantes).",
        noAttributesToDeleteMassEdit: "No hay atributos de URL para eliminar.",
        noAttributesAvailableMassEdit:
          "No es posible agregar atributos de URL, ya que las ubicaciones seleccionadas no comparten atributos de URL comunes.",
        notEditable:
          "Las URL no se pueden actualizar en esta sección (Google no permite hacerlo).",
        validationError:
          "Algunas de las URL en el formulario son incorrectas. Por favor, corrígelas y vuelve a guardar.",
        addAttributeBtn: "Agregar atributo URL",
        applyBtn: "Guardar"
      }
    },
    services: {
      validation: {
        descriptionLength:
          "La descripción del servicio no puede exceder los {0} caracteres",
        serviceExists: "El servicio ya existe",
        required: "Este campo es obligatorio"
      },
      addServiceInfo:
        "Los servicios personalizados se agregarán a la categoría principal del negocio de las ubicaciones seleccionadas.",
      addDescription: "Añadir descripción",
      customServices: "Servicios personalizados",
      standard: "Estándar",
      custom: "Personalizado",
      title: "Servicios",
      addNext: "Agregar siguiente servicio",
      selectServiceCategory: "Seleccionar categoría de servicio",
      noServicesSelected: "No tienes servicios seleccionados",
      addServicesInfo: "Agrega los servicios que ofreces en tu negocio.",
      addAnotherCustomService: "Agregar otro servicio personalizado",
      addCustomService: "Agregar servicio personalizado",
      customService: "Servicio personalizado",
      missingServiceQuestion: "¿No ves el servicio que ofreces?",
      serviceDescription: "Descripción del servicio",
      servicePrice: "Precio del servicio ({0})",
      price: "Precio",
      noPrice: "Sin precio",
      priceFrom: "Precio desde",
      priceTo: "Precio a",
      fixedPrice: "Precio fijo",
      deleteService: "Eliminar servicio",
      deleteServiceDialogText:
        "¿Estás seguro/a de que quieres eliminar este servicio?",
      closeServiceDialogText:
        "¿Estás seguro/a de que quieres cerrar la ventana? Los cambios no guardados se perderán.",
      addServices: "Agregar servicios",
      editServices: "Editar servicios",
      deleteServices: "Eliminar servicios",
      findService: "Buscar servicios",
      addingServices: "Añadiendo servicios",
      addServicesQuestion: "¿Deseas añadir servicios adicionales?",
      addServicesDescription:
        "Selecciona los servicios que deseas agregar a las fichas seleccionadas. Se añadirán a los ya existentes, que se mantendrán intactos.",
      deletingServices: "Eliminando servicios",
      deleteServicesQuestion: "¿Deseas eliminar los servicios seleccionados?",
      deleteServicesDescription:
        "Selecciona los servicios que deseas agregar a las fichas seleccionadas. Se añadirán a los ya existentes, que se mantendrán intactos.",
      overwriteServices: "Configurar servicios",
      overwritingServices: "Configurando servicios",
      overwriteServicesQuestion:
        "¿Quieres configurar (sobrescribir) servicios?",
      overwriteServicesDescription:
        "Selecciona los servicios que deseas configurar en las fichas seleccionadas. Esta operación eliminará todos los servicios actuales y los reemplazará por los que hayas seleccionado.",
      clickToRestore: "Haz clic para restaurar",
      duplicateError: "El servicio {0} ya existe",
      changeType: "¿Tienes algo más en mente? Selecciona:",
      changeTypeConfirm: `Si decides cambiar el modo de edición de servicios, se eliminarán todos los datos de la sección "Servicios" de tu formulario. Los datos se eliminarán únicamente del formulario; los servicios de cada ubicación individual no se verán afectados. ¿Deseas continuar?`
    },
    attributes: {
      googleAvailability: {
        unavailable: "No disponible en Google",
        deprecated: "Retirado por Google",
        why: "¿Por qué?",
        unavailableExplanation: "Google no admite este atributo para esta ubicación. El valor permanece guardado en LocalZen, pero no se envía a Google.",
        deprecatedExplanation: "Google ha retirado este atributo. El valor permanece guardado en LocalZen, pero no se envía a Google.",
        keepOrRemove: "Puedes conservar este valor o eliminar el atributo de LocalZen.",
        remove: "Eliminar de LocalZen",
        removeTitle: "¿Eliminar el atributo de LocalZen?",
        removeConfirm: "Se eliminarán el atributo «{name}» y su valor guardado de esta ubicación en LocalZen.",
        savedValue: "Valor guardado:",
        removeLocalOnly: "Solo se eliminan datos de LocalZen. El historial de cambios seguirá disponible.",
        removed: "Se ha eliminado el atributo de LocalZen.",
      },
      title: "Atributos",
      facilityAttributes: "Atributos de ubicación",
      facilitiesAttributes: "Atributos de ubicación",
      findAttributes: "Encontrar atributos",
      facilityDescription: "Descripción de la ubicación comercial",
      noAttributesSelected: "No se seleccionaron atributos",
      editMessage:
        "Agrega, elimina o configura atributos para comunicar más información sobre tus ubicaciones y resaltar sus características principales. Los atributos incluyen información como métodos de pago, accesibilidad, Wi-Fi gratuito, etc.",
      addAttributes: "Agregar atributos",
      addAttributesInfo:
        "Agrega atributos para comunicar más información sobre tus ubicaciones y resaltar sus principales características. Los atributos incluyen información como métodos de pago, accesibilidad, Wi-Fi gratuito, etc.",
      addingAttributes: "Añadiendo atributos",
      addAttributesQuestion: "¿Deseas agregar atributos adicionales?",
      addAttributesDescription:
        "Elige los atributos que deseas agregar a las ubicaciones seleccionadas. Los nuevos atributos se añadirán junto a los ya existentes sin modificarlos.",
      deleteAttributes: "Eliminar atributos",
      deletingAttributes: "Eliminando atributos",
      deleteAttributesQuestion:
        "¿Te gustaría eliminar los atributos seleccionados?",
      deleteAttributesDescription:
        "Elige los atributos que deseas eliminar en las ubicaciones seleccionadas. Solo se eliminarán los atributos seleccionados. Los demás permanecerán sin cambios.",
      overwriteAttributes: "Configurar atributos",
      overwritingAttributes: "Configurando atributos",
      overwriteAttributesQuestion:
        "¿Te gustaría configurar o sobrescribir los atributos existentes?",
      overwriteAttributesDescription:
        "Selecciona los atributos que deseas configurar en las ubicaciones seleccionadas. Esta acción eliminará todos los atributos actuales y establecerá los nuevos en su lugar.",
      changeType: "¿Tienes algo más en mente? Selecciona:",
      changeTypeConfirm: `Si decides cambiar el modo de edición de atributos, se eliminarán todos los datos de la sección "Atributos de ubicación" de tu formulario. Los datos se eliminarán únicamente del formulario; los atributos de la ubicación individual no se verán afectados. ¿Deseas continuar?`
    },
    categories: {
      primary: {
        title: "Elige la categoría principal del negocio",
        queryPlaceholder: "Buscar por categoría",
        applyBtnText: "Configurar"
      },
      additional: {
        title: "Elige una categoría adicional del negocio",
        queryPlaceholder: "Buscar por categoría",
        applyBtnText: "Agregar",
        bulkEditApplyBtnText: "Seleccionar",
        bulkEditTooltip:
          "Las categorías comerciales adicionales seleccionadas anteriormente reemplazarán (eliminarán) las que actualmente están configuradas para las ubicaciones seleccionadas."
      },
      deleteCategoryDialogTitle: "¿Deseas eliminar la categoría seleccionada?",
      mayNeedVerification:
        "Después de agregar o editar una categoría, Google puede solicitar la verificación de la ubicación nuevamente."
    },
    labels: {
      title: "Etiquetas",
      deleteLabelDialogTitle: "¿Te gustaría eliminar la etiqueta seleccionada?",
      facilityLabels: "Etiquetas de ubicación",
      facilitiesLabels: "Etiquetas de ubicación",
      findLabels: "Encontrar etiquetas",
      facilityDescription: "Descripción de la ubicación del negocio",
      noLabels: "Sin etiquetas",
      noLabelsSelected: "No se seleccionaron etiquetas",
      editMessage:
        "Añadir, eliminar o configurar etiquetas. Las etiquetas no son visibles públicamente en Google Maps.",
      addLabels: "Agregar etiquetas",
      addLabelsInfo:
        "Agrega etiquetas para comunicar más información sobre tus ubicaciones y destacar las etiquetas más importantes.",
      addingLabels: "Agregando etiquetas",
      addLabelsQuestion: "¿Te gustaría añadir etiquetas adicionales?",
      addLabelsDescription:
        "Elige las etiquetas que deseas añadir a las ubicaciones seleccionadas. Las nuevas etiquetas se agregarán junto a las ya existentes sin modificarlas.",
      deleteLabels: "Eliminar etiquetas",
      deletingLabels: "Eliminando etiquetas",
      deleteLabelsQuestion:
        "¿Te gustaría eliminar las etiquetas seleccionadas?",
      deleteLabelsDescription:
        "Elige las etiquetas que te gustaría eliminar de las ubicaciones seleccionadas. Solo se eliminarán las etiquetas seleccionadas. Las demás etiquetas permanecerán sin cambios.",
      overwriteLabels: "Configurar etiquetas",
      overwritingLabels: "Configurando etiquetas",
      overwriteLabelsQuestion:
        "¿Te gustaría configurar o sobrescribir las etiquetas existentes?",
      overwriteLabelsDescription:
        "Por favor, selecciona las etiquetas que te gustaría establecer en las ubicaciones seleccionadas. Esta acción eliminará todas las etiquetas actuales de las ubicaciones seleccionadas y establecerá nuevas etiquetas en su lugar.",
      changeType: "¿Tienes algo más en mente? Seleccionar:",
      changeTypeConfirm: `Si decides cambiar el modo de edición de etiquetas, se eliminarán todos los datos de la sección "Etiquetas de ubicación" de tu formulario. Los datos se eliminarán únicamente del formulario; las etiquetas de la ubicación individual no se verán afectadas. ¿Deseas continuar?`,
      dialog: {
        title: "Etiquetas",
        description:
          "Aquí puedes añadir, editar y eliminar etiquetas para la ubicación seleccionada.",
        noLabels: "Sin etiquetas.",
        addLabelBtn: "Agregar etiqueta",
        applyBtn: "Aplicar"
      }
    },
    moreHours: {
      title: "Más horas",
      facilitiesMoreHours: "Asignar más horas a la ubicación",
      noMoreHoursSelected: "No se seleccionaron más horas",
      editMessage:
        "Establecer o eliminar más horas, por ejemplo, relacionadas con el horario de entrega.",
      setMoreHours: "Establecer más horas",
      setMoreHoursInfo:
        "Configura más horas para proporcionar más información sobre los horarios de apertura de servicios específicos en tus ubicaciones.",
      settingMoreHours: "Configurando más horas",
      setMoreHoursQuestion: "¿Te gustaría configurar más horas?",
      setMoreHoursDescription:
        "Selecciona las horas adicionales que deseas configurar en las ubicaciones seleccionadas. Esto eliminará todas las horas adicionales actuales en dichas ubicaciones y las reemplazará por las nuevas.",
      deleteMoreHours: "Elimina las horas adicionales",
      deletingMoreHours: "Eliminando horas adicionales",
      deleteMoreHoursQuestion:
        "¿Te gustaría eliminar las horas adicionales seleccionadas?",
      deleteMoreHoursDescription:
        "Elige las horas adicionales que deseas eliminar de las ubicaciones seleccionadas. Solo se eliminarán las horas adicionales seleccionadas; las demás permanecerán sin cambios.",
      changeType: "¿Tienes algo más en mente? Selecciona:",
      changeTypeConfirm: `Si decides cambiar el modo de edición de horas adicionales, se eliminarán todos los datos de la sección "Horas adicionales de la ubicación" en tu formulario. Los datos se eliminarán únicamente del formulario; las horas adicionales de la ubicación individual no se verán afectadas. ¿Deseas continuar?`,
      categoriesDialog: {
        description:
          "Puedes añadir horas adicionales para ciertos servicios u ofertas en la ubicación seleccionada.",
        descriptionMassEdit:
          "Puedes añadir horas adicionales para ciertos servicios u ofertas en las ubicaciones seleccionadas.",
        chooseCategory: "Elige categoría:",
        chooseCategoriesToDelete: "Elige las categorías que deseas eliminar:",
        noCategories: "No hay categorías disponibles."
      }
    },
    openStatusDialog: { title: "Apertura y cierre de la ubicación" },
    addingFacilityToGoogleMapsInProgressInfoText:
      "No puedes editar esta ubicación porque se está añadiendo actualmente a Google Maps."
  },
  facilityCreate: {
    title: "Crear ubicación",
    cancelCreating: "Cancelar creación",
    baseForm: {
      heading: "Datos de la ubicación",
      headingSecondary: "Proporciona el nombre y la dirección del lugar.",
      required: "Este campo es obligatorio"
    },
    primaryCategoryRequired: "La categoría principal es obligatoria.",
    accountSelect: {
      heading: "Cuenta de Google",
      headingSecondary:
        "Elige la cuenta de Google y el perfil a los que deseas añadir la nueva ubicación:",
      noAccounts:
        "No hay cuentas de Google disponibles, no se puede crear ubicación."
    },
    createDisabled:
      "La creación de nuevas fichas en Google Maps desde el panel de LocalZen está actualmente desactivada en tu cuenta. Para activarla, por favor contacta con el soporte (support@localzen.com).",
    dialog: {
      facilityCreated: {
        title:
          "La ubicación se ha añadido exitosamente al Administrador del Perfil de Negocio en Google",
        subtitle: "(Cuenta GMB: {account}, perfil: {profile})",
        importedToCenter: "y ha sido importado a LocalZen.",
        verificationStarted:
          "El proceso de verificación de la ubicación ha comenzado y debería finalizar pronto.",
        goToFacilitiesList: "Ir a la lista de ubicaciones",
        createNew: "Crear la siguiente ubicación"
      },
      facilityImported: {
        description:
          "La ubicación se está importando a LocalZen y estará disponible en la lista de ubicaciones en unos minutos.",
        goToBtn: "Ir a la lista de ubicaciones"
      },
      createDuplicate: {
        title: "Esa ubicación ya existe en Google Maps",
        description: {
          main:
            "Si añades esta ubicación, corres el riesgo de crear un duplicado. Los duplicados pueden confundir a tus clientes y es posible que Google no muestre las ubicaciones duplicadas en Google Maps.",
          more: ""
        },
        sureToContinue: "¿Quieres continuar?",
        confirmBtn: "Sí, crear esta ubicación en Google Maps"
      },
      inCenter: {
        title: "La ubicación ya está en tu cuenta de Google",
        paragraphFirst:
          "La ubicación con el nombre y dirección proporcionados ya se ha añadido a tu cuenta de Google (cuenta GMB: {account}, perfil: {profile}) y se ha importado a LocalZen.",
        paragraphSecond:
          "No es necesario añadirla de nuevo. Si deseas actualizar tus datos, dirígete a la sección de edición de la ubicación.",
        goToEditView: "Editar datos de ubicación"
      },
      inGoogle: {
        title: "Ubicación en el Administrador de Perfiles de Negocio de Google",
        createNewFacility: "Crear nueva ubicación en Google Maps",
        choiceHeader:
          "Selecciona la ubicación para agregarla a tu cuenta de Google.",
        descriptionTop: {
          onlyExistsInAccount:
            "La ubicación con este nombre y dirección ya se ha añadido a tu cuenta de Google, pero aún no se ha importado a LocalZen. Por lo tanto, solo necesitas importarla a LocalZen.",
          mixWithAndWithoutOwner:
            "La ubicación con este nombre y dirección ya existe en Google Maps pero aún no se ha añadido a tu cuenta de Google. Las ubicaciones que hemos encontrado están en la lista que se muestra a continuación.",
          mixAll:
            "Ya se ha añadido una ubicación con este nombre y dirección a tu cuenta de Google, pero aún no se ha importado a LocalZen. Por tanto, solo necesitas importarla a LocalZen. También hemos notado que ya existe una ubicación con este nombre y dirección en Google Maps, pero aún no se ha añadido a tu cuenta de Google."
        },
        [FACILITY_CREATE_ACTION.EXISTS_IN_ACCOUNT]: {
          text: "La ubicación existe en tu cuenta de GMB.",
          tooltip:
            "La ubicación ya existe en tu cuenta de Google, pero aún no se ha importado a LocalZen. Solo necesitas importarla a LocalZen. No es necesario crear una nueva ubicación.",
          descriptionBottom:
            "La ubicación seleccionada ya está añadida a tu cuenta de GMB con el nombre {account}, en el perfil {profile}. Se importará a LocalZen utilizando esta cuenta y perfil de GMB.",
          goTo: "Ver en el Administrador de Perfiles de Negocio de Google",
          applyBtn: "Importar"
        },
        [FACILITY_CREATE_ACTION.WITH_OWNER]: {
          text:
            "La ubicación ya existe en Google Maps y tiene otro propietario.",
          tooltip:
            "Esta ubicación tiene otro propietario que ya fue añadido y verificado anteriormente en Google Maps por otra persona. Esta persona es el propietario actual de esta ubicación en Google Maps. Para obtener acceso a esta ubicación, necesitarás permiso de esta persona.",
          goTo: "Ver en Google Maps",
          applyBtn: "Solicitar acceso a esta ubicación",
          tooltipBottom:
            "Después de presionar este botón, serás redirigido a un formulario que te permitirá contactar al propietario actual de esta ubicación. El formulario incluirá una parte de la dirección de correo electrónico de esta persona. Si reconoces esa dirección, es recomendable que te pongas en contacto directamente y solicites permiso. Si no la reconoces, deberás completar y enviar el formulario. Después de eso, Google notificará al propietario actual sobre tu solicitud. Esta persona tendrá algunos días para aceptarla o rechazarla. Si tu solicitud es rechazada, aún podrás presentar una apelación desde tu panel de Google (Administrador del Perfil de Negocio). La falta de respuesta por parte del propietario se interpretará como una aceptación por parte de Google."
        },
        [FACILITY_CREATE_ACTION.WITHOUT_OWNER]: {
          text: "La ubicación existe en Google Maps y no tiene propietario.",
          tooltip:
            "Esta ubicación se agregó anteriormente a Google Maps, pero aún no está verificada. Esto significa que puedes añadirla fácilmente a tu cuenta.",
          goTo: "Ver en Google Maps",
          applyBtn: "Agregar a la cuenta de Google"
        }
      }
    }
  },
  facilitiesEdit: {
    editSuccess: "Edición exitosa",
    bulkEditMessage:
      "Se está realizando una edición en lote de los datos de las ubicaciones. No podrás realizar nuevas ediciones en lote hasta que el proceso no termine.",
    title: "Edición en lote de ubicaciones",
    checkFieldsDescription:
      "Selecciona los campos que te gustaría actualizar e introduce los cambios. Los cambios se implementarán en todas las ubicaciones seleccionadas."
  },
  facilitiesAddNew: {
    addExistingFacilities: "Agregar ubicaciones existentes",
    importFromGoogleMyBusiness:
      "Importar ubicaciones desde el Administrador del Perfil de Negocio de Google",
    importFromGoogleMyBusinessDescription:
      "Inicia sesión en tu cuenta de Google y selecciona la ubicación que te gustaría añadir. Los datos se importarán automáticamente.",
    analysisPositionAtGoogleMaps:
      "Analizar posiciones en la búsqueda de Google Maps",
    comparingWithCommercialFacilities:
      "Comparar con las ubicaciones de los competidores",
    updateDataOnGoogleMaps: "Actualizar datos en Google Maps",
    updateDataOnOtherMaps: "Actualizar datos en otros mapas",
    accessToStatistics:
      "Accede a las estadísticas sobre búsquedas y comportamiento de los usuarios para las ubicaciones de Google Maps.",
    searchOnGoogleMaps: "Buscar en Google Maps",
    searchOnGoogleMapsDescription:
      "Busca la ubicación en Google Maps utilizando tu nombre o dirección. Cualquier dato que esté disponible públicamente se descargará automáticamente.",
    addFacilitySearchingOnTheMap:
      "Agregar ubicación mediante la búsqueda en Google Maps",
    addFacilitySearchingOnTheMapDescription:
      "Busca la ubicación en Google Maps usando tu dirección o ingresando tu nombre a continuación. Cualquier dato que esté disponible públicamente se descargará automáticamente.",
    noAccess: "No tienes autorización para añadir nuevas ubicaciones."
  },
  wizard: {
    addNameAndchooseFromList: "Ingresa el nombre o selecciona uno de la lista",
    streetAndHomeNumber: "Dirección",
    fillTaxNumber:
      "Introduce tu NIP (solo para empresas registradas en Polonia)",
    taxNumberFieldDescription:
      "Si tu empresa está registrada en Polonia, puedes introducir el número de identificación fiscal (NIP) para acceder automáticamente a información sobre tu empresa.",
    businessAddresses: {
      method: {
        title: "Agrega tus ubicaciones desde Google Maps",
        description:
          "Agrega tu cuenta de Google para añadir automáticamente todas tus ubicaciones de Google Maps.",
        addManually: "Agregar ubicación manualmente"
      }
    },
    companyInWeb: {
      name: "Tu negocio en línea",
      header: "¿Cómo te encuentran tus clientes en línea?",
      termsTitle: "¿Qué buscan tus clientes?",
      termsDescription:
        "Palabras clave que los usuarios buscan en Google Maps para encontrar tu negocio o empresas similares.",
      localityTitle: "¿Dónde están tus clientes?",
      localityDescription:
        "¿En qué ciudades y lugares residen sus clientes potenciales?",
      settingsTitle: "¿Qué te gustaría que tus clientes encontraran?",
      settingsDescription:
        "Elige una ubicación o un sitio web de la lista para establecer los parámetros.",
      suggestedAll: "Añadir a todas las ubicaciones y sitios web",
      suggestedWebsites: "Añadir a todos los sitios web.",
      facilitiesAll:
        "Agregar palabra clave de búsqueda a todas las ubicaciones",
      facilitiesSelected:
        "Agregar palabra clave de búsqueda solo a las ubicaciones seleccionadas",
      removeLabel:
        "¿Deseas eliminar la palabra clave de todas las ubicaciones o solo de la ubicación seleccionada?",
      facilitiesRemoveAll: "Eliminar de todas las ubicaciones",
      facilitiesRemoveSelected: "Eliminar solo de las seleccionados",
      businessAddress: "Ubicación del negocio",
      noAddressesSelected:
        "No se especificó ninguna ubicación. Para continuar, por favor añade al menos una ubicación de negocio.",
      inLocationVicinity: "en las inmediaciones de la ubicación"
    },
    validation: {
      companyNotFound:
        "el siguiente número NIP no coincide con ninguna empresa. Por favor, asegúrate de haber ingresado el número NIP correcto."
    }
  },
  average: {
    veryWeak: "Muy insuficiente",
    weak: "Insuficiente",
    medium: "Aceptable",
    good: "Bueno",
    veryGood: "Excelente"
  },
  error: {
    badRequest:
      "Solicitud no válida. Por favor, contacta con nuestro equipo de soporte.",
    unauthorized: "Autorización requerida. Por favor, inicia sesión.",
    notFound:
      "No se encontró ningún archivo. Por favor, contacta con nuestro equipo de soporte.",
    server:
      "Error del servidor. Por favor, contacta con nuestro equipo de soporte.",
    other: "Error. Por favor, contacta con nuestro equipo de soporte.",
    parsing: "Se produjo un error al analizar los datos",
    requiredField: "Requerido",
    noAccounts: "No se añadieron cuentas"
  },
  businessAddresses: {
    list: {
      facilityIs: "La Instalación está",
      isDuplicate: "un duplicado",
      isDisconnected: "desconectado",
      editTooltip:
        "Aquí puedes editar varias ubicaciones en lote seleccionando más de una.",
      tabTitle: "Lista de ubicaciones",
      searchPlaceholder: "Nombre, dirección, código de tienda",
      delete: "Eliminar de LocalZen",
      addingToGoogleMaps: "Añadiendo a Google Maps",
      totalFacilitiesCount: "Todas las ubicaciones: {0}",
      ignoreUnverifiedFacilities: "Ignorar ubicaciones no verificadas"
    },
    groups: {
      tabTitle: "Grupos de ubicaciones",
      noGroups: {
        description:
          "¡Crea grupos y organiza tus ubicaciones para facilitar la gestión de la información!",
        button: "Agregar nuevo grupo"
      },
      labelGroups: {
        addBtn: "Agregar nuevo grupo conectado a las etiquetas de GMB",
        labelGroupListItemTooltip: "Conectado a las etiquetas de GMB",
        labelGroupTooltip:
          "Este grupo está gestionado automáticamente por LocalZen. El sistema agregará o eliminará ubicaciones a este grupo automáticamente en función de los cambios en las etiquetas GMB de las ubicaciones. Las ubicaciones de este grupo no se pueden agregar ni eliminar manualmente.",
        addGroupDialog: {
          title: "Seleccionar etiquetas",
          description:
            "Selecciona las etiquetas de GMB que se utilizarán para crear este grupo de ubicaciones. Se añadirán al grupo todas las ubicaciones que contengan todas las etiquetas seleccionadas. Este grupo será gestionado automáticamente por LocalZen, lo que significa que el sistema añadirá o eliminará ubicaciones del grupo según los cambios en las etiquetas de las ubicaciones."
        }
      },
      groupNotSelected: "No se seleccionó ningún grupo",
      addNewGroup: {
        title: "Agregar grupo",
        chosenCompany: "Compañía seleccionada: {0}",
        newGroupName: "Nombre del grupo",
        successfullyAdded: `El grupo "{0}" fue creado con éxito`
      },
      editGroup: {
        title: "Editar el nombre del grupo",
        chosenCompany: "Empresa seleccionada: {0}",
        newGroupName: "Nombre del grupo",
        successfullyUpdated: "El grupo fue editado con éxito"
      },
      emptyGroup:
        "Agrupar ubicaciones para facilitar la gestión de la información.",
      createdGroups: "Tus grupos:",
      groupSuccessfullyDeleted: `El grupo "{0}" fue eliminado con éxito`,
      facilities: {
        facilitiesInGroup: "Ubicaciones en este grupo",
        addFacilitiesButton: "Agregar ubicaciones",
        emptyGroup:
          "Agrupar ubicaciones para facilitar la gestión de la información",
        filterInputPlaceholder: "¿Qué ubicación estás buscando?",
        noFacilitiesMatchingQuery: "Ninguna ubicación coincide con la búsqueda",
        addFacilitiesToGroup: "Agregar ubicación al grupo",
        selectedGroup: "Grupo seleccionado: {0}",
        facilitiesAdded: `Se añadieron ubicaciones al grupo "{0}"`,
        facilityDeleted: `La ubicación "{0}" fue eliminada del grupo "{1}"`,
        facilitiesDeleted: `Las ubicaciones fueron eliminadas del grupo "{0}"`,
        importFromCsv: "Agregar ubicaciones desde archivo CSV",
        step1Title: "Seleccionar archivo CSV",
        step1Description:
          "Selecciona un archivo CSV que contenga ubicaciones para agregar al grupo. El archivo debe contener solo una columna con códigos de ubicación (sin encabezado).",
        clickToUpload: "Haz clic para seleccionar archivo CSV",
        dataToImport: "Ubicaciones a importar",
        code: "Código de ubicación",
        name: "Nombre de ubicación",
        address: "Dirección de ubicación",
        notFoundCodesTitle: "Códigos de ubicación no encontrados:",
        step2Title: "Elegir cómo agregar ubicaciones",
        step2Description:
          "Puedes extender el grupo seleccionado con nuevas ubicaciones o sobrescribir las ubicaciones existentes en el grupo.",
        addToGroup: "Agregar al grupo",
        addToGroupDescription:
          "Las ubicaciones existentes en el grupo se conservarán.",
        replaceGroup: "Sobrescribir grupo",
        replaceGroupDescription:
          "Las ubicaciones existentes en el grupo serán sobrescritas.",
        step3Title: "Resumen de importación",
        importCompleted: "Se importaron exitosamente {0} al grupo '{1}'",
        importFailed: "No se pudieron importar {0} al grupo '{1}'",
        importError: "Se produjo un error al importar ubicaciones",
        addManually: "Manualmente",
        addFromFile: "Desde archivo",
        invalidFileType:
          "Tipo de archivo no válido. Por favor selecciona un archivo CSV.",
        emptyFile: "El archivo seleccionado está vacío.",
        fileParseError: "Se produjo un error al analizar el archivo.",
        noName: "Sin nombre",
        noAddress: "Sin dirección",
        noFacilitiesFound: "No se encontraron ubicaciones"
      }
    },
    quality: {
      viewTitle: "Calidad de las ubicaciones de Google Maps",
      actionButtons: {
        information: {
          add: {
            text:
              "Proporciona toda la información necesaria sobre tu ubicación a tus clientes.",
            label: "Agregar información"
          },
          edit: {
            text:
              "Asegúrate de que toda la información de tu ubicación esté actualizada.",
            label: "Editar información"
          }
        },
        reviews: {
          text:
            "Cuida la relación con tus clientes respondiendo a sus reseñas.",
          label: "Responder a las reseñas"
        },
        photos: {
          text: "Sube fotos que reflejen lo mejor de tu negocio",
          label: "Subir fotos"
        },
        posts: {
          text:
            "Agrega publicaciones para informar a tus clientes sobre ofertas y novedades.",
          label: "Agregar publicaciones"
        }
      }
    }
  },
  externalChanges: {
    supersededAt: "Sustituida",
    supersededDescription:
      "Un cambio posterior de este campo en LocalZen sustituyó la operación anterior. Esta entrada muestra el cambio detectado originalmente.",
    googleSkip: {
      attribute_unavailable: "El cambio no se ha enviado a Google - el atributo no está disponible para esta ubicación.",
      attribute_deprecated: "El cambio no se ha enviado a Google - el atributo ha sido retirado.",
      valueRetained: "El valor anterior permaneció en LocalZen.",
    },
    title: "Cambios externos",
    hasExternalChanges:
      "Hay cambios externos que deben ser aceptados o rechazados.",
    noChanges:
      "LocalZen supervisa cualquier cambio en tus fichas que los usuarios hayan sugerido mientras la función 'Proteger contra cambios' haya estado activada. Actualmente, no tienes sugerencias de cambio, o todas han sido aceptadas o rechazadas.",
    noChangesHistory: "El historial de cambios externos está vacío.",
    noChangesAlt: "Sin cambios externos.",
    automaticChange: "Protección de LocalZen",
    filter: {
      fieldLabel: "Filtrar por campo",
      allFields: "Todos los campos",
      fieldsSelected: "Campos seleccionados: {count}"
    },
    list: {
      title: "Lista de cambios externos",
      searchPlaceholder: "Nombre, dirección, código de ubicación",
      overLimitTooltip:
        "Se pueden realizar acciones en lote para un máximo de {count} ubicaciones."
    },
    protect: {
      title: "Protección contra cambios externos",
      description:
        "Aquí puedes decidir si deseas aceptar o rechazar los cambios externos realizados por los usuarios de Google en tus ubicaciones. Cuando se detecten cambios, LocalZen ejecutará automáticamente algunas de estas acciones por ti. No obstante, para rechazar ciertos cambios, deberás confirmarlo manualmente.",
      type: {
        external: "Cambios externos",
        gmb: "Cambios en el Administrador de Perfiles de Negocio de Google"
      },
      alwaysAccept: "Aceptar",
      alwaysReject: "Rechazar",
      allFields: "Todos los campos",
      infoDialog: {
        title: "La configuración ha sido guardada.",
        textContentFirst:
          "Se supervisarán tus fichas según la configuración para identificar cambios ocurridos fuera de LocalZen. Se te notificará cuando se detecten cambios que deseas rechazar. Necesitarás confirmar su rechazo. Los cambios que deseas aceptar serán gestionados por LocalZen (no se requerirá ninguna acción por tu parte).",
        showChangesBtn: "Ver cambios detectados anteriormente"
      }
    },
    history: {
      title: "Historial de cambios externos",
      searchPlaceholder: "Nombre, dirección, código de ubicación",
      changeHeaderTooltip:
        "Cambio en los datos de ubicación que haya sido realizado, aceptado o rechazado.",
      showAllChanges: "Mostrar todos los cambios ({count})"
    },
    date: "Fecha",
    origin: "Fuente",
    type: "Cambiar tipo",
    user: "Usuario",
    field: "Campo cambiado",
    change: "Cambiar",
    allChanges: "Todos los cambios: {count}",
    action: "Acción",
    actionPerformed: "Acción realizada",
    changeDetected: "Cambio detectado",
    additionTooltip: "Se agregó nueva información",
    removalTooltip: "Se eliminó información existente.",
    changeTooltip: "Se cambió información existente.",
    selectedFacilities: "Ubicaciones seleccionadas: {0}",
    groupChangeDialog: {
      [EXTERNAL_CHANGES_STATUS.ACCEPTED]: {
        title: "Aceptar cambios externos",
        text:
          "Selecciona los cambios que deseas aceptar en las ubicaciones seleccionadas.",
        button: "Aceptar",
        [EXTERNAL_CHANGES_SOURCE.GMB]:
          "Estás aceptando cambios que provienen únicamente de este origen: Administrador de Perfiles de Negocio de Google",
        [EXTERNAL_CHANGES_SOURCE.EXTERNAL]:
          "Estás aceptando cambios que provienen únicamente de este origen: Externo"
      },
      [EXTERNAL_CHANGES_STATUS.REJECTED]: {
        title: "Rechazar cambios externos",
        text:
          "Selecciona los cambios que deseas rechazar en las ubicaciones seleccionadas.",
        button: "Rechazar",
        [EXTERNAL_CHANGES_SOURCE.GMB]:
          "Estás rechazando cambios que provienen únicamente de este origen: Administrador de Perfiles de Negocio de Google",
        [EXTERNAL_CHANGES_SOURCE.EXTERNAL]:
          "Estás rechazando cambios que provienen únicamente de este origen: Externo"
      }
    },
    informationalFieldTooltip:
      "El estado de la ubicación ha cambiado. Este cambio no se puede rechazar.",
    processingInProgressTooltip:
      "LocalZen está actualizando la información de esta ficha de Google Maps en estos momentos. Durante este proceso no se permiten otros cambios en esta ubicación. Inténtalo de nuevo en unos minutos.",
    fields: {
      [EXTERNAL_CHANGES_FIELD.NAME]: "Nombre de la ubicación",
      [EXTERNAL_CHANGES_FIELD.STREET]: "Calle",
      [EXTERNAL_CHANGES_FIELD.POSTAL_CODE]: "Código postal",
      [EXTERNAL_CHANGES_FIELD.CITY]: "Ciudad",
      [EXTERNAL_CHANGES_FIELD.COUNTRY]: "País",
      [EXTERNAL_CHANGES_FIELD.STORE_CODE]: "Código de tienda",
      [EXTERNAL_CHANGES_FIELD.PRIMARY_CATEGORY]:
        "Categoría principal del negocio",
      [EXTERNAL_CHANGES_FIELD.ADDITIONAL_CATEGORIES]:
        "Categorías comerciales adicionales",
      [EXTERNAL_CHANGES_FIELD.WEBSITE]: "Dirección del sitio web",
      [EXTERNAL_CHANGES_FIELD.PRIMARY_PHONE]: "Teléfono 1",
      [EXTERNAL_CHANGES_FIELD.ADDITIONAL_PHONES]: "Phone 2",
      [EXTERNAL_CHANGES_FIELD.REGULAR_HOURS]: "Horario de apertura",
      [EXTERNAL_CHANGES_FIELD.SPECIAL_HOURS]: "Horario especial de apertura",
      [EXTERNAL_CHANGES_FIELD.ATTRIBUTES]: "Atributos",
      [EXTERNAL_CHANGES_FIELD.DESCRIPTION]: "Descripción",
      [EXTERNAL_CHANGES_FIELD.OPENING_DATE]: "Fecha de apertura",
      [EXTERNAL_CHANGES_FIELD.LOCATION_STATE]:
        "Estado del Administrador de Perfiles de Negocios de Google",
      [EXTERNAL_CHANGES_FIELD.OPEN_STATUS]: "Estado abierto",
      [EXTERNAL_CHANGES_FIELD.LABELS]: "Etiquetas",
      [EXTERNAL_CHANGES_FIELD.MORE_HOURS]: "Más horas",
      [EXTERNAL_CHANGES_FIELD.SERVICES]: "Servicios"
    },
    fieldsTooltips: {
      [EXTERNAL_CHANGES_FIELD.REGULAR_HOURS]:
        "Horario de apertura y más horarios (por ejemplo, horario de entrega)"
    },
    summaryInfoBar:
      "Hemos detectado {changesCount} en tus ubicaciones pendientes para rechazar, según tu configuración.",
    rejectChanges: "Rechazar cambios",
    changesInfoSection: {
      detectedChanges:
        "Hemos detectado {changesCount} cambios pendientes para rechazar (en {facilitiesCount}) en los campos de contenido que deseas proteger.",
      changesRelatedTo: "Estos cambios se refieren a: {fields}.",
      availableHere:
        "Los detalles de todos los cambios detectados están disponibles en: {link}.",
      here: "aquí",
      confirmReject: "Haz clic abajo si deseas rechazar todos los cambios.",
      noChanges:
        "No se detectaron cambios para rechazar en los campos que deseas proteger.",
      rejectingDialog: "Los cambios detectados están siendo rechazados.",
      rejectDetectedChanges: "Rechazar los cambios detectados",
      rejectConfirmation:
        "¿Estás seguro/a de que quieres rechazar los cambios detectados?"
    }
  },
  photos: {
    title: "Agregar foto",
    facilityLabel:
      "Selecciona las ubicaciones a las que quieres agregar la foto",
    facilitiesAll: "todas las ubicaciones (verificadas)",
    facilitiesAllTooltip:
      "Las fotos solo pueden enviarse a ubicaciones verificadas en Google Maps",
    facilitiesSelected: "ubicaciones seleccionadas (verificadas)",
    facilitiesSelectedTooltip:
      "Solo puedes enviar fotos a las ubicaciones que están verificadas en Google Maps. En la lista que aparece en el cuadro de diálogo abierto solo se muestran esas ubicaciones.",
    addPhotoTitle: "Foto",
    addPhotoTooltip:
      "Resolución mínima recomendada: <b>720 x 720</b> px.<br/> Tamaño del archivo: entre <b>10 KB</b> y <b>10 MB</b>.<br/> Las fotos de <b>portada</b> deben tener una relación de aspecto de 16:9.",
    addPhoto: "Añadir foto",
    changePhoto: "Cambiar foto",
    categoriesTooltip: `La categoría en la que se mostrará una foto en Google Maps. Algunas categorías (por ejemplo, comida y bebida) podrían no estar disponibles para ciertos tipos de negocios. Si subes una foto a una categoría que no está disponible, la foto se añadirá automáticamente a la categoría "Otros".`,
    send: "Enviar",
    addMore: "Agregar más fotos",
    photoAddedSuccessfully:
      "Las fotos se enviaron. Deberían aparecer en Google Maps en unos 10 minutos.",
    photosNotAdded:
      "No se enviaron todas las fotos. Por favor, intenta nuevamente con las restantes.",
    facilitiesError: "Se requiere al menos una ficha de negocio.",
    facilitiesRequired: "Por favor, selecciona donde quieres agregar la foto",
    countLimitError: `Solo puedes enviar una foto con la categoría "{0}"`,
    edit: {
      applyChanges: "Aplicar cambios",
      infoBox: "Redimensiona y adapta el tamaño según tus necesidades.",
      rotateRight: "Girar a la derecha",
      rotateLeft: "Girar a la izquierda",
      reset: "Restablecer"
    },
    noData: {
      button: "Agregar cuenta",
      title: "Agregar fotos a ubicaciones en Google Maps",
      desc:
        "Aquí puedes agregar fotos a todas las ubicaciones de tu negocio en Google Maps. Solo necesitas ingresar el contenido de la foto una vez y nosotros lo enviaremos automáticamente a las ubicaciones seleccionadas o a todas tus ubicaciones de negocio. Esto te ahorrará tiempo y esfuerzo. Para utilizar esta funcionalidad, importa tus ubicaciones añadiendo tu cuenta de Google a LocalZen."
    },
    list: {
      title: "Fotos enviadas",
      empty: "Agrega fotos a tus fichas.",
      notFound: "No hay fotos en el período de tiempo seleccionado.",
      noPhotos: "Sin fotos",
      addNew: "Añadir nuevo",
      sendDate: "Enviado el",
      mapsStatus: "Estado de la ficha en Google Maps",
      slStatus: "Estado de la ficha en el Localizador de Tiendas",
      sendStatus: "Estado",
      details: "Detalles",
      visible: "Ficha visible",
      sendToFacilities: "Foto enviada a {0}",
      successCount: "{0} publicaco",
      failedCount: "{0} rechazado",
      [GMB_MEDIA_TYPE.ADDITIONAL.NAME]: "Adicional",
      [GMB_MEDIA_TYPE.COVER.NAME]: "Portada",
      [GMB_MEDIA_TYPE.LOGO.NAME]: "Logo",
      [GMB_MEDIA_TYPE.EXTERIOR.NAME]: "Exterior",
      [GMB_MEDIA_TYPE.INTERIOR.NAME]: "Interior",
      [GMB_MEDIA_TYPE.PRODUCT.NAME]: "Producto",
      [GMB_MEDIA_TYPE.FOOD_AND_DRINK.NAME]: "Comida y bebida",
      [GMB_MEDIA_TYPE.TEAMS.NAME]: "Equipo",
      delete: {
        title:
          "¿Estás seguro/a de que deseas eliminar la foto seleccionada de todas las fichas?",
        body1:
          "Esta acción eliminará las fotos en el Administrador de Perfiles de Negocios de Google. A veces, las fotos eliminadas pueden seguir siendo visibles en Google Maps durante un tiempo (Google las elimina con cierto retraso). Esto se debe a la forma en que funcionan los algoritmos de Google y no depende de si la entrada fue eliminada por LocalZen o directamente desde el panel del Administrador de Perfiles de Negocio de Google. Afortunadamente, esta situación es poco frecuente.",
        body2:
          "Al eliminar una foto, esta dejará de mostrarse en el Localizador de Tiendas.",
        confirm: "Sí, eliminar",
        tooltip:
          "Para eliminar esta foto, por favor contáctanos a través de correo electrónico (support@localzen.com) o a través del chat."
      },
      status: {
        [GMB_MEDIA_STATUS.PENDING]: "Enviando",
        [GMB_MEDIA_STATUS.COMPLETED]: "Enviado",
        [GMB_MEDIA_STATUS.FINISHED_WITH_PROBLEMS]: "Enviado"
      }
    },
    customer: {
      title: "Fotos de usuarios",
      addedDate: "Fecha de publicación",
      selectLocations: "Seleccionar ubicaciones",
      showDeleted: "Incluir eliminadas",
      aiSettings: {
        title: "Ajustes de IA",
        subtitle:
          "Cómo evalúa la IA las fotos de clientes en todas tus fichas.",
        companyContext: "Qué debe saber la IA sobre la empresa",
        companyContextTip:
          "Quiénes sois y qué suele verse en las fotos de vuestros locales.",
        companyContextMissing:
          "La IA preparará la descripción automáticamente en breve. También puedes escribirla tú.",
        generatedByAi: "Escrito por la IA.",
        approve: "Aprobar",
        orEditBelow: "o edítalo abajo.",
        rules: "Qué debe hacer la IA",
        rulesTip:
          "Reglas y excepciones adicionales, p. ej. «Si en la foto se ve un recibo con datos personales, márcala como Para denunciar».",
        rulesNewLine: "Escribe cada regla en una línea nueva, así la IA las tratará por separado.",
        appliesToNew:
          "Los cambios se aplican a partir de ahora, a las fotos nuevas. Las evaluaciones anteriores no cambiarán.",
        needsReviewLabel: "La descripción de la empresa está pendiente de revisión",
        needsReviewTooltip:
          "La IA ha escrito la descripción de tu empresa. Comprueba que es correcta: la IA evalúa las fotos a partir de ella."
      },
      deletedChip: "Eliminada de Google",
      deletedHint:
        "Esta foto se ha eliminado de Google. Solo puedes editar su nota.",
      empty: "No hay fotos de usuarios.",
      noResults: "No hay fotos que coincidan con los filtros seleccionados.",
      loadError: "No se pudieron cargar las fotos de usuarios.",
      unknownContributor: "Usuario desconocido",
      openPhoto: "Abrir foto",
      noResultsInTab: "No hay fotos en esta vista.",
      tabs: {
        all: "Todas",
        toReport: "Para denunciar",
        toVerify: "Para verificar",
        reported: "Denunciadas"
      },
      order: {
        newestFirst: "Más recientes primero",
        oldestFirst: "Más antiguas primero"
      },
      assessment: {
        ok: "OK",
        okHint: "Evaluar: la foto está bien",
        toReport: "Para denunciar",
        toReportHint: "Evaluar: para denunciar",
        pickReason: "Elige el motivo de la denuncia",
        noReason: "Sin indicar el motivo",
        noReasonHint: "Sin indicar el motivo",
        reasonHint: "Motivo: {reason}",
        remove: "Eliminar la evaluación",
        assessLabel: "Evalúa la foto:"
      },
      card: {
        moreOptions: "Más opciones",
        expand: "Ampliar y evaluar la foto",
        openDetails: "Abrir los detalles",
        copyLink: "Copiar el enlace a la foto",
        seeReview: "ver la reseña",
        reportInGoogle: "Denunciar en Google",
        reportedQuestion: "¿Has podido denunciar la foto en Google?",
        reportedInGoogle: "Denunciada en Google",
        photoReportedInGoogle: "Foto denunciada en Google",
        markReported: "Marcar como denunciada",
        unmarkReported: "Deshacer la marca de denuncia",
        assessmentLabel: "Evaluación:",
        assess: "evaluar",
        change: "Cambiar evaluación",
        byAi: "Evaluación de la IA",
        byYou: "Tu evaluación",
        aiPending: "análisis de IA en curso…",
        aiFailed: "el análisis de IA ha fallado",
        aiNone: "sin evaluación de la IA",
        notAssessed: "sin evaluar"
      },
      preview: {
        close: "Cerrar la vista previa",
        infoTitle: "Información de la foto",
        addedOn: "Añadida:",
        goToReview: "ir a la reseña",
        assessmentTitle: "Evaluación de la foto",
        assessmentIntro:
          "Evaluación de si la foto incumple las políticas de Google o los estándares de tu " +
          "empresa. Las fotos marcadas como «Para denunciar» se pueden denunciar después " +
          "para su eliminación en Google.",
        deletedAssessmentIntro:
          "Esta foto se ha eliminado de Google, así que ya no se puede evaluar ni denunciar. " +
          "Todavía puedes añadir o editar su nota.",
        noPermissionAssessmentIntro: "No tienes permiso para evaluar esta foto.",
        previous: "Foto anterior",
        next: "Foto siguiente",
        justification: "Justificación de la IA:",
        reason: "Motivo:",
        reportedChip: "Foto denunciada en Google",
        reopenForm: "Abrir el formulario de nuevo",
        reportLater:
          "o hazlo más tarde. Encontrarás la foto en la sección «Para denunciar».",
        showMore: "Mostrar más",
        showLess: "Mostrar menos",
        editor: {
          reason: "Motivo (opcional)"
        },
        // Lo que ya ha ocurrido con esta foto; solo se muestran los pasos que sucedieron — la
        // única excepción es el sitio reservado a la evaluación de la IA mientras se analiza.
        timeline: {
          analysisPending: "Análisis de IA en curso…",
          analysisFailed: "El análisis de IA ha fallado",
          analysisFailedHint: "evalúa la foto manualmente",
          aiDisabled: "La verificación por IA no está incluida en tu plan",
          aiDisabledHint:
            "la IA podría evaluar estas fotos por ti; por ahora las evalúas manualmente",
          aiAwaiting: "Evaluación de la IA",
          aiVerdict: "Evaluación de la IA:",
          disagreeWithAi: "¿No estás de acuerdo con la evaluación de la IA?",
          changeAssessment: "Cambiar evaluación",
          overriddenByYou: "modificada por tu evaluación",
          reasonChanged: "Motivo modificado",
          userVerdict: "Tu evaluación:",
          reported: "Foto denunciada en Google"
        },
        accuracy: {
          question: "¿Es acertada la evaluación de la IA?",
          voteAccurate: "Evaluación acertada",
          voteInaccurate: "Evaluación no acertada",
          commentPlaceholder: "¿Por qué? (opcional)",
          send: "Enviar",
          thanks: "Gracias por tu opinión sobre el trabajo de la IA."
        }
      },
      // Los nombres y las explicaciones proceden del formulario "Denunciar contenido"
      // de Google, para que el usuario vea aquí lo mismo que verá al denunciar.
      rejectionReason: {
        sexualOffensiveOrHate:
          "Contenido ofensivo, de incitación al odio o sexualmente explícito",
        privacy: "Problemas de privacidad",
        lowQuality: "Baja calidad",
        harmfulDangerousOrViolent: "Contenido dañino, peligroso o violento",
        notDepictingPlace: "No es una foto o un vídeo del lugar",
        other: "Otros"
      },
      rejectionReasonOriginal: {
        sexualOffensiveOrHate: "Offensive, Hateful, or Sexually Explicit",
        privacy: "Privacy Concern",
        lowQuality: "Poor Quality",
        harmfulDangerousOrViolent: "Harmful, Dangerous, Violent Content",
        notDepictingPlace: "Not a Photo or Video of the Place",
        other: "Other"
      },
      rejectionReasonExplanation: {
        sexualOffensiveOrHate:
          "El contenido incluye lenguaje, gestos, imágenes o temas dañinos sobre una persona o un grupo por su identidad. El contenido incluye lenguaje, imágenes o temas que atacan personalmente a alguien concreto. El contenido incluye lenguaje, gestos, imágenes o temas obscenos o sexualmente explícitos.",
        privacy:
          "El contenido incluye datos personales, como una dirección o un número de teléfono.",
        lowQuality:
          "El contenido no viene al caso, incluye anuncios o consiste en texto sin sentido o repetitivo.",
        harmfulDangerousOrViolent:
          "Contenido que fomenta o promueve la autolesión o el uso indebido de objetos o sustancias peligrosas, o da instrucciones al respecto; o bien contenido que detalla o fomenta la violencia gráfica contra personas o animales.",
        notDepictingPlace:
          "El contenido no es una foto, un vídeo ni ninguna otra representación del lugar.",
        other:
          "El contenido presenta un problema no relacionado con las categorías anteriores."
      }
    },
    storeLocator: {
      tooltipSwitchOff:
        "La foto añadida no será visible en el Localizador de Tiendas. Puedes cambiar la visibilidad de la foto después de añadirla.",
      tooltipSwitchOn:
        "La foto añadida será visible en Localizador de Tiendas. Puedes cambiar la visibilidad de la foto después de agregarla."
    }
  },
  posts: {
    fbDialogTitle: "Selecciona la publicación de Facebook que deseas copiar",
    usedForGoogleMapsPost: "Usado para crear una publicación en Google Maps",
    copyFacebookPost: "Copiar publicación de Facebook",
    selectPage: "Seleccionar página",
    selectPost: "Seleccionar publicación",
    multimedia: "Multimedia",
    checkOriginalPost: "Ir a la publicación original",
    planning: {
      authorAndDate: "Autor y fecha de creación",
      postsFrom: "Publicaciones de",
      showAllPlannedPosts: "Mostrar todas las publicaciones programadas",
      facilitiesSendTooltip:
        "La publicación solo se enviará a las ubicaciones que formaban parte del {0} seleccionado en el momento de programarla. Las ubicaciones que se agreguen a ese {0} posteriormente no serán incluidas. Además, si pierdes permisos sobre algunas ubicaciones antes del envío, no se enviará la publicación a ellas.",
      editActionDisabledTooltip:
        "Solo el autor puede editar esta publicación.",
      deleteActionDisabledTooltip:
        "No tienes permiso para eliminar esta publicación.",
      info:
        "La publicación solo se enviará a las ubicaciones que estaban en el {0} seleccionado en el momento de programarla publicación.",
      cities: "ciudades",
      groups: "grupos",
      addPostTo: "Añadirás una publicación a",
      emptyText: "No tienes publicaciones programadas.",
      publication: {
        publicationDateTitle: "Fecha de publicación de la entrada",
        publicationDateSubtitle:
          "Selecciona una fecha y hora para publicar la entrada.",
        now: "Ahora",
        tomorrowMorning: "Mañana por la mañana",
        nextWeek: "La próxima semana",
        anotherDate: "Otra fecha"
      }
    },
    scheduledSending: "Envío programado",
    sent: "Enviado",
    list: {
      [POSTS_FORM_TYPE.POST]: "Publicación",
      [POSTS_FORM_TYPE.EVENT]: "Evento",
      [POSTS_FORM_TYPE.OFFER]: "Oferta",
      [POSTS_FORM_TYPE.ALERT]: "Actualización de COVID-19",
      creatingInProgress: "Envío en progreso",
      planned: "Programado",
      titleTooltip:
        "Aquí puedes ver la lista de publicaciones agregadas con LocalZen. Las publicaciones subidas fuera de LocalZen (en Google My Business) no serán visibles en este panel.",
      searchFieldPlaceholder: "Buscar publicaciones",
      toogleShowDeletedPosts: "Mostrar las publicaciones eliminadas",
      noPostsAlt: "No hay publicaciones",
      noPostsDescription:
        "No has publicado ninguna entrada en tus fichas durante el período seleccionado. \nAgrega una publicación a todas o a alguna de las fichas seleccionadas para incentivar a tus clientes a visitar tu tienda y posicionar tus fichas en los resultados de búsqueda de Google Maps.",
      noPhoto: "sin foto",
      clickInButton: `en el botón: "{label}"`,
      sendingInProgress: "Enviando en progreso a",
      cancellingInProgress: "Anulando en progreso",
      cancelled: "Anulado",
      sendingFinished: "Enviado",
      deletingInProgress: "Eliminación en progreso",
      deleted: "Eliminado",
      sentTo: "Enviado",
      sentDate: "Fecha de envío",
      editDate: "Editar fecha",
      deleteDate: "Eliminar fecha",
      detailsStatusSent: "Enviado {sent_count}/{total_count}",
      sentSuccessCount: "{count} publicado",
      sentErrorCount: "{count} rechazado",
      durationTime: "Tiempo de duración",
      confirmPlannedDeleteDialog: {
        text:
          "¿Estás seguro/a de que deseas eliminar esta publicación programada?"
      },
      confirmDeleteDialog: {
        text:
          "¿Estás seguro/a de que deseas eliminar la publicación de todas las ubicaciones?",
        description:
          "Esta acción eliminará las publicaciones seleccionadas en el Administrador de Perfiles de Negocio de Google. A veces, las publicaciones eliminadas pueden seguir siendo visibles en Google Maps durante un breve período (se eliminan con cierto retraso). Este comportamiento está relacionado con los algoritmos de Google y puede ocurrir incluso si las publicaciones se eliminan directamente desde el panel de Google (Administrador de Perfiles de Negocio). Afortunadamente, esta situación no es común."
      },
      confirmCancelPostDialog: {
        text: "¿Estás seguro/a de que deseas cancelar la publicación?",
        description:
          "Esta acción cancelará todas las publicaciones que estén en proceso de envío, y las publicaciones que ya hayan sido publicadas se eliminarán. A veces, las publicaciones eliminadas pueden seguir siendo visibles en Google Maps durante un tiempo (Google las elimina con retraso). Esto se debe a cómo funcionan los algoritmos de Google y no depende de si la publicación se eliminó en LocalZen o en el panel de Google. Afortunadamente, esta situación ocurre rara vez."
      },
      facilitiesDialog: {
        defaultTitle: "Publicación enviada a las siguientes ubicaciones",
        [POST_BY_FACILITY_STATUS.OK]: {
          title: "Publicación enviada a las siguientes ubicaciones"
        },
        [POST_BY_FACILITY_STATUS.FAILED]: {
          title: "Publicación no enviada a las siguientes ubicaciones"
        },
        fixError: { general: "Contáctanos" }
      }
    },
    add: {
      [POSTS_FORM_TYPE.POST]: "Agregar publicación",
      [POSTS_FORM_TYPE.EVENT]: "Agregar evento",
      [POSTS_FORM_TYPE.OFFER]: "Agregar oferta",
      [POSTS_FORM_TYPE.ALERT]: "Actualización sobre COVID-19"
    },
    addTime: "Agregar tiempo",
    alertHeader: "Notifica a tus clientes",
    facilityLabel:
      "Selecciona las ubicaciones a las que quieres agregar la publicación",
    facilitiesAll: "todas las ubicaciones (verificadas)",
    facilitiesAllUnverified: "todas las ubicaciones",
    facilitiesAllTooltip:
      "Las publicaciones solo se pueden enviar a ubicaciones verificadas en Google Maps.",
    facilitiesSelected: "ubicaciones seleccionadas (verificadas)",
    facilitiesSelectedUnverified: "ubicaciones seleccionadas",
    facilitiesSelectedTooltip:
      "Las publicaciones solo se pueden enviar a ubicaciones verificadas en Google Maps. Solo esas ubicaciones aparecen en la lista del diálogo abierto.",
    mainPhoto: "Foto principal",
    offerName: "Nombre de la oferta",
    postName: "Contenido de la publicación",
    eventName: "Nombre del evento",
    alertName: "Actualiza tu estado",
    startDate: "Fecha de inicio",
    endDate: "Fecha de finalización",
    startTime: "Hora de inicio",
    endTime: "Hora de finalización",
    offerDetails: "Detalles de la oferta",
    offerCode: "Vale (opcional)",
    offerLink: "Enlace a la oferta (opcional)",
    offerTerms: "Términos (opcional)",
    showExtra: "Agregar más detalles (opcional)",
    publish: "Publicar",
    publishFor: "Publicar para {0}",
    preview: "Vista previa",
    schedule: "Detalles del evento",
    postUrl: "URL",
    callToAction: {
      label: "Agregar botón (opcional)",
      [POSTS_CALL_TO_ACTION_TYPE.BOOK]: "Libro",
      [POSTS_CALL_TO_ACTION_TYPE.ORDER]: "Pedir en línea",
      [POSTS_CALL_TO_ACTION_TYPE.SHOP]: "Comprar",
      [POSTS_CALL_TO_ACTION_TYPE.LEARN_MORE]: "Más información",
      [POSTS_CALL_TO_ACTION_TYPE.SIGN_UP]: "Regístrate",
      [POSTS_CALL_TO_ACTION_TYPE.CALL]: "Llama ya"
    },
    alertTitle: "¿Cambios en tu negocio?",
    alertSubtitle:
      "Informa a tus clientes sobre cambios recientes en tu negocio debido a las restricciones por COVID-19.",
    noData: {
      button: "Agregar cuenta",
      title: "Agregar publicación a ubicaciones en Google Maps",
      desc:
        "Aquí puedes añadir publicaciones a todos tus perfiles de ubicación en Google Maps. Solo necesitas ingresar el contenido una vez, y nosotros lo enviaremos automáticamente a las ubicaciones seleccionadas o a todas tus ubicaciones comerciales. Esto puede ahorrarte mucho tiempo y esfuerzo. Para utilizar esta funcionalidad, importa tus ubicaciones vinculando tu cuenta de Google con LocalZen."
    },
    addImage: "Agregar foto",
    addImageTooltip:
      "La foto debe estar en formato PNG o JPG. La proporción recomendada de la foto es 4:3. La resolución mínima es de 400 x 300 px y el tamaño debe ser de 10 kB. La resolución máxima recomendada es de 8000 x 6000 px y el tamaño de 10 MB.",
    postSuccess: "La publicación fue enviada. Aparecerá pronto en Google Maps.",
    postPlannedSuccess:
      "La publicación fue enviada. Debería aparecer en Google Maps {0}.",
    select: "Seleccionar",
    facilitiesError: "Por favor, selecciona al menos una ubicación.",
    facilitiesRequired:
      "Por favor, selecciona donde quieres agregar la publicación",
    published: "Publicado",
    selectedFacilities: "{facilitiesCount} seleccionados",
    selectedCities: "{citiesCount} seleccionados ({facilitiesCount})",
    selectedFacilitiesGroups:
      "{facilitiesGroupsCount} seleccionados ({facilitiesCount})",
    changeButton: "Cambiar",
    viewButton: "Ver",
    facilitiesToAddDialog: {
      title: "La publicación se enviará a las siguientes ubicaciones",
      noFacilities: "No se han elegido ubicaciones"
    },
    successfullyDeleted: "La publicación fue eliminada.",
    successfullyCancelled: "La publicación fue cancelada.",
    storeLocator: {
      visibilityStatus: "Estado de la publicación en el Localizador de Tiendas",
      tooltipSwitchOff:
        "La publicación agregada no será visible en el Localizador de Tiendas. La visibilidad de la entrada puede cambiarse después de haber sido añadida.",
      tooltipSwitchOn:
        "La publicación agregada será visible en el Localizador de Tiendas. La visibilidad de la entrada puede cambiarse después de haber sido añadida."
    },
    postVisibility: "Publicación visible",
    visibleGoogleMaps: "Para Google Maps",
    visibleStoreLocator: "En el Localizador de Tiendas"
  },

  searchKeywords: {
    title: "Palabras clave buscadas",
    dateNoDataTooltip: "No hay datos disponibles para este período",
    dataAvailableFromTooltip: "Los datos estarán disponibles el {date}",
    selectKeyword: "Seleccionar palabra clave",
    searches: "Búsquedas",
    searchesCertain: "Búsquedas (seguras)",
    searchesUncertain: "Búsquedas (inciertas)",
    searchesUncertainty: "Rango de incertidumbre",
    position: "Posición",
    positionLabel: "Posición (1 = mejor)",
    outsideTop20: "fuera del top 20",
    dateFrom: "Fecha desde",
    dateTo: "Fecha hasta",
    tooltipSearchesEstimate: "Búsquedas: {min} - {max} (estimado)",
    tooltipSearchesExact: "Búsquedas: {value}",
    tooltipPosition: "Posición: {position}",
    summaryTitle: "Resumen de búsquedas",
    topKeywordsTitle: "Top 5 palabras clave más buscadas",
    totalSearches: "Búsquedas totales",
    totalSearchesDescription:
      "Número de búsquedas en las que se mostró tu empresa.",
    other: "Otros",
    otherKeywords: "Otras palabras clave",
    keywordsTableTitle: "Lista de palabras clave",
    keyword: "Palabra clave",
    searchCount: "Número de búsquedas",
    listings: "Listados",
    avgPosition: "Pos. media",
    avgPositionTooltip:
      "Posición media de los listados seleccionados en los resultados de búsqueda de Google Maps",
    monitor: "Monitorear",
    monitored: "Monitoreado",
    estimated: "El valor real se encuentra dentro del rango presentado",
    chartTitle: "Análisis de búsquedas y posición",
    tracked: "Monitoreo de posición",
    noData: "No hay datos para mostrar",
    emptyState: "No hay datos sobre las palabras clave buscadas.",
    phrasesFound: "{count} frases",
    totalImpressions: "{count} impresiones",
    showExactData: "Incluir datos inciertos",
    viewBreakdown: "Ver desglose",
    breakdownByCity: "Por ciudades",
    breakdownByGroup: "Por grupos",
    breakdownByListing: "Por listados",
    topPhrases: "Máx. top 100 frases",
    topKeywordHighlight: "representa el {percentage}% de las búsquedas",
    impressionsInSearch: "impresiones en búsqueda",
    uniqueKeywords: "palabras clave únicas",
    monitoredKeywords: "palabras clave monitoreadas",
    infoTitle: "Información",
    infoBoxText:
      'Los datos presentados tienen cierto nivel de incertidumbre. Cuando un listado para una palabra clave aparece en los resultados de búsqueda menos de 15 veces, Google no proporciona el valor exacto. En estos casos, LocalZen tiene en cuenta los números mínimos y máximos posibles de búsquedas, determinando un rango de incertidumbre — presentado como dos valores límite: inferior <b>(min)</b> y superior <b>(max)</b>. Según el modo de visualización de datos seleccionado, verás un número redondeado de búsquedas o este rango. Puedes alternar entre modos usando el botón <b>"Mostrar datos exactos"</b>.',
    infoExampleLabel: "Ejemplo",
    infoExampleIntro:
      'El usuario tiene 3 listados (<b>A</b>, <b>B</b>, <b>C</b>). Para la palabra clave <i>"fast food"</i> Google proporciona los siguientes datos:',
    infoExampleListingA: "<b>Listado A</b>: <15 búsquedas",
    infoExampleListingB: "<b>Listado B</b>: 20 búsquedas",
    infoExampleListingC: "<b>Listado C</b>: 30 búsquedas",
    infoExampleApproximate: "valor aproximado",
    infoExampleExact: "valor exacto",
    infoExampleExplanation:
      "Para el listado <b>A</b>, el número real de búsquedas se encuentra en el rango de 1 a 15. Los valores límite se calculan mediante la fórmula:",
    infoRoundedExplanation:
      "Para valores inciertos (aproximados), solo se tiene en cuenta el límite inferior del rango. El número total de búsquedas se calcula mediante la fórmula:",
    infoExampleTotal: "total",
    infoIntroText:
      "<p>Aquí encontrarás información sobre qué palabras clave (keywords) y cuántas veces aparecieron tus listados en los resultados de búsqueda de Google. Al introducir estas palabras clave en el buscador, los usuarios vieron tus listados.</p><p>Los datos proporcionados por Google a veces son inciertos — para facilitar la interpretación, mostramos solo datos seguros por defecto.</p>",
    readHowToUseLink: "Lee cómo utilizar estos datos en la práctica",
    howToUseDialogTitle: "¿Cómo utilizar estos datos?",
    howToUseDialogContent:
      '<ul><li>Presta atención a las palabras clave no relacionadas con tu marca (palabras clave no de marca). Son palabras clave que muestran qué y cómo busca la gente (p. ej. productos o servicios específicos).</li><li>Las palabras clave que son importantes para ti pero no están en la lista (o tienen pocas impresiones de listado) son buenos candidatos para acciones de marketing.</li><li>Monitorea tu posición en los resultados de búsqueda para palabras clave importantes. De esta manera puedes, por ejemplo, encontrar palabras clave con una posición baja pero un alto número de impresiones de listado. Estas son palabras clave que, una vez mejorada su posición, tienen gran potencial para más impresiones.</li></ul><p class="dialog-subheader"><strong>¿Qué acciones de marketing vale la pena tomar?</strong></p><ul><li>Añade categorías de negocio, servicios o publicaciones con palabras clave importantes a tus listados.</li><li>Anima a los clientes a escribir reseñas sobre temas que contengan naturalmente palabras clave importantes para ti.</li></ul>',
    howDataIsPresented: "¿Cómo presentamos los datos?",
    dataUncertaintyIntro:
      'Algunos datos proporcionados por Google son inciertos (p. ej. se devuelven como "<15 impresiones").',
    dataDisplayModeAHeader:
      'Cuando la opción "Incluir datos inciertos" está desactivada:',
    dataDisplayModeA: "Solo se muestran datos seguros.",
    dataDisplayModeBHeader:
      'Cuando la opción "Incluir datos inciertos" está activada:',
    dataDisplayModeB:
      "Se muestran tanto datos seguros como inciertos. Los datos se muestran como un rango mín-máx. El límite inferior del rango representa datos seguros, mientras que el límite superior se incrementa con datos inciertos."
  },

  reviews: {
    reportInGoogle: "Denunciar reseña en Google",
    openInGoogleMaps: "Abrir reseña en Google Maps",
    cannotEditOptimisticReply:
      "Estamos procesando tu respuesta. La edición será posible pronto.",
    cannotDeleteOptimisticReply:
      "Estamos procesando tu respuesta. La eliminación será posible pronto.",
    morePhotos: "más fotos",
    moreMedia: "más contenido multimedia",
    brokenPhoto: "No se puede cargar la foto.",
    brokenVideo: "No se puede cargar el vídeo.",
    reviewPhotosTitle: "Fotos de la reseña",
    reviewVideosTitle: "Vídeos de la reseña",
    reviewMediaTitle: "Fotos y vídeos de la reseña",
    facilityPhotosTitle:
      "Fotos del autor en esta ubicación no relacionadas con la reseña",
    facilityPhotosTooltip:
      "Estas fotos no están directamente asociadas con esta reseña — pueden haber sido añadidas por el autor a esta ubicación en otra ocasión o estar asignadas a una versión anterior de la reseña.",
    aiReply: {
      packetCloseToLimitTooltip:
        "Para aumentar tu paquete, por favor contáctanos",
      onlyTextTooltip: "Puede usarse solo para reseñas con texto",
      outOfLimitTooltip:
        "Este mes, no es posible generar respuestas utilizando IA, ya que se ha agotado el paquete disponible. El paquete se renovará al inicio del mes. Para aumentar tu paquete, por favor contáctanos.",
      error: "Respuesta de error de la IA",
      replyWithAi: "Responde con IA",
      generateAgain: "Generar de nuevo",
      repliesLeft: "Respuestas restantes",
      generateWithAi: "Generando respuesta con IA",
      settingsAiReply: "Configuración de respuesta de Ia IA",
      instructionsForAi: "Instrucciones para la IA",
      aiSettingsTip1:
        "Cómo funciona: Aquí puedes ingresar opcionalmente instrucciones adicionales que la IA utilizará al generar sugerencias de respuesta para reseñas. Las instrucciones pueden referirse a cualquier aspecto, como el estilo de habla, el uso de palabras o frases específicas, etc. A continuación, se muestra un ejemplo de dichas instrucciones.",
      aiSettingsTip2: `Usa un lenguaje formal pero dirígete al autor de la reseña de manera informal. Añade siempre estas frases al final: "¡Gracias por comprar en nuestra tienda! ¡Esperamos tu próxima visita!"`
    },
    findPhrase: "Encontrar frase",
    periods: {
      daily: "Diario",
      weekly: "Semanalmente",
      monthly: "Mensualmente",
      yearly: "Anualmente"
    },
    chart: {
      averageRateForCategory:
        "Tasa promedio en la categoría “{0}” durante el período indicado",
      reviewsCountForCategory:
        "Recuento de reseñas en la categoría “{0}” durante el período indicado"
    },
    dialogs: {
      howDoesAutomaticCategorizationWork:
        "¿Cómo funciona la categorización automática?",
      contact: "Contáctanos",
      autoCategorizeOldReviews:
        "Después de habilitar la categorización automática, las categorías se asignarán solo a las nuevas reseñas (es decir, aquellas que se publiquen en el futuro). Si también deseas categorizar automáticamente las reseñas antiguas, por favor contáctanos.",
      addPhrasesToCategoryTitle: "Agregar frases a la categoría",
      addPhrasesToCategoryContent: `Agrega frases a la categoría (por ejemplo, "caro" a la categoría Precio). Gracias a ello, el sistema podrá asignar automáticamente esta categoría a la reseña.`,
      alertBeforeActionFirstLine: `Has realizado los siguientes cambios en la categoría “{0}”:`,
      alertBeforeActionLastLine: `¿Está seguro/a de que desea guardar los cambios? Estos afectarán tanto a las reseñas existentes como a las futuras que contengan las siguientes frases.`,
      autoCategorizationTitle: `Clasificación automática de reseñas y análisis de sentimiento`,
      autoCategorizationContent: `Center Al puede asignar automáticamente categorías (por ejemplo, "atención al cliente") a cada reseña relacionada, mediante el análisis de su contenido. Además, para cada categoría detectada, se determina el sentimiento asociado, indicando el tono emocional (positivo, neutral o negativo).<br /><br /> Para utilizar la categorización automática y el análisis de sentimiento, solo necesitas:<br /><br />• Definir las categorías que deben detectarse. El sistema solo asignará reseñas a las categorías añadidas manualmente en Center Al (no detecta categorías adicionales por sí solo).<br />• Habilitar la categorización automática de reseñas y el análisis de sentimiento para las categorías seleccionadas.<br /><br /> Ambas acciones se pueden realizar desde la pantalla de gestión de categorías.`,
      manageAlerts: {
        add: `Has añadido {0} frases.`,
        delete: `Has eliminado {0} frases.`,
        update: `Has actualizado {0} frases.`
      },
      alertAfterEditTitle: ``,
      alertAfterEditContent: `Has realizado cambios en las frases para la categoría “{0}”, pero no has activado la categorización automática. </br> <b> ¿Quieres habilitar la categorización automática para esta categoría? </b>`
    },
    allPhrases: "Todas las frases",
    autCategorizationEnabled: "La categoría fue asignada automáticamente.",
    autoCategorizationLabel:
      "La categoría tiene la categorización automática habilitada.",
    autoCategorization: "Categorización automática",
    allCategories: "Todas las categorías",
    phraseList: "Lista de frases",
    categoryAssignTitle: "¿Sobre qué tratan estas opiniones?",
    categoryAssignSubtitle:
      "Selecciona las categorías que deseas asignar a las reseñas seleccionadas.",
    enterNewCategory: "Ingresar nueva categoría",
    enterNewPhrase: "Introduce nueva frase",
    reviews: "Reseñas",
    reviewsList: "Lista de reseñas",
    selected: "Elementos seleccionados:",
    reviewsWith: "Reseñas:",
    replyPublished: "Respuesta publicada",
    replyRejected: "Respuesta rechazada",
    alreadyReplied: "Esta reseña ya ha sido respondida",
    reviewNotFound: "Esta reseña no ha sido encontrada",
    header: "Reseñas de lugares",
    all: "Todo",
    tip:
      "Aquí puedes ver todas las reseñas de cada una de tus ubicaciones. Puedes elegir responder a una o varias reseñas a la vez utilizando una plantilla de respuesta. Para encontrar rápidamente reseñas específicas por palabra clave o incluso una frase completa, usa nuestro navegador a continuación o el filtro en la esquina derecha. Asegúrate de responder primero a las “reseñas más relevantes“, ya que se encuentran en la parte superior de los resultados de búsqueda de Google Maps.",
    answered: "Respondido",
    answer: "Responder",
    assignCategories: "Asignar categorías",
    answerBtn: "Responde ahora",
    unanswered: "Sin respuesta",
    onlyComments: "Solo reseñas con contenido",
    onlyNotes: "Solo reseñas con una nota",
    hasCustomerMedia: "Solo reseñas con fotos",
    hasReviewVideos: "Solo reseñas con vídeos",
    hasRbReview: "Solo reseñas de Review Booster",
    showDeletedReviews: "Incluir reseñas eliminadas",
    showHiddenReviews: "Incluir reseñas ocultas",
    onlyUpdated: "Solo reseñas editadas durante el período seleccionado",
    onlyCreated: "Solo reseñas creadas durante el período seleccionado",
    addedToGoogle: "Añadido a Google Maps",
    writtenWithAI: "Escrito con IA",
    onlyNoComments: "Solo reseñas sin contenido",
    onlyAccurate: "Solo las reseñas más relevantes",
    opinions: "Reseñas",
    actions: "Acciones",
    noComment: "El usuario solo ingresó una calificación.",
    noData:
      "No se han encontrado reseñas en tus fichas para el período seleccionado. Selecciona un rango de fechas diferente o espera a que se recojan nuevas reseñas.",
    totalReviewsCount: "Todas las reseñas: {0}",
    withReplyReviewsCount: "Con respuesta: {0}",
    withoutReplyReviewsCount: "Sin respuesta: {0}",
    percentageOfAllReviews: "{0}% de todas las reseñas",
    yourAnswer: "Tu respuesta",
    publishAnswer: "Publicar respuesta",
    reviewsAIReplyList: "Lista de reseñas con respuestas de IA",
    suggestedAnswerByAI: "Respuesta sugerida por la IA",
    noSuggestedAnswerByAI:
      "Por el momento, no hay respuestas sugeridas por la IA para esta opinión.",
    cancel: "Cancelar",
    edit: "Editar",
    editAndResend: "Editar y reenviar",
    delete: "Borrar",
    deleteGoogleNotAllowed:
      "Google no permite eliminar respuestas a las reseñas",
    filter: "Filtrar",
    owner: "Respuesta del propietario",
    city: "Ciudad",
    cities: "Ciudades",
    facilities: "Ubicaciones",
    facilitiesGroups: "Grupos de ubicaciones",
    rating: "Calificación",
    save: "Guardar",
    dateRange: "Intervalo de fechas",
    more: "Más",
    addedLabel: "Añadido",
    deletedLabel: "Revisión eliminada",
    hiddenLabel: "Reseña oculta",
    hideReview: "Ocultar reseña",
    unhideReview: "Deshacer ocultación",
    moreOptions: "Más opciones",
    reviewHidden: "La reseña se ha ocultado.",
    undoHide: "Deshacer",
    accurateLabel: "Reseña más relevante",
    accurateTooltip:
      "Las reseñas más relevantes son aquellas que Google destaca y muestra en la página principal de tu ficha de Google Maps. Estas son las reseñas que tus clientes ven primero.",
    search: "Buscar ubicaciones",
    searchCity: "Buscar ciudad",
    searchFacilitiesGroups: "Grupos de ubicaciones de búsqueda",
    deleteReplyConfirm: "¿Está seguro/a de que deseas eliminar la respuesta?",
    userDataHidden: "Los datos del usuario están ocultos.",
    noFacilities: {
      button: "Agregar cuenta",
      title: "Ver y responder a las opiniones de tus clientes",
      desc:
        "Aquí puedes consultar fácilmente las reseñas de tus clientes en Google Maps y comunicarte con ellos. Para utilizar esta funcionalidad, importa tus ubicaciones añadiendo tu cuenta de Google."
    },
    analyst: {
      title: "Análisis de calificaciones",
      subtitleSummary: "Resumen",
      subtitleSummaryTooltip:
        "Este panel te permite consultar todas las calificaciones de Google Maps recopiladas desde que se crearon tus ubicaciones. Aquí puedes comparar las calificaciones en distintos periodos para obtener conclusiones sobre cómo perciben los clientes tu negocio, tanto en contextos específicos como de forma general. Permite que tus gerentes regionales o de tienda accedan a esta función para que puedan monitorear la retroalimentación de los clientes e implementar las mejoras necesarias.",
      subtitleRatings: "Distribución de calificaciones",
      subtitleRatingsTooltip:
        "Resumen de calificaciones de las ubicaciones seleccionadas durante el período de tiempo especificado.",
      subtitleComparison: "Datos de ubicaciones",
      subtitleHistory: "Historia",
      averageRating: "Calificación promedio",
      averageRatingTooltip:
        "La calificación promedio de las ubicaciones seleccionadas dentro del período de tiempo específico.",
      totalRatingCount: "Calificaciones en total",
      noDataDescription:
        "Actualmente estamos recopilando datos. La información estará disponible en aproximadamente 1 hora.",
      totalRatingCountTooltip:
        "Número total de calificaciones de ubicaciones seleccionadas dentro del período de tiempo específico.",
      gmbAddress: "Ubicación",
      averageRatingFromBegin: "Calificación promedio en total",
      ratingCountFromBegin: "Calificaciones en total",
      currentYearRatingCount: "Calificaciones en el año actual",
      newRatingCount: "Calificaciones en total",
      repliedCount: "Número de respuestas",
      repliedPercentage: "% de respuestas",
      reviews: "Calificaciones",
      selectedPeriod: "Período seleccionado ({0})",
      period: "Periodo",
      comparedPeriod: "Período comparado ({0})",
      allReviews: "Todas las calificaciones",
      noFacilities: {
        title:
          "Consultar estadísticas sobre las calificaciones de tus clientes",
        desc:
          "Aquí puedes analizar las calificaciones de Google Maps sobre tus ubicaciones, revisando la distribución de valoraciones dentro de un período seleccionado y comparándolas con el período anterior. Para utilizar esta funcionalidad, importa tus ubicaciones agregando una cuenta al Administrador de Perfiles de Negocio de Google."
      },
      includedRatings: "Calificaciones incluidas",
      allRatingsIncluded:
        "Todas las calificaciones añadidas o editadas en el período seleccionado.",
      newRatingsIncluded:
        "Solo las calificaciones añadidas durante el período seleccionado. Las calificaciones editadas en este período no están incluidas.",
      editedRatingIncluded:
        "Solo las calificaciones editadas durante el período seleccionado. Las calificaciones añadidas en este período no están incluidas."
    },
    replyTemplates: {
      title: "Plantillas de respuesta",
      use: "Usar",
      useTemplate: "Usar plantilla",
      chooseTemplate: "Seleccionar plantilla de respuesta",
      replyError: "Error al enviar la respuesta",
      reviewUnavailable:
        "La respuesta no se envió porque la reseña no está disponible actualmente en Google. Hemos guardado el contenido y volveremos a intentarlo si la reseña reaparece.",
      googleAccountUnavailable:
        "La respuesta no se envió debido a un problema con la conexión de la cuenta de Google. Hemos guardado el contenido y volveremos a intentarlo cuando se restablezca la conexión.",
      categories: {
        noCategoriesDescription:
          "Añade y categoriza plantillas de respuesta para mejorar tu efectividad al responder a las reseñas de tus clientes.",
        [DIALOG_MANAGE_MODE.ADD]: "Agregar categoría",
        [DIALOG_MANAGE_MODE.EDIT]: "Editar categoría",
        categoryNamePlaceholder: "Nombre de la categoría",
        category: "Nombre de categoría",
        repliesCount: "Total de plantillas",
        createdBy: "Creado por",
        viewButton: "Ver plantillas",
        save: "Guardar"
      },
      templates: {
        [DIALOG_MANAGE_MODE.ADD]: "Agregar plantilla",
        [DIALOG_MANAGE_MODE.EDIT]: "Editar plantilla",
        category: "Categoría",
        templateTextPlaceholder: "Texto de respuesta",
        noTemplates: "No hay plantillas de respuesta en esta categoría",
        backToList: "Atrás",
        save: "Guardar"
      }
    },
    tags: {
      changesSavedAutomatically:
        "Todas las modificaciones realizadas se guardan automáticamente",
      activeTags: "Categorías activas",
      inactiveTags: "Categorías inactivas",
      tags: "Categorías",
      manageTagsBasic: "Gestionar categorías",
      manageTags: "Gestionar categorías de reseñas",
      typeNewTag: "Introducir una nueva categoría",
      addedTags: "Categorías añadidas",
      noTagsDescription: "Aún no tienes ninguna categoría.",
      noTagsFilterDialogText:
        "Actualmente no tienes ninguna categoría añadida. Añade alguna para poder filtrarla.",
      addDescription:
        "Escríbelas en el campo de arriba, pulsa Enter o haz clic en 'Agregar' para añadirlas a tu lista de categorías.",
      selectTagsDescription:
        "Haz clic en las categorías anteriores para añadirlas a la opinión seleccionada.",
      selectTags: "Seleccionar categorías",
      selectTag: "Seleccionar categoría",
      selected: "Seleccionada",
      reviewTags: "¿De qué trata esta reseña?",
      noTagsAssigned: "No hay categorías asignadas",
      noTagsSelected: "No hay categorías seleccionadas",
      noTagsAvailable:
        "Para añadir una categoría a tu reseña, primero debes definir las categorías disponibles.",
      defineTagsHere: "Define categorías aquí",
      noPermissions:
        "No tienes permisos para definir categorías de reseñas. \nContacta al administrador de la cuenta o al propietario.",
      tagDeleteAlert:
        "¿Está seguro/a de que deseas eliminar la categoría <b>{0}</b>? También se eliminará de todas las reseñas."
    },
    bulkReply: {
      heading: "Respuesta en lote",
      btnLabel: "Respuesta en lote",
      infoBoxLabel:
        "Agregaremos la respuesta siguiente a cada una de las reseñas seleccionadas.",
      infoBoxLabel2:
        "Las reseñas que ya tienen una respuesta se omitirán (las respuestas no se cambiarán).",
      bulkReplyPlaceholder: "Tú respuesta",
      saveBtnLabel: "Publicar respuesta",
      replyInProgress: "Envío de respuesta en progreso",
      replyInProgressTooltip:
        "Su respuesta se está publicando en Google Maps. No tomará mucho tiempo. Para verificar si la respuesta se ha publicado, actualiza esta página o regresa en unos minutos.",
      selectCustomReply: "Ingresa manualmente",
      selectTemplateReply: "Elige plantillas de respuesta",
      templateInfoBoxLabel:
        "Si eliges más de una plantilla, asignaremos las respuestas al azar",
      category: "Categoría",
      all: "Todo"
    },
    sort: "Ordenar",
    ratingDesc: "Calificación: de mayor a menor",
    ratingAsc: "Calificación: de menor a mayor",
    createDateDesc: "Fecha: más reciente primero",
    createDateAsc: "Fecha: más antigua primero",
    selectedPeriod: "Período seleccionado",
    categories: {
      showOnlyAutoAssignedCategories:
        "Mostrar solo categorías asignadas automáticamente",
      ratingsInCategory: "Calificaciones en la categoría {0}",
      averageRateTooltip: "Calificación promedio",
      allLocations: "Todas las ubicaciones",
      selectLocations: "Seleccionar ubicaciones",
      locationsGroup: "Grupo de ubicaciones",
      facilitySearchLabel: "¿Qué ubicación estás buscando?",
      groupSearchLabel: "¿Qué grupo de ubicaciones estás buscando?",
      citySearchLabel: "¿Qué ciudad estás buscando?",
      selectedPeriod: "Periodo seleccionado",
      comparedPeriod: "Período comparado",
      sentiment: "Sentimiento",
      generalSentiment: "Sentimiento general",
      sentimentChange: "Confirmar cambio",
      changeAnyway: "Cambiar",
      makeChange: "Cambiar",
      sentimentChangeAlert: `La categoría y el sentimiento fueron asignados automáticamente por nuestro asistente de IA en función del contenido de la reseña. Si crees que la asignación es incorrecta, puedes cambiarla. ¿Te gustaría hacer algún cambio?`,
      sentimentRateInPeriod: `Tasa de sentimiento en la categoría "{0}" durante el período comparado`,
      gridColumns: {
        cities: "Ciudades",
        groups: "Grupos",
        facilities: "Ubicaciones",
        categories: "Categoría",
        averageRateInPeriod: "Tasa promedio en el período",
        countInComparisonPeriod: "Número de opiniones en el período comparado",
        reviewsCount: "Opiniones en total",
        averageRateInComparisonPeriod: "Tasa promedio en el período comparado",
        averageRateFromBeginning: "Tasa promedio desde el inicio",
        reviewsCountInPeriod: "Opiniones en total",
        rates: "Calificaciones",
        actions: "Acciones",
        sentiment: {
          sentimentScoreTooltip: `NSS (Net Sentiment Score). NSS te permite evaluar el sentimiento general de las reseñas. Su valor varía de -100 (cuando todas las reseñas tienen un sentimiento negativo) a 100 (cuando todas tienen un sentimiento positivo). El NSS se calcula con la fórmula: (porcentaje de reseñas con sentimiento positivo) - (porcentaje de reseñas con sentimiento negativo).`,
          positive: "Sentimiento positivo",
          negative: "Sentimiento negativo",
          neutral: "Sentimiento neutral",
          unassigned: "Sentimiento no asignado",
          sentimentInSelectedPeriod: "Sentimiento en el periodo seleccionado",
          sentimentInComparisonPeriod: "Sentimiento en el período comparado",
          sentimentFromBeginning: "Sentimiento desde el inicio"
        }
      },
      citySearchPlaceholder: "¿Qué ciudad estás buscando?",
      groupSearchPlaceholder: "¿Qué grupo estás buscando?",
      facilitySearchPlaceholder: "¿Qué ubicación estás buscando?",
      appSearchPlaceholder: "¿Qué app estás buscando?",
      appsRatesInPeriodTitle: "Reseñas en apps",
      title: "Análisis de categorías de reseñas",
      dataFor: "Datos para",
      allFacilities: "Todas las ubicaciones",
      allApps: "Todas las apps",
      selectFacilities: "Seleccionar ubicaciones",
      selectedRange: "En el rango seleccionado",
      fromBegin: "Desde el principio",
      inGivenPeriod: "En el período comparado",
      averageRate: "Calificación promedio",
      reviewsCount: "Número de reseñas",
      ratings: "Calificación",
      positive: "Positivo",
      negative: "Negativo",
      chartDescription: `El mapa de calor a continuación muestra las reseñas de los clientes clasificadas por categorías. Cuanto más grande es el rectángulo, mayor es la cantidad de reseñas compartidas. El color indica la calidad de las reseñas, según la leyenda que aparece abajo (de verde oscuro —mejor— a rojo oscuro —peor—).`,
      compare: "Comparar",
      comparedTo: "en comparación con",
      categorySearchLabel: "¿Qué categoría estás buscando?",
      averageRateHigherTooltip: `La calificación promedio durante el período seleccionado muestra una mejora con respecto al inicio.`,
      sentimentRateHigherTooltip: `El sentimiento durante el período seleccionado mejoró en comparación con el sentimiento desde el inicio.`,
      sentimentRateComparisonHigherTooltip: `El sentimiento en el período seleccionado muestra una mejora con respecto al sentimiento desde el inicio.`,
      countRateHigherTooltip: `La cantidad de calificaciones en el período seleccionado aumentó con respecto al período comparado.`,
      averageRateLowerTooltip: `La calificación promedio durante el período seleccionado empeoró en comparación con la calificación promedio desde el inicio.`,
      sentimentRateLowerTooltip: `El sentimiento durante el período seleccionado empeoró en comparación con el promedio desde el inicio.`,
      sentimentRateComparisonLowerTooltip: `El sentimiento durante el período seleccionado empeoró en comparación con el promedio desde el inicio.`,
      countRateLowerTooltip: `La cantidad de calificaciones en el período seleccionado disminuyó respecto al período comparado.`,
      ratesInPeriodTitle: "Reseñas en categorías",
      facilitiesRatesInPeriodTitle: "Calificaciones en instalaciones",
      filters: {
        custom: "Personalizado",
        yesterday: "Ayer",
        today: "Hoy",
        last7Days: "Últimos 7 días",
        last30Days: "Últimos 30 días",
        last90Days: "Últimos 90 días",
        last180Days: "Últimos 180 días",
        last365Days: "Últimos 365 días",
        lastWeek: "Semana pasada",
        lastMonth: "Mes anterior",
        lastQuarter: "Trimestre anterior",
        last6Months: "Últimos 6 meses",
        lastYear: "Año anterior",
        fromBeginning: "Desde el principio",
        previousTerm: "Período anterior",
        previousYear: "Año anterior"
      },
      facilityDialog: {
        title: "Seleccionar ubicación",
        allFacilitiesTitle: `Mostrar todas las ubicaciones de una empresa:`,
        allFacilitiesFooter: `El usuario siempre tendrá acceso a todas las fichas comerciales, incluidas las que se agreguen a la empresa en el futuro.`
      }
    }
  },
  twoFactor: {
    loginTitle: "Verificación en dos pasos",
    loginDescription:
      "Introduce el código de tu aplicación Authenticator para completar el inicio de sesión.",
    authenticatorCode: "Código de Authenticator",
    backupCode: "Código de respaldo",
    challengeExpires: "Tiempo restante: {time}",
    challengeExpired:
      "La solicitud de verificación ha caducado. Vuelve al inicio de sesión con contraseña.",
    verifyAndLogin: "Verificar e iniciar sesión",
    useBackupCode: "Usar un código de respaldo",
    useAuthenticatorCode: "Usar un código de Authenticator",
    backToPassword: "Volver al inicio de sesión con contraseña",
    settingsTitle: "Autenticación de dos factores (2FA)",
    settingsDescription:
      "Protege el inicio de sesión con contraseña mediante un código adicional de una aplicación Authenticator.",
    helpLink: "Más información",
    statusLoadFailed: "No se ha podido cargar el estado actual de 2FA.",
    enabled: "2FA activado",
    disabled: "2FA desactivado",
    backupCodesRemaining: "Códigos de respaldo restantes: {count}",
    regenerateBackupCodes: "Generar nuevos códigos de respaldo",
    disable: "Desactivar 2FA",
    disabledDescription:
      "Una vez activado, se te pedirá un código de Authenticator cada vez que inicies sesión con contraseña.",
    enable: "Activar 2FA",
    setupTitle: "Configurar 2FA",
    confirmPasswordDescription:
      "Por seguridad, confirma la contraseña actual de tu cuenta LocalZen.",
    currentPassword: "Contraseña actual",
    existingAuthenticator:
      "Esta cuenta ya tiene una aplicación Authenticator configurada. Introduce su código actual; no necesitas escanear otro QR.",
    scanQrDescription:
      "Escanea el código QR con tu aplicación Authenticator e introduce el código generado.",
    manualEntryDescription: "Si no puedes escanear el QR, introduce esta clave manualmente:",
    disableTitle: "Desactivar 2FA",
    disableDescription:
      "Confirma tu contraseña y el código actual. Los códigos de respaldo quedarán invalidados.",
    regenerateTitle: "Nuevos códigos de respaldo",
    regenerateDescription:
      "Confirma tu contraseña y el código actual. Todos los códigos de respaldo anteriores quedarán invalidados.",
    generate: "Generar",
    backupCodesTitle: "Guarda tus códigos de respaldo",
    backupCodesDescription:
      "Los códigos de respaldo te permiten iniciar sesión si pierdes el acceso a tu aplicación Authenticator, por ejemplo, si pierdes tu teléfono. Al iniciar sesión, selecciona «Usar un código de respaldo» e introduce uno de los siguientes códigos en lugar del código de la aplicación.",
    backupCodesWarning:
      "Esta es la única vez que podrás ver estos códigos. Guárdalos en un lugar seguro. Cada código funciona una sola vez.",
    copyCodes: "Copiar códigos",
    downloadCodes: "Descargar códigos",
    savedCodes: "He guardado los códigos",
    codesCopied: "Códigos de respaldo copiados",
    disabledSuccess: "Se ha desactivado 2FA",
    errors: {
      invalid_password: "La contraseña actual es incorrecta.",
      two_factor_already_enabled: "2FA ya está activado para esta cuenta.",
      two_factor_not_enabled: "2FA no está activado para esta cuenta.",
      invalid_challenge:
        "Esta solicitud de verificación no es válida o ya se ha utilizado.",
      challenge_expired: "La solicitud de verificación ha caducado. Vuelve a empezar.",
      challenge_locked:
        "Demasiados intentos incorrectos. Vuelve a iniciar la verificación.",
      invalid_code: "El código no es válido."
    }
  },

  permissions: {
    entraManaged: "Permisos administrados por Microsoft Entra ID",
    entraManagedHint:
      "Los permisos de este usuario se administran en Microsoft Entra ID. Realiza los cambios en Entra ID.",
    managedLocally: "Permisos administrados localmente",
    usersTooltip:
      "Aquí puedes agregar nuevos miembros al equipo y definir sus permisos.",
    tooltip:
      "Para cambiar la ubicación, haz clic en el menú desplegable de arriba y selecciona una ubicación diferente.",
    permissions: "Permisos",
    selectedCompany: "Empresa seleccionada",
    addNewUser: "Agregar un nuevo usuario",
    addUserToTeam: "Agregar usuario al equipo",
    addUser: "Agregar usuario",
    team: "Equipo",
    users: "Usuarios",
    youAreOwner: "Eres el propietario",
    youAreAdmin: "Tienes acceso completo",
    youAreManager: "Tienes acceso limitado",
    email: "Correo electrónico",
    emailAddress: "Dirección de correo electrónico",
    teamInvitation: "Estado de la invitación",
    accountType: "Tipo de cuenta",
    accountTypes: {
      [AccountType.OWNER]: "Propietario",
      [AccountType.ADMIN]: "Acceso completo",
      [AccountType.MANAGER]: "Acceso limitado"
    },
    managerTooltip:
      "Los usuarios con acceso limitado solo podrán acceder a las ubicaciones que selecciones y realizar las acciones que autorices. Estas ubicaciones y acciones se definirán en los siguientes pasos.",
    adminTooltip:
      "Los usuarios con acceso completo tienen acceso a todas las acciones y ubicaciones. Además, pueden añadir y eliminar ubicaciones, importar ubicaciones desde el Administrador de Perfiles de Negocio de Google, así como agregar, eliminar o restringir los permisos de otros usuarios.",
    fullAccessOnlyPermissionTooltip:
      "Este permiso solo está disponible para propietarios y usuarios con acceso completo.",
    invitationStatus: {
      active: "Acceso concedido",
      pending: "Esperando la aceptación de la invitación"
    },
    see: "Ver permisos",
    all: "Todas las ubicaciones",
    resend: "Reenviar",
    noUsers:
      "¿Necesitas ayuda para gestionar tus ubicaciones? ¡Autoriza a los miembros de tu equipo a administrar las ubicaciones!",
    invitationSent: "La invitación ha sido reenviada",
    accountDeleted: "El usuario fue eliminado del equipo.",
    permissionsGranted: "Permisos concedidos correctamente",
    forceLogout: "Cerrar la sesión de este usuario al guardar los cambios",
    forceLogoutHint:
      "Las sesiones activas se cerrarán en todos los dispositivos.",
    access: "Acceso",
    accessTo: "Acceso a",
    allFacilities: "todas las ubicaciones",
    allPermissions: "sin restricciones",
    limitedPermissions: "restringido",
    invitationEmailInfo:
      "* se envió una invitación para unirse a tu equipo a la dirección de correo electrónico que proporcionaste",
    facilitiesInGroupTitle: "Ubicaciones en grupo",
    facilitiesPermissionsTitle: "Seleccionar ubicaciones para otorgar acceso",
    editFacilitiesPermissionsTitle: "Editar acceso a la ubicación",
    previewFacilitiesPermissionsTitle: "Acceso a la ubicación",
    facilitySearchPlaceholder: "¿Qué ubicación estás buscando?",
    facilityGroupSearchPlaceholder: "¿Qué grupo estás buscando?",
    facilitiesList: "Lista de ubicaciones",
    facilitiesGroups: "Grupos de ubicaciones",
    selected: "Ubicaciones seleccionadas",
    selectedAll: "Todas las ubicaciones",
    selectedGroups: "Grupos seleccionados",
    userAccessAllTo: "El usuario tendrá acceso a todas las ubicaciones en:",
    accessAllFutureInfo:
      "* el usuario tendrá acceso a todas las ubicaciones, incluyendo aquellas que puedan añadirse a tu empresa más adelante",
    userPermissions: "Permisos de usuario",
    editUserPermissions: "Editar permisos de usuario",
    noMembers:
      "¿Necesitas ayuda para gestionar tus ubicaciones?\n ¡Autoriza a los miembros de tu equipo a gestionarlas!",
    noMembersFound:
      "No se encontraron miembros que coincidan con los criterios de búsqueda",
    atLeastOneFacilityRequired: "Por favor, selecciona al menos una ubicación",
    editAccountType: "Editar tipo de cuenta",
    backToPermissions: "Volver a los permisos",
    addCompanyAsOwner: "Agregar nueva empresa"
  },
  permissionsData: {
    group: {
      name: {
        basic: "Permisos básicos",
        photos: "Fotos enviadas",
        customerMedia: "Fotos de usuarios",
        gmbEdit: "Editando ubicaciones en Google Maps",
        externalChanges: "Gestionando cambios externos",
        gmbPosts: "Publicando en ubicaciones de Google Maps",
        gmbReviews: "Reseñas de ubicaciones en Google Maps",
        gmbAnalytics: "Analítica para ubicaciones en Google Maps",
        storeLocator: "Localizador de tiendas",
        questionsAndAnswers: "Preguntas y respuestas",
        reviewBooster: "Review Booster"
      }
    },
    name: {
      viewDashboard: "Ver el panel de control",
      viewFacilitiesData: "Ver ubicaciones",
      viewCompanyData: "Ver información de la empresa",
      manageCompanyData: "Editar información de la empresa",
      editFacilityName: "Editar nombre",
      editFacilityAddress: "Editar dirección",
      editFacilityStoreCode: "Editar código de tienda",
      editFacilityWebsite: "Editar sitio web",
      editFacilityPhoneNumber: "Editar número de teléfono",
      editFacilityServiceItems: "Editar servicios",
      editFacilityOpeningDate: "Editar fecha de apertura",
      editFacilityDescription: "Editar descripción",
      editFacilityAttributes: "Editar atributos",
      editFacilityPrimaryCategory: "Editar categoría principal",
      editFacilityAdditionalCategories: "Editar categorías adicionales",
      editFacilityLabels: "Editar etiquetas",
      editFacilityHours: "Editar el horario de apertura",
      editFacilityOpenStatus: "Editar estado de apertura / cierre",
      editReviewReplyTemplates: "Editar plantillas de respuesta",
      viewExternalChanges: "Ver cambios externos",
      approveAndRejectExternalChanges: "Aprobar y rechazar cambios externos",
      viewExternalChangesHistory: "Ver historial de cambios externos",
      protectFromExternalChanges:
        "Administrar la protección contra cambios externos",
      addAndDeletePhotos: "Agregar y eliminar fotos",
      viewPhotos: "Ver lista de fotos",
      viewAndReportCustomerMedia: "Ver y denunciar fotos de usuarios",
      assessCustomerMedia: "Evaluar fotos de usuarios",
      viewLocalPosts: "Ver lista de publicaciones",
      addAndDeleteLocalPosts: "Agregar y eliminar publicaciones",
      viewReviewsAnalytics: "Ver análisis de reseñas",
      viewReviews: "Ver reseñas",
      replyReviews: "Responder a las reseñas",
      viewGmbInsights:
        "Ver analíticas de los Perfiles de Empresa de Google",
      viewMapsRankings: "Ver posiciones de tus ubicaciones en Google Maps",
      viewMapsCompetitionRankings:
        "Ver las ubicaciones de tus competidores en Google Maps",
      manageCompetitionPlaces:
        "Administrar las ubicaciones de los competidores",
      manageKeywords:
        "Gestionar palabras clave que están siendo monitoreadas en búsquedas de Google Maps",
      manageGmbAccount:
        "Importar ubicaciones desde el Admnistrador de Perfiles de Negocio de Google",
      manageExternalGmbAddresses:
        "Importar ubicaciones desde fuera del Admnistrador de Perfiles de Negocio de Google",
      viewTeam: "Ver miembros del equipo",
      manageTeam: "Gestionar equipo",
      manageReviewsCategories: "Administrar categorías",
      assignReviewsCategories: "Administrar categorías de reseñas",
      manageStoreLocator: "Administrar el Localizador de Tiendas",
      configureAiReviewReply: "Configuración de respuestas a reseñas con IA",
      configureAiMediaAssessment: "Configuración de la evaluación de fotos con IA",
      viewQAndA: "Ver preguntas y respuestas",
      addAndEditQAndA: "Agregar y editar preguntas y respuestas",
      deleteQAndA: "Eliminar preguntas y respuestas",
      viewRbReviews: "Ver reseñas",
      viewRbReviewsAnalytics: "Ver analíticas de reseñas",
      viewRbForms: "Ver formularios"
    },
    tooltip: {
      viewFacilitiesData: "Ver lista de ubicaciones (sin permiso de edición)",
      viewCompanyData: `Mostrar información de la empresa (en la página "Mi Empresa")`,
      editFacilityHours:
        "Edita el horario regular de apertura, horas especiales (por ejemplo, horario de apertura en días festivos) y más horarios (por ejemplo, horario de entrega).",
      editFacilityOpenStatus: "Establecer la ubicación como abierta o cerrada",
      editFacilityOpeningDate: "Editar la fecha de apertura de la ubicación",
      editFacilityAttributes:
        "Editar atributos de ubicación. Los atributos comprenden información como métodos de pago, accesibilidad o Wi-Fi gratuito.",
      viewGmbInsights:
        "Consultar datos sobre las interacciones de los usuarios con los Perfiles de Empresa de Google (p. ej., visualizaciones y acciones), así como las palabras clave por las que dichos perfiles aparecieron en los resultados de búsqueda de Google Maps.",
      manageCompetitionPlaces:
        "Agregar y eliminar ubicaciones de competidores monitorizadas por LocalZen",
      manageKeywords:
        "Agregar y eliminar palabras clave que se están monitoreando en las búsquedas de Google Maps.",
      manageGmbAccount:
        "Gestionando cuentas de Google en LocalZen (añadiendo y eliminando cuentas) e importando ubicaciones de estas cuentas de GMB a LocalZen",
      manageExternalGmbAddresses:
        "importando o eliminando ubicaciones de LocalZen que no están asociadas con cuentas de Google. Estas ubicaciones no se pueden editar, pero es posible monitorizarlas.",
      viewTeam: "Ver miembros del equipo",
      manageTeam:
        "Invitar a nuevos miembros a unirse a tu equipo, eliminar miembros del equipo, conceder y restringir los permisos de cada miembro del equipo.",
      manageCompanyData: `Mostrar información de la empresa (en la página "Mi Empresa") y ver y gestionar el plan de suscripción de LocalZen (en la página "Configuración de la Cuenta").`
    }
  },
  demoService: {
    language: { description: "Esta cuenta está disponible solo en español." },
    modal: {
      text:
        "Esta es una versión de demostración de LocalZen. No puedes modificar los datos. Crea una cuenta gratuita para acceder a todas las funciones.",
      buttonText: "OK"
    }
  },
  demoGoogleReviewReport: {
    metaTitle: "Denunciar reseña",
    demoNotice:
      "Vista demo - esta denuncia no se enviará a Google.",
    title: "Denunciar reseña",
    legalProblem: "Notificar un problema legal",
    backToReviews: "Volver a las reseñas",
    photo: {
      metaTitle: "Denunciar contenido",
      title: "Denunciar contenido",
      backTo: "Volver a las fotos de usuarios"
    },
    reasons: {
      offTopic: {
        title: "Contenido fuera de contexto",
        description:
          "La reseña no se corresponde con una experiencia ofrecida por esta empresa"
      },
      spam: {
        title: "Spam",
        description:
          "La reseña es de un bot o una cuenta falsa, o bien contiene anuncios y promociones"
      },
      conflictOfInterest: {
        title: "Conflicto de intereses",
        description:
          "La reseña es de una entidad asociada a la empresa o una empresa de la competencia"
      },
      profanity: {
        title: "Palabras malsonantes",
        description:
          "La reseña contiene palabras malsonantes o lenguaje pornográfico o sexualmente explícito"
      },
      harmful: {
        title: "Dañina",
        description:
          "La reseña incluye contenido que fomenta, promueve o proporciona instrucciones para autolesionarse, usar de forma inadecuada artículos o sustancias peligrosas, o bien detalla o fomenta la violencia explícita contra personas o animales"
      },
      harassment: {
        title: "Hostigamiento o acoso",
        description: "La reseña ataca a alguien personalmente"
      },
      hateSpeech: {
        title: "Discriminación o incitación al odio",
        description:
          "La reseña incluye lenguaje ofensivo sobre una persona o un grupo debido a su identidad"
      },
      personalInformation: {
        title: "Información personal",
        description:
          "La reseña incluye información personal, como una dirección o un número de teléfono"
      },
      notHelpful: {
        title: "No es útil",
        description:
          "La reseña no ayuda a los usuarios a decidir si ir o no a este sitio"
      }
    },
    result: {
      title: "Esto era una demostración de denuncia",
      description:
        "El motivo seleccionado no se ha enviado a Google ni ha afectado a la reseña. En la versión completa de LocalZen se abriría el formulario de Google.",
      backToForm: "Volver al formulario"
    }
  },
  meta: {
    login: {
      title: "App LocalZen - inicio de sesión",
      description:
        "Inicia sesión en el panel de gestión de fichas del Administrador de Perfiles de Negocio de Google"
    },
    signUp: {
      title:
        "Gestiona tus servicios en el Administrador de Perfiles de Negocio de Google y destaca en Google Maps | LocalZen",
      description:
        "Analiza datos, supervisa cambios, gestiona la información y optimiza la visibilidad de las ubicaciones de tu negocio en Google Maps desde un panel intuitivo."
    }
  },
  menuLabels: {
    [Module.DASHBOARD]: "Panel de control",
    [Module.POSITION_MONITORING]: "Supervisión de posiciones en Google Maps",
    [Module.POSITION_SINGLE_LOCATION]:
      "Clasificación - ubicaciones individuales",
    [Module.POSITION_ALL_LOCATIONS]: "Clasificación - todas las ubicaciones",
    [Module.POSITION_COMPETITION_COMPARISON]: "Comparación con la competencia",
    [Module.USERS_BEHAVIOR]: "Acciones de los usuarios en Google Maps",
    [Module.ANALYTICS_COMPARISON]: "Compara las fichas de Google Maps.",
    [Module.LOCATIONS]: "Ubicaciones",
    [Module.LOCATIONS_MANAGE]: "Gestión de ubicaciones",
    [Module.LOCATIONS_QUALITY]: "Calidad de ubicaciones",
    [Module.EXTERNAL_CHANGES]: "Cambios externos",
    [Module.EXTERNAL_CHANGES_LIST]: "Lista de cambios",
    [Module.EXTERNAL_CHANGES_PROTECT]: "Protección contra cambios",
    [Module.EXTERNAL_CHANGES_HISTORY]: "Historial de cambios",
    [Module.PHOTOS]: "Fotos",
    [Module.PHOTOS_SENT]: "Fotos enviadas",
    [Module.PHOTOS_USERS]: "Fotos de usuarios",
    [Module.POSTS]: "Publicaciones",
    [Module.REVIEWS]: "Opiniones",
    [Module.REVIEWS_LIST]: "Lista de reseñas",
    [Module.REVIEWS_ANALYTICS]: "Análisis de calificaciones",
    [Module.REVIEWS_CATEGORIES_ANALYTICS]: "Análisis de categorías de reseñas",
    [Module.TEAM]: "Equipo",
    [Module.SETTINGS]: "Configuración",
    [Module.SETTINGS_COMPANY]: "Tu empresa",
    [Module.SETTINGS_KEYWORDS]: "Palabras clave monitoreadas",
    [Module.SETTINGS_COMPETITION_LOCATIONS]: "Ubicaciones de los competidores",
    [Module.SETTINGS_GMB_ACCOUNTS]: "Cuentas de Google",
    [Module.SETTINGS_FACEBOOK_ACCOUNTS]: "Cuentas de Facebook",
    [Module.SETTINGS_APPLE_ACCOUNTS]: "Cuentas de Apple",
    [Module.SETTINGS_MAP_CONFIG]: "Configuración del mapa",
    [Module.SETTINGS_APPS_CONFIG]: "Configuración de aplicaciones",
    [Module.STORE_LOCATOR]: "Localizador de Tiendas",
    [Module.REVIEW_BOOSTER]: "Reseñas de Review Booster",
    [Module.REVIEW_BOOSTER_FORM_LIST]: "Formularios",
    [Module.REVIEW_BOOSTER]: "Review Booster",
    [Module.REVIEW_BOOSTER_REVIEWS]: "Respuestas de formularios",
    [Module.QUESTIONS_AND_ANSWERS]: "Preguntas y respuestas",
    [Module.REVIEWS_COMPETITION_COMPARISON]: "Comparación con la competencia",
    [Module.APP_REVIEWS]: "Opiniones de aplicaciones móviles",
    [Module.QUESTIONS_AND_ANSWERS]: "Preguntas y respuestas",
    [Module.REVIEW_BOOSTER_STATISTICS]: "Estadísticas",
    [Module.SEARCH_KEYWORDS]: "Palabras clave buscadas"
  },
  weekDaysShort: {
    [WEEK_DAYS.Monday]: "Lun",
    [WEEK_DAYS.Tuesday]: "Mar",
    [WEEK_DAYS.Wednesday]: "Mié",
    [WEEK_DAYS.Thursday]: "Jue",
    [WEEK_DAYS.Friday]: "Vie",
    [WEEK_DAYS.Saturday]: "Sáb",
    [WEEK_DAYS.Sunday]: "Dom"
  },
  weekDays: {
    [WEEK_DAYS.Monday]: "Lunes",
    [WEEK_DAYS.Tuesday]: "Martes",
    [WEEK_DAYS.Wednesday]: "Miércoles",
    [WEEK_DAYS.Thursday]: "Jueves",
    [WEEK_DAYS.Friday]: "Viernes",
    [WEEK_DAYS.Saturday]: "Sábado",
    [WEEK_DAYS.Sunday]: "Domingo"
  },
  openStatusTypes: {
    [OPEN_STATUS.ANY]: "Cualquiera",
    [OPEN_STATUS.OPEN]: "Abrir",
    [OPEN_STATUS.CLOSED_PERMANENTLY]: "Cerrado permanentemente",
    [OPEN_STATUS.CLOSED_TEMPORARILY]: "Cerrado temporalmente"
  },
  facilityStatusTypes: {
    [FACILITY_STATUS.ANY]: "Cualquiera",
    [FACILITY_STATUS.IS_VERIFIED]: "Verificado",
    [FACILITY_STATUS.IS_UNVERIFIED]: "No verificado",
    [FACILITY_STATUS.IS_DUPLICATE]: "Duplicado",
    [FACILITY_STATUS.HAS_PENDING_VERIFICATION]: "Verificación pendiente",
    [FACILITY_STATUS.IS_INACTIVE]: "Sin conexión"
  },
  bingFacilityStatusTypes: {
    [MAPS_INTEGRATION_STATUS.ANY]: "Cualquiera",
    [MAPS_INTEGRATION_STATUS.NO_CONNECTION]: "Sin conexión",
    [MAPS_INTEGRATION_STATUS.CONNECTION_ACTIVE]: "La conexión está activa",
    [MAPS_INTEGRATION_STATUS.PUBLISHING_IN_PROGRESS]: "Publicación en progreso",
    [MAPS_INTEGRATION_STATUS.PUBLISHING_FAILED]:
      "Error al publicar la información"
  },
  externalChangesSources: {
    [EXTERNAL_CHANGES_SOURCE.GMB]:
      "Administrador de Perfiles de Negocio de Google",
    [EXTERNAL_CHANGES_SOURCE.EXTERNAL]: "Cambio externo"
  },
  externalChangesTypes: {
    [EXTERNAL_CHANGES_TYPE.ADDITION]: "Adición",
    [EXTERNAL_CHANGES_TYPE.REMOVAL]: "Eliminación",
    [EXTERNAL_CHANGES_TYPE.CHANGE]: "Cambiar"
  },
  externalChangesStatuses: {
    [EXTERNAL_CHANGES_STATUS.PENDING]: "Pendiente",
    [EXTERNAL_CHANGES_STATUS.ACCEPTED]: "Aceptado",
    [EXTERNAL_CHANGES_STATUS.REJECTED]: "Rechazado",
    [EXTERNAL_CHANGES_STATUS.DELETED_DUE_TO_GMB]: "Eliminado a través de GMB",
    [EXTERNAL_CHANGES_STATUS.DELETED_DUE_TO_CENTER]:
      "Eliminado a través de Center",
    [EXTERNAL_CHANGES_STATUS.SUPERSEDED]: "Sustituido por un cambio posterior"
  },
  facilitiesSortingOptions: {
    [FACILITIES_SORTING_OPTION.DEFAULT]: "Predeterminado",
    [FACILITIES_SORTING_OPTION.COUNTRY]: "País A-Z",
    [FACILITIES_SORTING_OPTION.CITY]: "Ciudad A-Z",
    [FACILITIES_SORTING_OPTION.STORE_CODE]: "Código de tienda"
  },
  topChartSeries: {
    [TOP_CHART_SERIE.TOP_3]: "Posiciones 1-3",
    [TOP_CHART_SERIE.TOP_10]: "Posiciones 4-10",
    [TOP_CHART_SERIE.TOP_20]: "Posiciones 11-20"
  },
  reviewsTagsSearchTypes: {
    [REVIEWS_TAGS_SEARCH_TYPE.INCLUDE_ALL_TAGS]:
      "con todas las categorías elegidas",
    [REVIEWS_TAGS_SEARCH_TYPE.INCLUDE_ANY_TAG]:
      "con cualquiera de las categorías elegidas",
    noCategories: "sin categorías"
  },
  gmbVerification: {
    name:
      "Cuando cambias el nombre, en algunos casos Google podría volver solicitar la verificación de tu ficha. Para minimizar tal posibilidad, recuerda: el nombre de tu ficha debe ser el mismo que el nombre de tu empresa. No debe contener el nombre de la ciudad, frases de marketing o palabras clave para SEO.",
    category: `Puedes añadir un máximo de 10 categorías (1 principal y 9 adicionales). Si alcanzas el límite, debes eliminar una de las existentes para añadir una nueva. Google podría solicitar la verificación de tu ubicación cuando agregues o edites categorías de negocios. Para evitar este tipo de solicitudes, asegúrate de que las categorías de tu negocio describan cómo es tu negocio y no el tipo de servicios que ofrece (por ejemplo, elige "Entrega de pizza" en lugar de "Restaurante para llevar").`,
    dialog: {
      title: "Advertencia",
      body:
        "Estás actualizando campos ({fields}). Al editar estos campos, en algunos casos, Google podría volver a solicitar la verificación de tu ficha.\n\nLee las instrucciones a continuación para asegurarte de que tus actualizaciones estén alineadas con las directrices de Google.",
      confirm: "Confirmar y continuar."
    },
    changes: {
      name: {
        label: "Nombre",
        description:
          "El nombre de la ficha debe ser el mismo que el nombre de tu empresa. No debe contener el nombre de la ciudad, frases de marketing o palabras clave para SEO."
      },
      address: {
        label: "Dirección",
        description:
          "Utiliza una dirección precisa y completa para describir la ubicación de tu propiedad. No incluyas en la dirección información que no esté relacionada con la ubicación física de tu propiedad (por ejemplo, URL, palabras clave para SEO)."
      },
      category: {
        label: "Categorías de negocios",
        description: `Las categorías de negocios deben describir tu empresa y no los servicios o productos que ofrece. Elige categorías que sean lo más específicas posible, pero que representen tu negocio principal (por ejemplo, elige "Reparto de pizzas" en lugar de "Restaurante para llevar").`
      }
    }
  },
  questionsAndAnswers: {
    expandAnswers: "Mostrar más respuestas ({0})",
    deleteItemTitle: "¿Estás seguro/a de querer eliminar este elemento?",
    collapseAnswers: "Ocultar respuestas",
    selectLocation: "Seleccionar ubicación",
    questionAndAnswer: "Preguntas y Respuestas",
    title: "Lista de Preguntas y Respuestas",
    sharingPubliclyOnGoogle: "Estás compartiendo públicamente en Google",
    askQuestion: "Hacer una pregunta",
    publishAnswer: "Publicar respuesta",
    owner: "Propietario",
    readOnlyOwnerActionsTooltip:
      "Función no disponible - debido a cambios en la API de Google, el módulo 'Preguntas y respuestas' estará disponible en modo de lectura desde el 3 de noviembre de 2025",
    readonlyGeneralMessage:
      "Debido a cambios en la API de Google, el módulo 'Preguntas y respuestas' estará disponible en modo de lectura desde el 3 de noviembre de 2025. No se aceptarán nuevas preguntas y respuestas.",
    tabs: {
      all: "Todos",
      withoutAnswer: "Sin responder",
      withAnswer: "Respondidas"
    },
    noDataDescription:
      "No hay preguntas ni respuestas que coincidan con los criterios seleccionados."
  },
  reviewBooster: {
    statistics: {
      totalCount: "Número de calificaciones en Google Maps",
      sessions: "Sesiones de usuarios",
      conversionReference: "Tasa de conversión a:",
      previousStep: "Paso anterior",
      firstStep: "Primer paso",
      all: "Todas",
      negative: "Solo negativas",
      positive: "Solo positivas",
      averageRatingTrend: "Calificación promedio en Google Maps",
      viewsActionsConversion: "Conversiones de Review Booster",
      globalRatingAverage: "Todas las calificaciones",
      newReviewsAverage: "Nuevas calificaciones",
      globalRatingCount: "Todas las calificaciones",
      newReviewsCount: "Nuevas calificaciones",
      launchedMoment: "Fecha de lanzamiento de Review Booster",
      averageRating: "Calificación promedio",
      basedOnReviews: "Basado en {0} reseñas",
      total: "Total",
      fromReviewBooster: "Calificaciones de Review Booster",
      fromGoogle: "Calificaciones de otros",
      sessionsCount: "Número de sesiones",
      sessionsWithAI: "Número de sesiones con asistente de IA",
      aiSessionsDescription:
        "Sesiones en las que el contenido de la reseña fue generado con la ayuda del asistente de IA. El valor porcentual se calcula como la relación entre las sesiones con asistente de IA y el número total de sesiones en un paso dado.",
      attributes: {
        form_impressions: "Impresiones",
        started_responding: "Inicio del formulario",
        main_question_answered: "Respuesta a la pregunta principal",
        completed_forms: "Formularios completados",
        visited_external_service: "Visita a Google Maps",
        published_reviews: "Publicación de reseñas en Google Maps"
      }
    },

    additionalQuestions: "Preguntas adicionales",
    title: "Configuración de Review Booster",
    changeBlocked: "El cambio ha sido bloqueado",
    placeholder: {
      contactText: "Damian te contará más sobre Review Booster:",
      positiveScreenList: {
        title: "Dos opciones de revisión - positiva",
        firstElement:
          "Se pide a los clientes que califiquen su experiencia de compra en una ubicación determinada.",
        secondElement:
          "Una vez que se publica la calificación, los clientes reciben una nota de agradecimiento y se les invita a dejar una reseña en Google Maps.",
        thirdElement:
          "Finalmente, los clientes reciben una nota de agradecimiento por la reseña publicada."
      },
      negativeScreenList: {
        title: "Dos opciones de revisión - negativa",
        firstElement:
          "Se solicita a los clientes que califiquen su experiencia de compra en una ubicación determinada.",
        secondElement:
          "Si la calificación es negativa, se les pide a los clientes que publiquen una reseña.",
        thirdElement:
          "Finalmente, los clientes reciben una nota de agradecimiento por la reseña publicada."
      },
      list: {
        title: "Dos opciones de revisión - positiva",
        firstElement: {
          title: "Comprende mejor a tus clientes",
          description:
            "Comprende claramente a tus clientes. Al recopilar y analizar las reseñas de los clientes, puedes entender mejor sus necesidades. Y luego, puedes utilizar este conocimiento para mejorar y enriquecer la experiencia de compra."
        },
        secondElement: {
          title: "Mejora tus calificaciones y reseñas en Google Maps",
          description:
            "Más del 93 % de los clientes admiten leer reseñas en línea antes de realizar una compra, por lo que las calificaciones más altas influyen sin lugar a dudas en la decisión final de compra, y además animan a más clientes a compartir su experiencia. Solo el 47 % de los clientes comparten sus experiencias positivas, frente al 97 % que deciden compartir las negativas."
        },
        thirdElement: {
          title: "Atrae más clientes a tu tienda y aumenta tus beneficios",
          description:
            "Las investigaciones muestran que el 89% de los clientes tienen más probabilidades de volver a comprar cuando la tienda responde a sus reseñas. ¡Los datos confirman que, en promedio, las reseñas pueden generar un aumento del 18% en las ventas!"
        }
      },
      subtitle: "¿Por qué Local Review Booster?"
    },
    formList: {
      title: "Formularios",
      formLink: "Enlaces de formularios",
      previewForm: "Vista previa del formulario",
      previewFormDialogTitle: "Vista previa del formulario en modo de prueba",
      previewFormDialogText:
        "Las visitas desde la vista previa no se cuentan en las estadísticas y las respuestas no crean reseñas en el panel. No compartas este enlace con los destinatarios.",
      previewFormOpen: "Abrir",
      description:
        "Aquí hay una lista de todos los formularios activos para recopilar comentarios y reseñas. Para cada uno, puedes abrir una vista previa del formulario en modo de prueba (las visitas desde la vista previa no se cuentan en las estadísticas y las respuestas no crean reseñas), descargar enlaces para ubicaciones individuales y consultar estadísticas (información sobre cómo los usuarios interactuaron con los formularios)."
    },
    reviews: {
      title: "Respuestas de formularios",
      selectForm: "Seleccionar formulario",
      googleMapsClicked: "El cliente se trasladó a Google Maps",
      googleMapsClickedAndReviewAdded:
        "El cliente fue a Google Maps y agregó una reseña.",
      aiGenerated:
        "El usuario utilizó el asistente de IA para que le ayudara a redactar una reseña.",
      noData:
        "No hay datos disponibles. Selecciona un rango de fechas diferente o modifica los filtros."
    }
  },
  storeLocator: {
    general: "General",
    faqTitle: "FAQ",
    faqSubtitle:
      "Vista previa de preguntas y respuestas frecuentes para este negocio",
    configSubtitle: "Información adicional para el Localizador de Tiendas",
    contactAndSectionsTitle: "Contacto y secciones adicionales",
    contactAndSectionsDescription: `Crea secciones adicionales en el Localizador de Tiendas como: una lista de enlaces, una lista de texto con viñetas, una sección de botones, una sección de imágenes, etc.`,
    faqItemTitle: "Preguntas frecuentes",
    backToStoreLocator: "Volver al Localizador de Tiendas",
    faqItemDescription:
      "Crea una lista de preguntas y respuestas para abordar las dudas más frecuentes de tus clientes.",
    faq: {
      noFaq: "No hay preguntas y respuestas disponibles",
      toAllLocations: "Para todas las ubicaciones",
      toLocation: "Para esta ubicación",
      faqCreatorTitle: "Creador de Preguntas Frecuentes",
      addFaqToFacilities: "Añadir Preguntas Frecuentes a tus fichas de empresa",
      question: "Pregunta",
      answer: "Respuesta",
      orderInfoText:
        "Las preguntas en el Localizador de Tiendas se mostrarán en el orden que se muestra a continuación.",
      allFacilities: "Todas las ubicaciones",
      editTitle: "Editar",
      changeOrder: "Cambiar orden",
      deleteAlertTitle: "¿Está seguro/a que deseas eliminar esta pregunta?"
    },
    placeholder: {
      title:
        "Optimiza tu sitio web y aumenta la conversión de visitas a tienda con el Localizador de Tiendas.",
      subtitle: "¿Por qué un Localizador de Tiendas?",
      implementedIn: "Consulta el Localizador de Tiendas de nuestro cliente:",
      contactText: "Damian te contará más sobre el Localizador de Tiendas",
      phone: "#ERROR!",
      consultantName: "Damian Kordyla",
      list: {
        firstElement: {
          title:
            "Mejora la visibilidad en línea de tus tiendas en las búsquedas de Google",
          description:
            "El Localizador de Tiendas está optimizado para los motores de búsqueda (SEO), lo que facilita que se encuentren tus tiendas en los resultados de búsqueda. El sitio web de cada tienda se verá con más frecuencia, lo que incrementará el tráfico en línea, así como el tráfico en la tienda."
        },
        secondElement: {
          title: "Aumentar el tráfico en la tienda",
          description:
            "Gracias a nuestra solución, la página web de cada tienda obtendrá contenido adicional, como imágenes, información sobre nuevas ofertas y ofertas especiales, las mejores reseñas de clientes y las calificaciones más altas, ayudando a convertir las tasas de conversión en visitas reales a la tienda."
        },
        thirdElement: {
          title: "Ahorrar tiempo",
          description:
            "El Localizador de Tiendas te permite gestionar la información tanto en tus Perfiles de Negocio de Google Maps como en tu propio sitio web simultáneamente, lo que te permite ahorrar tiempo."
        },
        fourthElement: {
          title: "Fácil de integrar y personalizable",
          description:
            "La solución puede adaptarse a la estética de tu negocio (esquema de colores, fuentes, logotipos) para convertirse en una parte integral de tu propio sitio web. Además, cualquier ajuste técnico es increíblemente fácil y rápido, y toma apenas una hora."
        }
      }
    },
    title: "Configuración del Localizador de Tiendas",
    saveChanges: "Guardar cambios",
    enableLocator: "¿Desea habilitar el Localizador de Tiendas?",
    contactUs: "¡Contáctanos!",
    basic: {
      title: "General",
      url: "URL",
      urlText: "Nombre de URL",
      name: "Nombre en el encabezado",
      addLogo: "Agregar un logotipo",
      primaryColor: "Color primario",
      selectPrimaryColor: "Selecciona el color primario",
      favoritesIcon: "Icono de favoritos"
    },
    facilities: {
      title: "Ubicaciones",
      show: "Mostrar",
      allFacilities: "Todas las ubicaciones ({0})",
      selectedGroups: "Grupos seleccionados",
      searchArea: "Área de búsqueda"
    },
    floatingButton: {
      text: "Texto",
      title: "Configuración adicional",
      subtitle: "Botón adicional visible en cada página:"
    },
    reviews: {
      title: "Reseñas",
      description:
        "Las reseñas del Localizador de Tiendas se muestran de las más recientes a las más antiguas. Adicionalmente, puedes filtrarlas para mostrar solo aquellas con calificaciones específicas.",
      selectRatings: "Selecciona las calificaciones para mostrar",
      onlyWithText: "Reseñas solo con texto"
    },
    posts: {
      title: "Publicaciones",
      description:
        "Las publicaciones mostradas en Localizador de Tiendas se pueden seleccionar en {0}.",
      descriptionLink: "lista de publicaciones"
    },
    photos: {
      title: "Fotos",
      description:
        "Las fotos mostradas en el Localizador de Tiendas pueden ser seleccionadas en {0}.",
      descriptionLink: "lista de fotos"
    },
    saveSuccess:
      "Cambios guardados. Los cambios aparecerán en el Localizador de Tiendas dentro de 10 minutos.",
    extraInfo: {
      pageTitle: "Localizador de Tiendas",
      title: "Contacto y secciones adicionales",
      offerLink: "Enlace de oferta de la tienda",
      contact: "Contacto",
      sections: "Secciones",
      sectionName: "Nombre de la sección (opcional)",
      addNewElement: "Agregar otro",
      removeElement: "Eliminar la última fila",
      moveSection: "Mover sección:",
      selectSectionType: "Seleccionar tipo de sección",
      noSections: "Aún no tienes secciones adicionales.",
      linkSection: {
        defaultTitle: "Sección de enlaces",
        titleAdd: "Añadir enlaces",
        titleEdit: "Editar enlaces",
        label: "Lista de enlaces",
        description:
          "Proporciona un nombre de enlace que se mostrará a los clientes en la página del Localizador de Tiendas y luego ingrese la URL a la que debemos redirigir.",
        columns: { text: "Nombre de URL", url: "Dirección URL" }
      }
    }
  },
  usersBehavior: {
    lastDaysLabel: "¿Por qué no puedo seleccionar las últimas dos semanas?",
    dateNotAllowed: "Fecha fuera de rango",
    lastDaysTooltip:
      "Google pone los datos completos a disposición con cierto retraso. Para garantizar conclusiones precisas basadas en datos completos, no es posible seleccionar las dos últimas semanas."
  },
  offer: {
    showCouponInShop: "Mostrar cupón en tienda",
    offerValid: "Oferta válida",
    useOnline: "Utilizar en línea",
    terms: "Términos de uso"
  },
  asyncCSVExport: {
    title: "Exportando archivo",
    content1:
      "El archivo se está generando. Puedes cerrar la ventana o esperar.",
    content2:
      "Una vez que se complete la generación del archivo, recibirás un correo electrónico con el mismo.",
    download: "Descargar archivo",
    generatingInProgress: "Generación de archivo en progreso",
    fileGeneratingError: "Error de generación de archivo",
    closeWindow: "Cerrar ventana"
  },
  copyLink: {
    copyLink: "Copiar enlace a la reseña",
    copied: "Copiado al portapapeles",
    noLink: "Sin enlace"
  },
  notes: {
    note: "Nota",
    addNote: "Agregar nota",
    deleteNote: "Eliminar",
    deleteNoteDescription: "¿Realmente deseas eliminar esta nota de reseña?",
    noteAdded: "Nota añadida",
    noteDeleted: "Nota eliminada",
    noteUpdated: "Nota actualizada"
  },
  sentiment: {
    reviewsProcessing: "Procesamiento de reseñas",
    reviewsProcessingNumber: "Número de reseñas en proceso",
    reviewsProcessingNumber2: "Algunas reseñas están siendo procesadas",
    reviewsProcessingNumber3:
      "La reseña se está procesando actualmente para asignar automáticamente categorías y sentimientos. Durante este proceso, no se pueden editar manualmente las categorías ni los sentimientos.",
    inProgressAlert:
      "El procesamiento de <strong>{0} categorías</strong> está en curso.",
    unknown: "Desconocido",
    markAsPositive: "Marcar como positivo",
    markAsNegative: "Marcar como negativo",
    markAsNeutral: "Marcar como neutral",
    clearSelection: "Borrar selección",
    sentimentName: "Sentimiento",
    positive: "Positivo",
    negative: "Negativo",
    neutral: "Neutral",
    unassigned: "No asignado",
    mixed: "Mixto",
    heatmap: {
      legendTitle: "Sentimiento en mayoría",
      mostly: "Mayoritariamente",
      tooltipClickInfo: "Haz clic en el campo para ver más"
    }
  },
  mapIntegrations: {
    noFacilities: {
      button: "Agregar cuenta",
      title: "Enviar información de ubicación a múltiples destinos",
      desc:
        "Aquí puedes habilitar fácilmente la integración con varios servicios de mapas. Esto enviará automáticamente la información sobre tus ubicaciones. Para hacerlo posible, importa tus fichas de negocio conectando una cuenta de Google."
    },
    catalog: "Catálogo",
    integrationStatus: "Estado de integración",
    additionalInfo: "Información adicional",
    actions: "Acciones",
    enable: "Habilitar",
    disable: "Desactivar",
    mapConfigurationTitle: "Configuración del mapa",
    infoText: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit.`,
    bing: {
      dialog: {
        enable: {
          title: "¿Habilitar la integración con Bing Maps?",
          description: `Después de habilitar la integración, la información seleccionada sobre todas tus ubicaciones actuales y futuras se enviará automáticamente a Bing Maps. Las ubicaciones que aún no estén registradas en Bing Maps se crearán allí (esto puede demorar hasta 10 días debido a los tiempos de procesamiento de Bing Maps). ¿Deseas continuar?`
        },
        disable: {
          title: "¿Desactivar la integración con Bing Maps?",
          description: `Desde el momento en que se desactive la integración, no se enviarán nuevos cambios en las ubicaciones a Bing Maps. ¿Deseas continuar?`
        }
      }
    },
    tomtom: {
      dialog: {
        enable: {
          title: "¿Activar la integración con TomTom?",
          body:
            "Activa la integración con TomTom para que tus locales lleguen al ecosistema global de mapas y navegación.",
          howItWorks: "¿Cómo funciona?",
          automaticSending:
            "Envío automático: Una vez a la semana, LocalZen transfiere a la base de datos de TomTom la información de tus locales (nombre, dirección, horarios, datos de contacto, atributos y más).",
          wideReach:
            "Gran alcance: TomTom utiliza estos datos en sus productos y los comparte con fabricantes de automóviles (p. ej., BMW, Volkswagen) y desarrolladores de mapas.",
          dataUsage:
            "Uso de los datos: Los fabricantes de coches descargan la información de la base de datos de TomTom a su propio ritmo. Nosotros nos aseguramos de que los datos más recientes estén siempre allí esperándoles.",
          outro:
            "Puedes activar la integración ahora o volver más tarde. También puedes desactivarla en cualquier momento.",
          learnMore:
            '¿Quieres saber más sobre a dónde van tus datos? <a href="{link}" target="_blank" rel="noopener noreferrer">Lee más aquí.</a>',
          rodo:
            'Entiendo que al activar la integración con TomTom Global Content B.V., con domicilio social en Ámsterdam ("TomTom"), mis datos, los datos de la empresa o los datos de mi personal (p. ej., números de teléfono de contacto de las personas que trabajan en cada ubicación) serán transferidos a TomTom con el fin de su distribución y visualización en los productos de TomTom. Declaro que cuento con los consentimientos necesarios de las personas cuyos datos personales serán transferidos y que estas han recibido la información relativa al tratamiento de sus datos personales. Las normas detalladas sobre el tratamiento de datos personales se encuentran en la <a href="{link}" target="_blank" rel="noopener noreferrer">Cláusula Informativa</a>.'
        },
        disable: {
          title: "¿Desactivar la integración con TomTom?",
          body:
            "Una vez desactivada la integración, no se enviarán más cambios de ubicación a TomTom. ¿Deseas continuar?"
        }
      }
    }
  },
  facebook: {
    removePageAndFacilities: "Eliminar página e instalaciones",
    noConnectedFacebookAccount:
      "No hay ninguna cuenta de Facebook conectada. Por favor, inicia sesión con Facebook para añadir una.",
    addPage: "Agregar página",
    facebookAccounts: "Cuentas de Facebook",
    loginWithFacebook: "Inicia sesión con Facebook",
    info1:
      "Para enviar información de ubicación desde LocalZen a las fichas de negocio de Facebook, necesitas agregar una cuenta de Facebook y seleccionar las páginas que contienen esas fichas.",
    info2:
      "Se requiere que las páginas de Facebook tengan la estructura adecuada: todas las fichas de negocio deben añadirse como Páginas de Ubicación dentro de la página.",
    accountRemoveAlert: {
      title: "Confirmar la desconexión de la cuenta",
      description:
        "Después de desconectarse, LocalZen perderá acceso a las fichas de negocio de esta cuenta.<br /> La información de LocalZen dejará de enviarse a estas fichas."
    },
    pageRemoveAlert: {
      title: "Confirma la desconexión de la página y sus fichas de negocio",
      description:
        "Tras desconectarte, LocalZen perderá acceso a las fichas de negocio de esta página. La información de LocalZen dejará de enviarse a estas fichas."
    },
    enableIntegrationAlert: {
      title: "Se han añadido páginas",
      description: `Ha comenzado la integración con Facebook para las fichas de negocio de las páginas seleccionadas. Para completar este proceso necesitaremos información adicional. Nos pondremos en contacto contigo dentro de X días. Puedes monitorear el estado del proceso en la pantalla de <b>"Configuración del mapa"</b>.`
    },
    selectPageDialog: {
      title: "Seleccionar páginas con fichas de negocio",
      description: `Elige las páginas con fichas de negocio que deseas conectar con ubicaciones en LocalZen. Después de seleccionarlas, empezaremos el proceso de emparejar las fichas de negocio de Facebook con ubicaciones en LocalZen. <br /> <br /> Las fichas de negocio emparejadas se actualizarán con información de LocalZen.`,
      infobox: `Este proceso puede requerir tu participación. Si es necesario, nuestro departamento de soporte se pondrá en contacto contigo. Puedes monitorear el estado del proceso en la pantalla de 'Configuración de Mapa'.`,
      confirmAndStartIntegration: "Confirma y comienza la integración."
    },
    noPagesToAdd: "No hay páginas para añadir",
    goToMapConfiguration: "Ir a la configuración del mapa",
    goBackToMapConfiguration: "Volver a la configuración del mapa",
    completeConfiguration: "Configuración completa",
    configurationInProgress: "Configuración en progreso",
    configureAlert: {
      title: "Configurar cuenta de Facebook",
      description:
        "Para habilitar la integración, primero debes configurar tu cuenta de Facebook.",
      confirmLabel: "Configurar cuenta"
    }
  },
  mobile: {
    common: {
      appAdded: "Aplicación agregada correctamente",
      addAccount: "Agregar cuenta",
      addApp: "Agregar aplicación",
      appConfiguration: "Cuentas de aplicaciones móviles",
      cancel: "Cancelar",
      noApps: "Sin aplicaciones",
      selectApp: "Seleccionar aplicación",
      appDeleteAlert: {
        btnText: "Eliminar",
        title: "Confirmar eliminación de la aplicación",
        description: "¿Está seguro/a de que deseas eliminar la aplicación?"
      }
    },
    appStore: {
      listings: {
        info:
          "Para habilitar la integración, primero debes configurar tu cuenta de App Store.",
        subtitle: {
          mainSection: "Cuentas de App Store añadidas"
        },
        addAccountForm: {
          accountName: "Nombre de la cuenta",
          file: "Individuál API key (p8)",
          filePlaceholder: "Seleccionar archivo"
        },
        addAppForm: {
          appId: "ID de la aplicación"
        }
      },
      name: "App Store"
    },
    googlePlay: {
      listings: {
        subtitle: { mainSection: "Cuentas de Google Play añadidas" },
        accountRemoveAlert: {
          title: "Confirmar desconexión de cuenta",
          description:
            "Después de desconectarse, LocalZen perderá acceso a las aplicaciones relacionadas con esta cuenta.<br /> La información de LocalZen dejará de ser enviada a estas aplicaciones."
        },
        appAddForm: {
          appName: "Nombre de la aplicación",
          googlePlayUrl: "URL de Google Play"
        },
        info:
          "Para habilitar la integración, primero debes configurar tu cuenta de Google Play."
      },
      name: "Google Play"
    }
  },
  payments: {
    activeSubscriptionDescription:
      "Tu suscripción está activa. Administra tu plan o liquida cualquier factura pendiente a continuación.",
    freePlanDescription:
      "Tu prueba gratuita incluye acceso completo a todas las funciones del <b>Plan Estándar</b>. Selecciona un plan para continuar después del período de prueba.",
    selectPlanButton: "Seleccionar plan",
    subscriptionExpiryDate: "Fecha de vencimiento de la suscripción: {date}",
    paymentSummary: "Resumen de pago",
    vatNumberRetrievalTooltip:
      "La recuperación de datos solo está disponible para números de NIP polacos válidos.",
    paymentMethod: "Opciones de Pago",
    limit: "Límite",
    aboveLimit: "por encima del límite",
    currently: "Actualmente",
    overLimit: "Límites excedidos",
    usageLimits: "Límites superados",
    viewUsageLimits: "Ver límites",
    limitDescriptionNoDeletion: `Este plan, en comparación con tu plan actual, tiene restricciones adicionales (límites) que actualmente se han superado. Para cambiar a este plan, primero elimina el exceso de elementos que está provocando que se superen los límites en el panel de AI Center.`,
    limitDescription: `Este plan, en comparación con tu plan actual, tiene restricciones adicionales (límites) que actualmente se han superado. Para cambiar a este plan, primero elimina el exceso de elementos que están provocando que se superen los límites. Haz clic en el límite excedido para abrir un menú desplegable donde puedes eliminar los objetos que sobran.`,
    limits: {
      max_facilities: "Número de ubicaciones",
      max_maps_keywords: "Número de palabras clave monitoreadas",
      max_ai_categorization_categories: "Número de categorías de reseñas",
      max_company_users: "Número de usuarios",
      max_listings_competitors: "Número de ubicaciones de competidores",
      max_websites: "Máximo de sitios web",
      max_organic_keywords: "Máximo de palabras clave orgánicas",
      max_search_locations: "Máxima de Ubicaciones de Búsqueda",
      max_website_competitors: "Máximo de Sitios Web de Competidores"
    },
    changePlanHelp:
      "Si deseas cambiar a un plan diferente, comunícate con nosotros enviando un correo electrónico a support@localzen.com o llamando al 537 340 555.",
    freeTrialPeriod: "prueba gratuita",
    daysLeft: "Termina en {0} días",
    freeTrialTooltip:
      "Ve a la configuración de suscripciones para seleccionar un plan",
    freeTrialEndsIn: "La prueba gratuita termina el: {0}",
    freeTrialEnded: "La prueba gratuita ha finalizado",
    freeTrial: "Prueba gratuita",
    title: "Suscripción",
    orderDetails: "Plan seleccionado",
    locationsQuantity: "Número de ubicaciones",
    payByCard: "Pagar con tarjeta",
    payByQuickPayment: "Pagos Rápidos",
    totalPrice: "Precio total",
    perLocation: "{0} neto por ubicación mensualmente",
    monthly: "Mensualmente",
    annually: "Anualmente",
    payMonthly: "Pago mensual",
    payAnnually: "Pago anual",
    payNow: "Pagar ahora",
    paymentDetails: "Complete tus datos y confirma el pago",
    selectedPlan: "Planes",
    completeYourPayment: "Completa tu pago",
    processingPayment: "Procesando pago",
    status: {
      success: "¡Todo está listo!",
      pending: "Tu pago está siendo procesado.",
      failed: "Pago fallido"
    },
    startUsingCenterAi: "Ir a la aplicación",
    goBackToPayment: "Regresar al pago",
    error: "Se produjo un error al procesar el pago.",
    accept: "Acepto el",
    paymentsRegulations: "términos de uso",
    promoCode: "Código de promoción",
    promoCodeText:
      "El código de promoción se puede agregar en el siguiente paso.",
    invoiceData: "Añade tu información de facturación",
    invoiceDataDescription:
      "Hazlo fácil: simplemente ingresa tu NIF y completaremos automáticamente los datos de tu empresa.",
    getData: "Obtener datos",
    net: "neto",
    vat: "NIF",
    pln: "PLN",
    planDialog: {
      title: "¡Ya casi está!",
      description: `Hemos abierto la página de gestión de suscripciones en una nueva pestaña para ti. Después de completar tus cambios allí, vuelve aquí y haz clic en el botón de actualizar para ver tu suscripción actualizada.`
    },
    paymentErrorDescription: `No pudimos procesar tu pago. Esto podría deberse a una de las siguientes razones:<br /><br /> <ul><li>Fondos insuficientes en tu cuenta.</li><li>Detalles incorrectos de la tarjeta (por ejemplo, número, fecha de vencimiento, código CVV).</li><li>Problemas de autorización con tu banco.</li></ul><br />Por favor, intenta de nuevo o contacta a tu banco para resolver el problema.`,
    paymentSuccessDescription: `Tu pago se procesó con éxito. Hemos enviado tu factura a tu correo electrónico. En el futuro, recibirás allí las facturas por cualquier pago de forma automática. Puedes encontrar el historial completo de facturas en la sección "Cuenta de Usuario" de tu panel de control de LocalZen.`
  },
  competitionComparison: {
    competitionLimitReached:
      "Se ha seleccionado el número máximo de competidores. Guarda o cambia tu selección.",
    competitionLimitReachedInline:
      "Se ha seleccionado el número máximo de competidores.",
    alreadyAdded: "Empresa ya añadida",
    title: "Ranking de competidores",
    pageTitle: "Reseñas - Comparación con la competencia",
    description:
      "Para ver cómo te comparas con otros, selecciona las empresas con las que quieres compararte. Cuando agregues competencia, te mostraremos un análisis detallado.",
    addCompetition: "Agregar Competencia",
    addReport: "Agregar Informe",
    createReport: "Crear informe",
    emptyPage: "Página vacía",
    addReportSubtitle: "Selecciona un país para ver la comparación de mercado",
    reportNameLabel: "Nombre del informe",
    addCompetitionSubtitle:
      "Las opiniones de los competidores se monitorizarán automáticamente",
    noCategoriesTitle: "No hay categorías para comparar",
    noCategoriesDescription:
      "Para comparar con la competencia necesitas categorías con auto-categorización activada. Añade o activa estas categorías en la configuración de categorías.",
    manageCategories: "Ir a categorías",
    selectCompetition: "Seleccionar Competencia para Comparar",
    manageCompetition: "Gestionar Competencia",
    myCompetition: "Mi Competencia",
    manageCompetitionInfo:
      "Agrega tu competencia para seguir las empresas más importantes de tu industria. Agrega tus primeros competidores y te mostraremos sus datos cuando estén disponibles.",
    searchCompetition: "Buscar Competencia",
    searchCompetitionShort: "Buscar...",
    selectCompanies:
      "Selecciona las empresas competidoras (máximo {0}) con las que deseas compararte.",
    selectCompanies2:
      "Selecciona las empresas competidoras con las que deseas compararte.",
    noCompetitionFound:
      "¿No encuentras la empresa que buscas? Puedes enviarla para que la agreguemos.",
    noCompetitionFound2:
      "¿No has encontrado la empresa con la que quieres compararte? Envíanos su nombre y trataremos de agregarla al sistema.",
    submitCompetitor: "Enviar Competencia Faltante",
    sendRequest: "Enviar Solicitud",
    competitorCompanyLabel: "Ingresa el nombre de la empresa faltante",
    removeCompetitorTitle: "Eliminar competidor",
    removeCompetitorConfirm:
      "¿Estás seguro de que quieres eliminar {name} de la comparación?",
    removeCompetitorConfirmDescription:
      "Este competidor se eliminará de la comparación y LocalZen dejará de monitorizar sus opiniones. Para ocultarlo en su lugar, usa la casilla de verificación.",
    selectExistingOrAdd: "Selecciona existente o envía faltante",
    dataCollection: "Recopilación de datos",
    competitorNetworks: "Redes de Competencia",
    comparisonArea: "Categoría de comparación",
    marketPosition: "Tu posición en el mercado",
    reportGeneratedOn: "Informe generado el",
    comparisonAreasTitle: "Comparación de categorías de opiniones",
    showMore: "Mostrar más ({0})",
    showLess: "Mostrar menos",
    ranking: "Ranking",
    barChart: {
      title:
        "Comparación del número y sentimiento de opiniones de la competencia en la categoría: {category}",
      titlePrefix:
        "Comparación del número y sentimiento de opiniones de la competencia en la categoría:",
      rankPosition: "Posición en el ranking",
      nssDescription: "Puntuación en esta categoría (Net Sentiment Score)",
      reviewsInArea: "Opiniones en esta categoría",
      reviewsCount: "Número de opiniones",
      areaDescription:
        "Mostramos empresas que tienen opiniones en la categoría seleccionada",
      withText: "con texto",
      noKeywordsBarInfo:
        "No se encontraron reseñas relacionadas con esta categoría en los datos analizados para esta empresa."
    },
    radarChart: {
      cardTitle: "Resumen de comparación de categorías",
      title: "Comparación de todas las categorías por NSS (de -100 a +100)",
      infoTooltip:
        "El Net Sentiment Score (NSS) refleja el equilibrio entre reseñas positivas y negativas en cada categoría. Los valores van de -100 a +100.",
      seeDetails: "Ver detalles",
      compareAreas: "Comparar todas las categorías de opinión:",
      selectedAreas: "Categorías seleccionadas:",
      change: "Cambiar",
      vs: "vs",
      notEnoughCategoriesRequired:
        "El gráfico radar requiere al menos 3 categorías.",
      notEnoughCompanies:
        "El gráfico radar requiere al menos 2 empresas para comparar."
    },
    stats: {
      sectionTitle: "Comparación de estadísticas principales de fichas:",
      avgRating: "Calificación promedio (últimas 30 opiniones por ficha)",
      avgRatingShort: "Calificación promedio",
      seeDetails: "Ver detalles",
      companyName: "Nombre (número de fichas)",
      companyNameShort: "Nombre",
      avgRatingAll: "Calificación promedio de todas las fichas",
      ratingsCount: "Número de opiniones",
      responseRate:
        "% de respuestas a opiniones (últimas 30 opiniones por ficha)",
      responseRateShort: "% de respuestas a opiniones",
      competitor: "Competencia",
      responsesCount: "Número de respuestas",
      responsesPercent: "% de respuestas"
    },
    sentimentInCategory: `Sentimiento en la categoría <span class='chart__title-category'>"{0}"</span> en el período seleccionado`,

    you: "Tú",
    freeToolBanner: {
      textBefore:
        "La versión gratuita de la auditoría contiene análisis de hasta",
      limit: "30 reseñas por ficha",
      textAfter: "Desbloquea todas las funciones",
      cta: "Crea una cuenta gratuita"
    },
    upsellCard: {
      title: "¡Descubre más datos y obtén ventaja sobre la competencia!",
      description:
        "LocalZen es una herramienta avanzada para marketing, CX y SEO.",
      feature1: "Gestión agregada de fichas de empresa en mapas",
      feature2: "Análisis comparativo con la competencia, incluido SEO",
      feature3: "Respuestas rápidas a reseñas - con soporte de IA",
      cta: "Reservar demo",
      noCreditCard: "sin tarjeta de crédito"
    },
    reportGoneDialog: {
      title: "Tu informe ha expirado.",
      subtitle: "Puedes generar uno nuevo en",
      heading: "¡Descubre más datos y obtén ventaja sobre la competencia!",
      description:
        "LocalZen es una herramienta avanzada para marketing, CX y SEO.",
      feature1: "Gestión agregada de fichas de empresa en mapas",
      feature2: "Análisis comparativo con la competencia, incluido SEO",
      feature3: "Respuestas rápidas a reseñas - con soporte de IA",
      ctaBookDemo: "Reservar demo",
      ctaTryFree: "Pruébalo gratis"
    },
    dataCollectionTooltip: {
      title: "Recopilación de datos",
      description:
        "¡Muy pronto! Estamos recopilando datos para esta empresa y la agregaremos a nuestras analíticas cuando estén listos."
    },
    dateUnavailableTooltip:
      "Los datos de este período aún no están disponibles para todas las empresas de la competencia",
    dateNoDataTooltip: "No hay datos disponibles para este período",
    tagPickerDialog: {
      editSelectedAreas: "Editar categorías seleccionadas",
      uncheckAnotherToAdd: "Desmarca otra categoría para añadir una nueva",
      searchPlaceholder: "Buscar...",
      selected: "Seleccionadas",
      availableCount: "Disponibles ({count})",
      noResultsFor: 'Sin resultados para "{query}"',
      limitReached: "Límite {current}/{max} alcanzado",
      minimumRequiredHint:
        "El gráfico radar requiere al menos 3 categorías seleccionadas.",
      notEnoughCategoriesAvailable:
        "El gráfico radar requiere al menos 3 categorías. No hay suficientes categorías disponibles."
    },
    emailConfirmation: {
      verifying: "Verificando tu correo",
      pleaseWait:
        "Por favor espera mientras verificamos tu dirección de correo electrónico...",
      successTitle: "¡Correo verificado!",
      successDescription:
        "Tu correo electrónico ha sido verificado exitosamente.",
      errorTitle: "Verificación fallida",
      errorDescription:
        "No pudimos verificar tu correo. El enlace puede haber expirado o no es válido. Por favor intenta de nuevo o solicita un nuevo enlace de verificación."
    }
  },
  apple: {
    apple: "Apple",
    title: "Cuentas de Apple",
    loginWithApple: "Iniciar sesión con Apple",
    emptyState: {
      title: "Conecta tu cuenta de Apple Business Connect",
      description:
        "Conecta tu cuenta para que los datos de tus ubicaciones lleguen automáticamente a Apple Maps, Siri y otras aplicaciones de Apple.",
      noAccountTitle: "¿Aún no tienes una cuenta de Apple Business Connect?",
      noAccountDescription:
        'Créala y completa la verificación de la empresa por parte de Apple (puede tardar algunos días hábiles). Encontrarás instrucciones paso a paso en <a href="{link}" target="_blank" rel="noopener noreferrer">nuestro Help Center</a>.',
      hasAccountTitle: "¿Ya tienes una cuenta verificada?",
      hasAccountDescription: "Haz clic a continuación para conectarla."
    },
    header: { title: "Cuentas conectadas" },
    info1:
      "Para enviar información de ubicación desde LocalZen a las fichas de negocio de Apple Maps (Apple Business Connect), necesitas añadir una cuenta de Apple.",
    configureAlert: {
      title: "Habilitar la integración con Apple Maps (Apple Business Connect)",
      body:
        "Conéctate con Apple Maps (Apple Business Connect) para llegar a millones de usuarios de dispositivos Apple.",
      whyItMatters: "¿Por qué vale la pena?",
      appleEcosystem:
        "Apple Business Connect es más que solo Apple Maps – tus datos también llegan a Siri, Fotos, Wallet y otras aplicaciones de Apple.",
      valuableCustomers:
        "Los usuarios de Apple son clientes que gastan más. Dales fácil acceso a la información sobre tu negocio.",
      alwaysUpToDate:
        "Todos los cambios en tus ubicaciones se envían automáticamente a Apple – sin actualizaciones manuales.",
      howItWorks: "¿Cómo funciona?",
      connectAccount:
        "Conectas tu cuenta de Apple Maps (Apple Business Connect).",
      sendData:
        "LocalZen envía a Apple todos los datos de tus ubicaciones añadidas en LocalZen.",
      autoUpdates:
        "Cada actualización de datos se transmite automáticamente a Apple.",
      outro:
        "Para comenzar, primero necesitas conectar tu cuenta. La configuración solo toma un momento.",
      confirmLabel: "Configurar Cuenta"
    },
    enableDialog: {
      confirmBrandSettings:
        "Confirmar configuraciones para marcas (Brands) en Apple Maps",
      title: "¿Habilitar la integración con Apple Maps?",
      subtitle:
        "La cuenta de Apple se ha agregado correctamente. ¿Quieres habilitar la integración con Apple Maps ahora?",
      description: `Después de habilitar la integración:
        <ul>
          <li>Las tarjetas de negocio existentes en Apple Maps se actualizarán con la información de LocalZen.</li>
          <li>Las tarjetas de negocio en Apple Maps también se actualizarán automáticamente cada vez que realices cambios en LocalZen.</li>
          <li>
            <b>Datos actualizados: nombre de la tarjeta de negocio, categorías, dirección, coordenadas, números de teléfono, horario de apertura estándar, horario de apertura especial, descripción, código de tienda, dirección del sitio web.</b>
          </li>
          <li>
            Si faltan algunas tarjetas de negocio en Apple Maps, se crearán según la información de LocalZen.
          </li>
        </ul>
      `,
      descriptionEnding: `
        También puedes habilitar la integración más tarde. También puedes deshabilitarla en cualquier momento.
      `,
      description2: `
        La cuenta de Apple se ha agregado correctamente. ¿Quieres habilitar la integración con Apple Maps ahora? Te haremos algunas preguntas adicionales antes de habilitar la integración.
      `,
      rodo:
        'Entiendo que al activar la integración con Apple Inc. ("Apple"), mis datos, los datos de la empresa o los datos de mi personal (p. ej., números de teléfono de contacto de las personas que trabajan en cada ubicación) serán transferidos a Apple con el fin de su distribución y visualización en los productos de Apple. Declaro que cuento con los consentimientos necesarios de las personas cuyos datos personales serán transferidos y que estas han recibido la información relativa al tratamiento de sus datos personales. Las normas detalladas sobre el tratamiento de datos personales se encuentran en la <a href="{link}" target="_blank" rel="noopener noreferrer">Cláusula Informativa</a>.'
    },
    brandDialog: {
      title: "Confirmar configuraciones para marcas (Brands) en Apple Maps",
      subtitle:
        "Apple requiere que las tarjetas de negocios creadas en Apple Maps estén asociadas con una marca (Brand). Las marcas se definen para cada país en el que se añaden las tarjetas de negocios, y cada país puede tener varias marcas.",
      brandFieldDescription:
        "Al añadir tarjetas de negocios en LocalZen, se creará automáticamente una marca (Brand) para cada país con el mismo nombre (puedes cambiar el nombre):",
      confirmInfo:
        "¿Confirma estas configuraciones de marcas? Si desea utilizar marcas de manera diferente en Apple Maps, póngase en contacto con nuestro equipo de soporte (support@localzen.com o a través de chat).",
      brandListTitle:
        "Aquí está la lista de marcas actualmente en su cuenta de Apple Business Connect",
      brandsListDescription:
        "Las tarjetas de negocios creadas en estos países se asociarán automáticamente con estas marcas.",
      multiBrandInfo:
        "En algunos países, actualmente tiene más de una marca. En este caso, para configurar la integración con Apple Maps, póngase en contacto con nuestro equipo de soporte (support@localzen.com o a través de chat).",
      brandName: "Nombre de la marca",
      brands: "Marcas"
    },
    disableDialog: {
      title: "¿Deshabilitar la integración con Apple Maps?",
      description: `Desde el momento en que la integración se desactiva, no se enviarán nuevos cambios de las ubicaciones a Apple Maps. ¿Quieres continuar?`
    },
    accountRemoveAlert: {
      title: "Confirmar la desconexión de la cuenta",
      description:
        "Después de desconectarse, LocalZen perderá acceso a las tarjetas de visita de esta cuenta.<br /> La información de LocalZen dejará de enviarse a estas tarjetas de visita."
    }
  }
};
